(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.GTM = factory());
})(this, (function () { 'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    /** @deprecated */
    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    var js_cookie = {exports: {}};

    /*!
     * JavaScript Cookie v2.2.1
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */

    (function (module, exports) {
    (function (factory) {
    	var registeredInModuleLoader;
    	{
    		module.exports = factory();
    		registeredInModuleLoader = true;
    	}
    	if (!registeredInModuleLoader) {
    		var OldCookies = window.Cookies;
    		var api = window.Cookies = factory();
    		api.noConflict = function () {
    			window.Cookies = OldCookies;
    			return api;
    		};
    	}
    }(function () {
    	function extend () {
    		var i = 0;
    		var result = {};
    		for (; i < arguments.length; i++) {
    			var attributes = arguments[ i ];
    			for (var key in attributes) {
    				result[key] = attributes[key];
    			}
    		}
    		return result;
    	}

    	function decode (s) {
    		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    	}

    	function init (converter) {
    		function api() {}

    		function set (key, value, attributes) {
    			if (typeof document === 'undefined') {
    				return;
    			}

    			attributes = extend({
    				path: '/'
    			}, api.defaults, attributes);

    			if (typeof attributes.expires === 'number') {
    				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
    			}

    			// We're using "expires" because "max-age" is not supported by IE
    			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

    			try {
    				var result = JSON.stringify(value);
    				if (/^[\{\[]/.test(result)) {
    					value = result;
    				}
    			} catch (e) {}

    			value = converter.write ?
    				converter.write(value, key) :
    				encodeURIComponent(String(value))
    					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

    			key = encodeURIComponent(String(key))
    				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
    				.replace(/[\(\)]/g, escape);

    			var stringifiedAttributes = '';
    			for (var attributeName in attributes) {
    				if (!attributes[attributeName]) {
    					continue;
    				}
    				stringifiedAttributes += '; ' + attributeName;
    				if (attributes[attributeName] === true) {
    					continue;
    				}

    				// Considers RFC 6265 section 5.2:
    				// ...
    				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
    				//     character:
    				// Consume the characters of the unparsed-attributes up to,
    				// not including, the first %x3B (";") character.
    				// ...
    				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    			}

    			return (document.cookie = key + '=' + value + stringifiedAttributes);
    		}

    		function get (key, json) {
    			if (typeof document === 'undefined') {
    				return;
    			}

    			var jar = {};
    			// To prevent the for loop in the first place assign an empty array
    			// in case there are no cookies at all.
    			var cookies = document.cookie ? document.cookie.split('; ') : [];
    			var i = 0;

    			for (; i < cookies.length; i++) {
    				var parts = cookies[i].split('=');
    				var cookie = parts.slice(1).join('=');

    				if (!json && cookie.charAt(0) === '"') {
    					cookie = cookie.slice(1, -1);
    				}

    				try {
    					var name = decode(parts[0]);
    					cookie = (converter.read || converter)(cookie, name) ||
    						decode(cookie);

    					if (json) {
    						try {
    							cookie = JSON.parse(cookie);
    						} catch (e) {}
    					}

    					jar[name] = cookie;

    					if (key === name) {
    						break;
    					}
    				} catch (e) {}
    			}

    			return key ? jar[key] : jar;
    		}

    		api.set = set;
    		api.get = function (key) {
    			return get(key, false /* read as raw */);
    		};
    		api.getJSON = function (key) {
    			return get(key, true /* read as json */);
    		};
    		api.remove = function (key, attributes) {
    			set(key, '', extend(attributes, {
    				expires: -1
    			}));
    		};

    		api.defaults = {};

    		api.withConverter = init;

    		return api;
    	}

    	return init(function () {});
    }));
    }(js_cookie));

    var Cookies = js_cookie.exports;

    // Unique ID creation requires a high quality random # generator. In the browser we therefore
    // require the crypto API and do not support built-in fallback to lower quality random number
    // generators (like Math.random()).
    let getRandomValues;
    const rnds8 = new Uint8Array(16);
    function rng() {
      // lazy load so that environments that need to polyfill have a chance to do so
      if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

        if (!getRandomValues) {
          throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
      }

      return getRandomValues(rnds8);
    }

    /**
     * Convert array of 16 byte values to UUID string format of the form:
     * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
     */

    const byteToHex = [];

    for (let i = 0; i < 256; ++i) {
      byteToHex.push((i + 0x100).toString(16).slice(1));
    }

    function unsafeStringify(arr, offset = 0) {
      // Note: Be careful editing this code!  It's been tuned for performance
      // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
      return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
    }

    const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
    var native = {
      randomUUID
    };

    function v4(options, buf, offset) {
      if (native.randomUUID && !buf && !options) {
        return native.randomUUID();
      }

      options = options || {};
      const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

      rnds[6] = rnds[6] & 0x0f | 0x40;
      rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

      if (buf) {
        offset = offset || 0;

        for (let i = 0; i < 16; ++i) {
          buf[offset + i] = rnds[i];
        }

        return buf;
      }

      return unsafeStringify(rnds);
    }

    function getEnvironment() {
      var hostname = window.location.hostname;

      if (STAGING_HOSTNAMES.includes(hostname)) {
        return 'staging';
      }

      if (hostname.endsWith('.intercom.com') || hostname.endsWith('.intercom.io') || hostname.endsWith('intercom.engineering') || hostname.endsWith('intercom.design')) {
        return 'production';
      }

      return 'local';
    }
    var STAGING_HOSTNAMES = ['marketing-site-node.internal.intercom.io', 'marketing-site-static-staging.internal.intercom.io', 'preview.intercom.com', 'full-intercombuilders.cs194.force.com', 'intergdpr-intercombuilders.cs195.force.com', 'marketing-site-experimental.intercom.com', 'production-system-test.internal.intercom.io', 'intercom-en-community.insided.com', 'funky-staging.intercom.io'];

    function apiEndpoint () {
      switch (getEnvironment()) {
        case 'local':
          return 'http://intercom.test/visitor_analytics';

        case 'staging':
          return 'https://funky-staging.intercom.io/visitor_analytics';

        case 'production':
          return 'https://api-visitor-analytics.intercom.com/visitor_analytics';
      }
    }

    var Intercom =
    /** @class */
    function () {
      function Intercom() {}

      Intercom.prototype.get = function (url, options) {
        if (options === void 0) {
          options = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            return [2
            /*return*/
            , this.request('get', url, options)];
          });
        });
      };

      Intercom.prototype.post = function (url, body, options) {
        if (options === void 0) {
          options = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            return [2
            /*return*/
            , this.request('post', url, __assign({
              body: body
            }, options))];
          });
        });
      };

      Intercom.prototype.request = function (method, url, _a) {
        var _b = _a.query,
            query = _b === void 0 ? {} : _b,
            _c = _a.body,
            body = _c === void 0 ? {} : _c,
            _d = _a.headers,
            headers = _d === void 0 ? {} : _d,
            _e = _a.timeout,
            timeout = _e === void 0 ? 5000 : _e;
        return __awaiter(this, void 0, void 0, function () {
          var params, response, parsed_1, text_1, exception_1;
          return __generator(this, function (_f) {
            switch (_f.label) {
              case 0:
                url = new URL([apiEndpoint(), url.replace(/^\//, '')].join('/')).toString();
                params = new URLSearchParams(query).toString();
                if (params) url += "?" + params;
                _f.label = 1;

              case 1:
                _f.trys.push([1, 6,, 7]);

                return [4
                /*yield*/
                , Promise.race([fetch(url, {
                  method: method,
                  credentials: 'include',
                  headers: __assign({
                    'Content-Type': 'application/json'
                  }, headers),
                  body: method === 'post' ? JSON.stringify(body) : undefined
                }), rejectAfterTimeout(timeout, new Error("Request to " + url + " timed out after " + timeout + "ms"))])];

              case 2:
                response = _f.sent();
                if (!response.ok) return [3
                /*break*/
                , 4];
                return [4
                /*yield*/
                , response.json()];

              case 3:
                parsed_1 = _f.sent();
                return [2
                /*return*/
                , {
                  error: null,
                  status: response.status,
                  data: parsed_1,
                  resultOrThrow: function () {
                    return parsed_1;
                  }
                }];

              case 4:
                return [4
                /*yield*/
                , response.text()];

              case 5:
                text_1 = _f.sent();
                return [2
                /*return*/
                , {
                  error: true,
                  exception: null,
                  data: text_1.toString(),
                  status: response.status,
                  resultOrThrow: function () {
                    throw new Error(text_1);
                  }
                }];

              case 6:
                exception_1 = _f.sent();
                return [2
                /*return*/
                , {
                  error: true,
                  exception: exception_1,
                  resultOrThrow: function () {
                    throw exception_1;
                  }
                }];

              case 7:
                return [2
                /*return*/
                ];
            }
          });
        });
      };

      return Intercom;
    }();

    function rejectAfterTimeout(timeout, error) {
      return new Promise(function (_, reject) {
        setTimeout(function () {
          return reject(error);
        }, timeout);
      });
    }

    var intercom = new Intercom();

    function appStatus(email) {
      var _a;

      return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , intercom.post('/app_status', {
                email: email
              })];

            case 1:
              _b.sent();

              return [3
              /*break*/
              , 3];

            case 2:
              error_1 = _b.sent();
              (_a = window.Raven) === null || _a === void 0 ? void 0 : _a.captureException(error_1);
              return [3
              /*break*/
              , 3];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    var n$3,u$3,i$3,t$4,r$4,o$3,f$4,e$4={},c$4=[],s$2=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;function a$3(n,l){for(var u in l)n[u]=l[u];return n}function v$4(n){var l=n.parentNode;l&&l.removeChild(n);}function h$4(n,l,u){var i,t=arguments,r={};for(i in l)"key"!==i&&"ref"!==i&&(r[i]=l[i]);if(arguments.length>3)for(u=[u],i=3;i<arguments.length;i++)u.push(t[i]);if(null!=u&&(r.children=u),"function"==typeof n&&null!=n.defaultProps)for(i in n.defaultProps)void 0===r[i]&&(r[i]=n.defaultProps[i]);return p$4(n,r,l&&l.key,l&&l.ref,null)}function p$4(l,u,i,t,r){var o={type:l,props:u,key:i,ref:t,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,constructor:void 0,__v:r};return null==r&&(o.__v=o),n$3.vnode&&n$3.vnode(o),o}function d$4(n){return n.children}function m$4(n,l){this.props=n,this.context=l;}function w$3(n,l){if(null==l)return n.__?w$3(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?w$3(n):null}function k$2(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return k$2(n)}}function g$3(l){(!l.__d&&(l.__d=!0)&&u$3.push(l)&&!i$3++||r$4!==n$3.debounceRendering)&&((r$4=n$3.debounceRendering)||t$4)(_$2);}function _$2(){for(var n;i$3=u$3.length;)n=u$3.sort(function(n,l){return n.__v.__b-l.__v.__b}),u$3=[],n.some(function(n){var l,u,i,t,r,o,f;n.__d&&(o=(r=(l=n).__v).__e,(f=l.__P)&&(u=[],(i=a$3({},r)).__v=i,t=A$2(f,r,i,l.__n,void 0!==f.ownerSVGElement,null,u,null==o?w$3(r):o),T$2(u,r),t!=o&&k$2(r)));});}function b$2(n,l,u,i,t,r,o,f,s){var a,h,p,y,d,m,k,g=u&&u.__k||c$4,_=g.length;if(f==e$4&&(f=null!=r?r[0]:_?w$3(u,0):null),a=0,l.__k=x$4(l.__k,function(u){if(null!=u){if(u.__=l,u.__b=l.__b+1,null===(p=g[a])||p&&u.key==p.key&&u.type===p.type)g[a]=void 0;else for(h=0;h<_;h++){if((p=g[h])&&u.key==p.key&&u.type===p.type){g[h]=void 0;break}p=null;}if(y=A$2(n,u,p=p||e$4,i,t,r,o,f,s),(h=u.ref)&&p.ref!=h&&(k||(k=[]),p.ref&&k.push(p.ref,null,u),k.push(h,u.__c||y,u)),null!=y){var c;if(null==m&&(m=y),void 0!==u.__d)c=u.__d,u.__d=void 0;else if(r==p||y!=f||null==y.parentNode){n:if(null==f||f.parentNode!==n)n.appendChild(y),c=null;else {for(d=f,h=0;(d=d.nextSibling)&&h<_;h+=2)if(d==y)break n;n.insertBefore(y,f),c=f;}"option"==l.type&&(n.value="");}f=void 0!==c?c:y.nextSibling,"function"==typeof l.type&&(l.__d=f);}else f&&p.__e==f&&f.parentNode!=n&&(f=w$3(p));}return a++,u}),l.__e=m,null!=r&&"function"!=typeof l.type)for(a=r.length;a--;)null!=r[a]&&v$4(r[a]);for(a=_;a--;)null!=g[a]&&D$1(g[a],g[a]);if(k)for(a=0;a<k.length;a++)j$1(k[a],k[++a],k[++a]);}function x$4(n,l,u){if(null==u&&(u=[]),null==n||"boolean"==typeof n)l&&u.push(l(null));else if(Array.isArray(n))for(var i=0;i<n.length;i++)x$4(n[i],l,u);else u.push(l?l("string"==typeof n||"number"==typeof n?p$4(null,n,null,null,n):null!=n.__e||null!=n.__c?p$4(n.type,n.props,n.key,null,n.__v):n):n);return u}function P$2(n,l,u,i,t){var r;for(r in u)"children"===r||"key"===r||r in l||N$1(n,r,null,u[r],i);for(r in l)t&&"function"!=typeof l[r]||"children"===r||"key"===r||"value"===r||"checked"===r||u[r]===l[r]||N$1(n,r,l[r],u[r],i);}function C$1(n,l,u){"-"===l[0]?n.setProperty(l,u):n[l]="number"==typeof u&&!1===s$2.test(l)?u+"px":null==u?"":u;}function N$1(n,l,u,i,t){var r,o,f,e,c;if(t?"className"===l&&(l="class"):"class"===l&&(l="className"),"style"===l)if(r=n.style,"string"==typeof u)r.cssText=u;else {if("string"==typeof i&&(r.cssText="",i=null),i)for(e in i)u&&e in u||C$1(r,e,"");if(u)for(c in u)i&&u[c]===i[c]||C$1(r,c,u[c]);}else "o"===l[0]&&"n"===l[1]?(o=l!==(l=l.replace(/Capture$/,"")),f=l.toLowerCase(),l=(f in n?f:l).slice(2),u?(i||n.addEventListener(l,z$2,o),(n.l||(n.l={}))[l]=u):n.removeEventListener(l,z$2,o)):"list"!==l&&"tagName"!==l&&"form"!==l&&"type"!==l&&"size"!==l&&!t&&l in n?n[l]=null==u?"":u:"function"!=typeof u&&"dangerouslySetInnerHTML"!==l&&(l!==(l=l.replace(/^xlink:?/,""))?null==u||!1===u?n.removeAttributeNS("http://www.w3.org/1999/xlink",l.toLowerCase()):n.setAttributeNS("http://www.w3.org/1999/xlink",l.toLowerCase(),u):null==u||!1===u&&!/^ar/.test(l)?n.removeAttribute(l):n.setAttribute(l,u));}function z$2(l){this.l[l.type](n$3.event?n$3.event(l):l);}function A$2(l,u,i,t,r,o,f,e,c){var s,v,h,p,y,w,k,g,_,x,P=u.type;if(void 0!==u.constructor)return null;(s=n$3.__b)&&s(u);try{n:if("function"==typeof P){if(g=u.props,_=(s=P.contextType)&&t[s.__c],x=s?_?_.props.value:s.__:t,i.__c?k=(v=u.__c=i.__c).__=v.__E:("prototype"in P&&P.prototype.render?u.__c=v=new P(g,x):(u.__c=v=new m$4(g,x),v.constructor=P,v.render=E$2),_&&_.sub(v),v.props=g,v.state||(v.state={}),v.context=x,v.__n=t,h=v.__d=!0,v.__h=[]),null==v.__s&&(v.__s=v.state),null!=P.getDerivedStateFromProps&&(v.__s==v.state&&(v.__s=a$3({},v.__s)),a$3(v.__s,P.getDerivedStateFromProps(g,v.__s))),p=v.props,y=v.state,h)null==P.getDerivedStateFromProps&&null!=v.componentWillMount&&v.componentWillMount(),null!=v.componentDidMount&&v.__h.push(v.componentDidMount);else {if(null==P.getDerivedStateFromProps&&g!==p&&null!=v.componentWillReceiveProps&&v.componentWillReceiveProps(g,x),!v.__e&&null!=v.shouldComponentUpdate&&!1===v.shouldComponentUpdate(g,v.__s,x)||u.__v===i.__v&&!v.__){for(v.props=g,v.state=v.__s,u.__v!==i.__v&&(v.__d=!1),v.__v=u,u.__e=i.__e,u.__k=i.__k,v.__h.length&&f.push(v),s=0;s<u.__k.length;s++)u.__k[s]&&(u.__k[s].__=u);break n}null!=v.componentWillUpdate&&v.componentWillUpdate(g,v.__s,x),null!=v.componentDidUpdate&&v.__h.push(function(){v.componentDidUpdate(p,y,w);});}v.context=x,v.props=g,v.state=v.__s,(s=n$3.__r)&&s(u),v.__d=!1,v.__v=u,v.__P=l,s=v.render(v.props,v.state,v.context),u.__k=null!=s&&s.type==d$4&&null==s.key?s.props.children:Array.isArray(s)?s:[s],null!=v.getChildContext&&(t=a$3(a$3({},t),v.getChildContext())),h||null==v.getSnapshotBeforeUpdate||(w=v.getSnapshotBeforeUpdate(p,y)),b$2(l,u,i,t,r,o,f,e,c),v.base=u.__e,v.__h.length&&f.push(v),k&&(v.__E=v.__=null),v.__e=!1;}else null==o&&u.__v===i.__v?(u.__k=i.__k,u.__e=i.__e):u.__e=$$3(i.__e,u,i,t,r,o,f,c);(s=n$3.diffed)&&s(u);}catch(l){u.__v=null,n$3.__e(l,u,i);}return u.__e}function T$2(l,u){n$3.__c&&n$3.__c(u,l),l.some(function(u){try{l=u.__h,u.__h=[],l.some(function(n){n.call(u);});}catch(l){n$3.__e(l,u.__v);}});}function $$3(n,l,u,i,t,r,o,f){var s,a,v,h,p,y=u.props,d=l.props;if(t="svg"===l.type||t,null!=r)for(s=0;s<r.length;s++)if(null!=(a=r[s])&&((null===l.type?3===a.nodeType:a.localName===l.type)||n==a)){n=a,r[s]=null;break}if(null==n){if(null===l.type)return document.createTextNode(d);n=t?document.createElementNS("http://www.w3.org/2000/svg",l.type):document.createElement(l.type,d.is&&{is:d.is}),r=null,f=!1;}if(null===l.type)y!==d&&n.data!=d&&(n.data=d);else {if(null!=r&&(r=c$4.slice.call(n.childNodes)),v=(y=u.props||e$4).dangerouslySetInnerHTML,h=d.dangerouslySetInnerHTML,!f){if(y===e$4)for(y={},p=0;p<n.attributes.length;p++)y[n.attributes[p].name]=n.attributes[p].value;(h||v)&&(h&&v&&h.__html==v.__html||(n.innerHTML=h&&h.__html||""));}P$2(n,d,y,t,f),h?l.__k=[]:(l.__k=l.props.children,b$2(n,l,u,i,"foreignObject"!==l.type&&t,r,o,e$4,f)),f||("value"in d&&void 0!==(s=d.value)&&s!==n.value&&N$1(n,"value",s,y.value,!1),"checked"in d&&void 0!==(s=d.checked)&&s!==n.checked&&N$1(n,"checked",s,y.checked,!1));}return n}function j$1(l,u,i){try{"function"==typeof l?l(u):l.current=u;}catch(l){n$3.__e(l,i);}}function D$1(l,u,i){var t,r,o;if(n$3.unmount&&n$3.unmount(l),(t=l.ref)&&(t.current&&t.current!==l.__e||j$1(t,null,u)),i||"function"==typeof l.type||(i=null!=(r=l.__e)),l.__e=l.__d=void 0,null!=(t=l.__c)){if(t.componentWillUnmount)try{t.componentWillUnmount();}catch(l){n$3.__e(l,u);}t.base=t.__P=null;}if(t=l.__k)for(o=0;o<t.length;o++)t[o]&&D$1(t[o],u,i);null!=r&&v$4(r);}function E$2(n,l,u){return this.constructor(n,u)}function H(l,u,i){var t,r,f;n$3.__&&n$3.__(l,u),r=(t=i===o$3)?null:i&&i.__k||u.__k,l=h$4(d$4,null,[l]),f=[],A$2(u,(t?u:i||u).__k=l,r||e$4,e$4,void 0!==u.ownerSVGElement,i&&!t?[i]:r?null:c$4.slice.call(u.childNodes),f,i||e$4,t),T$2(f,l);}function L(n,l){var u,i;for(i in l=a$3(a$3({},n.props),l),arguments.length>2&&(l.children=c$4.slice.call(arguments,2)),u={},l)"key"!==i&&"ref"!==i&&(u[i]=l[i]);return p$4(n.type,u,l.key||n.key,l.ref||n.ref,null)}function M(n){var l={},u={__c:"__cC"+f$4++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var i,t=this;return this.getChildContext||(i=[],this.getChildContext=function(){return l[u.__c]=t,l},this.shouldComponentUpdate=function(n){t.props.value!==n.value&&i.some(function(l){l.context=n.value,g$3(l);});},this.sub=function(n){i.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){i.splice(i.indexOf(n),1),l&&l.call(n);};}),n.children}};return u.Consumer.contextType=u,u.Provider.__=u,u}n$3={__e:function(n,l){for(var u,i;l=l.__;)if((u=l.__c)&&!u.__)try{if(u.constructor&&null!=u.constructor.getDerivedStateFromError&&(i=!0,u.setState(u.constructor.getDerivedStateFromError(n))),null!=u.componentDidCatch&&(i=!0,u.componentDidCatch(n)),i)return g$3(u.__E=u)}catch(l){n=l;}throw n}},m$4.prototype.setState=function(n,l){var u;u=this.__s!==this.state?this.__s:this.__s=a$3({},this.state),"function"==typeof n&&(n=n(u,this.props)),n&&a$3(u,n),null!=n&&this.__v&&(l&&this.__h.push(l),g$3(this));},m$4.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),g$3(this));},m$4.prototype.render=d$4,u$3=[],i$3=0,t$4="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,o$3=e$4,f$4=0;

    var t$3,u$2,r$3,i$2=0,o$2=[],c$3=n$3.__r,f$3=n$3.diffed,e$3=n$3.__c,a$2=n$3.unmount;function v$3(t,r){n$3.__h&&n$3.__h(u$2,t,i$2||r),i$2=0;var o=u$2.__H||(u$2.__H={__:[],__h:[]});return t>=o.__.length&&o.__.push({}),o.__[t]}function m$3(n){return i$2=1,p$3(E$1,n)}function p$3(n,r,i){var o=v$3(t$3++,2);return o.__c||(o.__c=u$2,o.__=[i?i(r):E$1(void 0,r),function(t){var u=n(o.__[0],t);o.__[0]!==u&&(o.__[0]=u,o.__c.setState({}));}]),o.__}function l$3(r,i){var o=v$3(t$3++,3);!n$3.__s&&x$3(o.__H,i)&&(o.__=r,o.__H=i,u$2.__H.__h.push(o));}function d$3(n){return i$2=5,h$3(function(){return {current:n}},[])}function h$3(n,u){var r=v$3(t$3++,7);return x$3(r.__H,u)?(r.__H=u,r.__h=n,r.__=n()):r.__}function w$2(n){var r=u$2.context[n.__c],i=v$3(t$3++,9);return i.__c=n,r?(null==i.__&&(i.__=!0,r.sub(u$2)),r.props.value):n.__}function _$1(){o$2.some(function(t){if(t.__P)try{t.__H.__h.forEach(g$2),t.__H.__h.forEach(q$1),t.__H.__h=[];}catch(u){return t.__H.__h=[],n$3.__e(u,t.__v),!0}}),o$2=[];}function g$2(n){n.t&&n.t();}function q$1(n){var t=n.__();"function"==typeof t&&(n.t=t);}function x$3(n,t){return !n||t.some(function(t,u){return t!==n[u]})}function E$1(n,t){return "function"==typeof t?t(n):t}n$3.__r=function(n){c$3&&c$3(n),t$3=0,(u$2=n.__c).__H&&(u$2.__H.__h.forEach(g$2),u$2.__H.__h.forEach(q$1),u$2.__H.__h=[]);},n$3.diffed=function(t){f$3&&f$3(t);var u=t.__c;if(u){var i=u.__H;i&&i.__h.length&&(1!==o$2.push(u)&&r$3===n$3.requestAnimationFrame||((r$3=n$3.requestAnimationFrame)||function(n){var t,u=function(){clearTimeout(r),cancelAnimationFrame(t),setTimeout(n);},r=setTimeout(u,100);"undefined"!=typeof window&&(t=requestAnimationFrame(u));})(_$1));}},n$3.__c=function(t,u){u.some(function(t){try{t.__h.forEach(g$2),t.__h=t.__h.filter(function(n){return !n.__||q$1(n)});}catch(r){u.some(function(n){n.__h&&(n.__h=[]);}),u=[],n$3.__e(r,t.__v);}}),e$3&&e$3(t,u);},n$3.unmount=function(t){a$2&&a$2(t);var u=t.__c;if(u){var r=u.__H;if(r)try{r.__.forEach(function(n){return n.t&&n.t()});}catch(t){n$3.__e(t,u.__v);}}};

    var _id = 0;
    var sheet = document.head.appendChild(document.createElement("style")).sheet;

    function hyphenate(str) {
      return str.replace(/[A-Z]/g, "-$&").toLowerCase()
    }

    function createStyle(rules, prefix) {
      var id = "p" + _id++;
      var name = prefix + id;
      rules.forEach(function(rule) {
        if (/^@/.test(rule)) {
          var start = rule.indexOf("{") + 1;
          rule = rule.slice(0, start) + name + rule.slice(start);
        } else {
          rule = name + rule;
        }
        sheet.insertRule(rule, sheet.cssRules.length);
      });
      return id
    }

    function wrap(stringToWrap, wrapper) {
      return wrapper + "{" + stringToWrap + "}"
    }

    function parse(obj, isInsideObj) {
      var arr = [""];
      isInsideObj = isInsideObj || 0;
      for (var prop in obj) {
        var value = obj[prop];
        prop = hyphenate(prop);
        // Same as typeof value === 'object', but smaller
        if (!value.sub && !Array.isArray(value)) {
          // replace & in "&:hover", "p>&"
          prop = prop.replace(/&/g, "");
          arr.push(wrap(parse(value, !/^@/.test(prop)).join(""), prop));
        } else {
          value = Array.isArray(value) ? value : [value];
          value.forEach(function(value) {
            return (arr[0] += prop + ":" + value + ";")
          });
        }
      }
      if (!isInsideObj) {
        arr[0] = wrap(arr[0], "");
      }
      return arr
    }

    function picostyle(h, options) {
      var cache = {};
      options = options || {};
      return options.returnObject ? { style: style, css: css } : style
      function style(nodeName) {
        return function(decls) {
          return function(attributes, children) {
            attributes = attributes || {};
            children = attributes.children || children;
            var nodeDecls = typeof decls == "function" ? decls(attributes) : decls;
            attributes.class = [css(nodeDecls), attributes.class]
              .filter(Boolean)
              .join(" ");
            return h(nodeName, attributes, children)
          }
        }
      }
      function css(decls) {
        var rules = parse(decls);
        var key = rules.join("");
        return cache[key] || (cache[key] = createStyle(rules, "."))
      }
    }

    var dest = {};

    var helpers = {};

    Object.defineProperty(helpers, "__esModule", {
      value: true
    });
    helpers.removeEventListener = helpers.addEventListener = helpers.getAllFocusableElements = helpers.KEYS = void 0;
    var KEYS$1 = {
      TAB: 9
    };
    helpers.KEYS = KEYS$1;

    var getAllFocusableElements = function getAllFocusableElements(context) {
      return Array.from(context.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'));
    };

    helpers.getAllFocusableElements = getAllFocusableElements;

    var addEventListener = function addEventListener(node, eventName, callback) {
      if (node.addEventListener) {
        node.addEventListener(eventName, callback);
      } else {
        node.attachEvent("on".concat(eventName), callback);
      }
    };

    helpers.addEventListener = addEventListener;

    var removeEventListener = function removeEventListener(node, eventName, callback) {
      if (node.removeEventListener) {
        node.removeEventListener(eventName, callback);
      } else {
        node.detachEvent("on".concat(eventName), callback);
      }
    };

    helpers.removeEventListener = removeEventListener;

    Object.defineProperty(dest, "__esModule", {
      value: true
    });
    var _default$2 = dest.default = void 0;

    var _helpers = helpers;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

    function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

    var boolNoop = function boolNoop() {
      return false;
    };

    var nullNoop = function nullNoop() {
      return null;
    };

    var FocusTrap =
    /*#__PURE__*/
    function () {
      function FocusTrap(_ref) {
        var _this = this;

        var node = _ref.node,
            _firstElement = _ref.firstElement,
            _lastElement = _ref.lastElement,
            _disableStartingTrap = _ref.disableStartingTrap,
            _disableEndingTrap = _ref.disableEndingTrap;

        _classCallCheck(this, FocusTrap);

        _defineProperty(this, "node", void 0);

        _defineProperty(this, "firstElement", void 0);

        _defineProperty(this, "lastElement", void 0);

        _defineProperty(this, "disableStartingTrap", void 0);

        _defineProperty(this, "disableEndingTrap", void 0);

        _defineProperty(this, "focusableElements", null);

        _defineProperty(this, "handleFocusTrap", function (event) {
          var focusableElements = _this.focusableElements,
              firstElement = _this.firstElement,
              lastElement = _this.lastElement,
              disableEndingTrap = _this.disableEndingTrap,
              disableStartingTrap = _this.disableStartingTrap;
          if (!focusableElements || !focusableElements.length || event.keyCode !== _helpers.KEYS.TAB) return;
          var first = focusableElements[0];
          var last = focusableElements[focusableElements.length - 1];
          var isBackwards = event.shiftKey;

          if (last === event.srcElement && !isBackwards && !disableEndingTrap()) {
            event.preventDefault();
            return (firstElement() || first).focus();
          }

          if (first === event.srcElement && isBackwards && !disableStartingTrap()) {
            event.preventDefault();
            return (lastElement() || last).focus();
          }
        });

        this.node = node;
        this.firstElement = _firstElement || nullNoop;
        this.lastElement = _lastElement || nullNoop;
        this.disableStartingTrap = _disableStartingTrap || boolNoop;
        this.disableEndingTrap = _disableEndingTrap || boolNoop;
        this.focusableElements = (0, _helpers.getAllFocusableElements)(this.node);
        (0, _helpers.addEventListener)(this.node, 'keydown', this.handleFocusTrap);
      }

      _createClass(FocusTrap, [{
        key: "recalculateFocusableElements",
        value: function recalculateFocusableElements() {
          this.focusableElements = (0, _helpers.getAllFocusableElements)(this.node);
        }
      }, {
        key: "restore",
        value: function restore() {
          if (this.node) {
            (0, _helpers.removeEventListener)(this.node, 'keydown', this.handleFocusTrap);
          }
        }
      }]);

      return FocusTrap;
    }();

    _default$2 = dest.default = FocusTrap;

    var DEFAULT_LOCALE_CODE = 'en-US';
    var LocaleCodeContext = M(DEFAULT_LOCALE_CODE);

    var de = new Map([['accept-all-cookies', 'Alle Cookies annehmen'], ['advertising-cookies-description', 'Diese Cookies stellen Werbeunternehmen Informationen über Ihre Online-Aktivitäten zur Verfügung, damit diese relevantere Online-Werbung für Sie bereitstellen oder die Anzahl einschränken können, wie oft Sie eine Anzeige sehen. Diese Informationen können an andere Werbeunternehmen weitergegeben werden.'], ['advertising-cookies', 'Werbe-Cookies'], ['always-on', 'Immer an'], ['analytics-cookies-description', 'Diese Cookies erfassen Informationen, mit denen wir nachvollziehen können, wie unsere Websites genutzt werden oder wie effektiv unsere Marketing-Kampagnen sind bzw. wie wir unsere Websites für Sie anpassen können.'], ['analytics-cookies', 'Analyse-Cookies'], ['close-dialog', 'Dialog schließen'], ['cookie-modal-description', 'Essenzielle Cookies sind immer aktiviert. Sie haben die Möglichkeit, andere Cookie-Typen zu deaktivieren.'], ['cookie', 'Cookie'], ['disclaimer-text', 'Wir verwenden Cookies, damit unsere Website funktioniert, und auch für Analyse- und Werbezwecke. Sie können optionale Cookies nach Wunsch aktivieren oder deaktivieren.Weitere Informationen finden Sie in unserer <a href="https://www.intercom.com/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie-Richtlinie</a>.'], ['error-select-a-choice-for-each-option', 'Bitte Auswahl für jede Option treffen'], ['essential-cookies-description', 'Diese Cookies sind unerlässlich, damit Sie die Website verwenden und deren Funktionen nutzen können. Sie können nicht abgeschaltet werden.Sie werden als Reaktion auf Ihre Anfragen festgelegt, z. B. wenn Sie Ihre Datenschutzeinstellungen festlegen, sich anmelden oder Formulare ausfüllen.'], ['essential-cookies', 'Essenzielle Cookies'], ['fresh-cookie-update', 'Neues Cookie-Update'], ['manage-your-cookies', 'Cookies verwalten'], ['marketing-cookies-description', 'Diese Cookies für Account-basiertes Marketing ermöglichen es uns, zukünftige potenzielle Kunden zu identifizieren und Vertriebs- und Marketinginteraktionen für sie zu personalisieren.'], ['marketing-cookies', 'Marketing-Cookies'], ['off', 'Aus'], ['on', 'An'], ['performance-functionality-cookies-description', 'Diese Cookies werden verwendet, um die Leistung und Funktionalität unserer Websites zu verbessern, sind aber für die Nutzung nicht unbedingt erforderlich. Ohne diese Cookies stehen jedoch bestimmte Funktionen wie z. B. Videos möglicherweise nicht mehr zur Verfügung.'], ['performance-functionality-cookies', 'Leistungs-/Funktions-Cookies'], ['save-preferences', 'Einstellungen speichern'], ['see-list-advertising-cookies', 'Eine Liste der von uns verwendeten Werbe-Cookies finden Sie hier.'], ['see-list-analytics-cookies', 'Eine Liste der von uns verwendeten Analyse-Cookies finden Sie hier.'], ['see-list-marketing-cookies', 'Eine Liste der von uns verwendeten Marketing-Cookies finden Sie hier.'], ['see-list-performance-functionality-cookies', 'Eine Liste der von uns verwendeten Performance-/Funktionalitäts-Cookies finden Sie hier.']]);

    var enUS = new Map([['accept-all-cookies', 'Accept all cookies'], ['advertising-cookies-description', 'These cookies provide advertising companies with information about your online activity to help them deliver more relevant online advertising to you or to limit how many times you see an ad. This information may be shared with other advertising companies.'], ['advertising-cookies', 'Advertising cookies'], ['always-on', 'Always On'], ['analytics-cookies-description', 'These cookies collect information to help us understand how our Websites are being used or how effective our marketing campaigns are, or to help us customise our Websites for you.'], ['analytics-cookies', 'Analytics cookies'], ['close-dialog', 'Close dialog'], ['cookie-modal-description', 'Essential cookies are always on. You have the option to turn off other cookie types.'], ['cookie', 'Cookie'], ['disclaimer-text', 'We use cookies to make our site work and also for analytics and advertising purposes. You can enable or disable optional cookies as desired. See our <a href="https://www.intercom.com/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</a> for more details.'], ['error-select-a-choice-for-each-option', 'Please select a choice for each option'], ['essential-cookies-description', "These cookies are essential so that you can use the website and use its functions. They cannot be turned off. They're set in response to requests made by you, such as setting your privacy preferences, logging in or filling in forms."], ['essential-cookies', 'Essential cookies'], ['fresh-cookie-update', 'Fresh cookie update'], ['manage-your-cookies', 'Manage your cookies'], ['marketing-cookies-description', 'These account-based marketing cookies enable us to identify future prospects and personalise sales and marketing interactions with them.'], ['marketing-cookies', 'Marketing cookies'], ['off', 'Off'], ['on', 'On'], ['performance-functionality-cookies-description', 'These cookies are used to enhance the performance and functionality of our Websites but are non-essential to their use. However, without these cookies, certain functionality like videos may become unavailable.'], ['performance-functionality-cookies', 'Performance/functionality cookies'], ['save-preferences', 'Save preferences'], ['see-list-advertising-cookies', 'See a list of the advertising cookies we use here.'], ['see-list-analytics-cookies', 'See a list of the analytics cookies we use here.'], ['see-list-marketing-cookies', 'See a list of the marketing cookies we use here.'], ['see-list-performance-functionality-cookies', 'See a list of the performance/functionality cookies we use here.']]);

    var es = new Map([['accept-all-cookies', 'Aceptar todas las cookies'], ['advertising-cookies-description', 'Estas cookies proporcionan a las empresas de publicidad información sobre tu actividad en línea a fin de ayudarlas a proporcionarte la publicidad en línea más relevante o para limitar cuántas veces ves un anuncio. Esta información se puede compartir con otras empresas de publicidad.'], ['advertising-cookies', 'Cookies publicitarias'], ['always-on', 'Siempre activadas'], ['analytics-cookies-description', 'Estas cookies recopilan información para ayudarnos a entender cómo se utilizan nuestros sitios web y qué efectividad tienen nuestras campañas de marketing, así como para ayudarnos a adaptar nuestros sitios web a los intereses de cada visitante.'], ['analytics-cookies', 'Cookies de análisis'], ['close-dialog', 'Cerrar diálogo'], ['cookie-modal-description', 'Las cookies indispensables siempre están activadas. Tienes la opción de desactivar otro tipo de cookies.'], ['cookie', 'Cookie'], ['disclaimer-text', 'Utilizamos cookies para que nuestro sitio funcione y también con fines analíticos y publicitarios. Puedes habilitar o deshabilitar las cookies opcionales según lo desees. Consulta nuestra <a href="https://www.intercom.com/cookie-policy" target="_blank" rel="noopener noreferrer">Política de cookies</a> para obtener más información.'], ['error-select-a-choice-for-each-option', 'Selecciona una alternativa para cada opción'], ['essential-cookies-description', 'Estas cookies son imprescindibles para que puedas usar el sitio web y utilizar sus funciones. No se pueden desactivar. Están configuradas según las solicitudes que llevas a cabo, como al configurar tus preferencias de privacidad, iniciar sesión o rellenar un formulario.'], ['essential-cookies', 'Cookies indispensables'], ['fresh-cookie-update', 'Actualización reciente de cookies'], ['manage-your-cookies', 'Gestiona las cookies'], ['marketing-cookies-description', 'Estas cookies de marketing basadas en cuentas nos permiten identificar futuros clientes potenciales y personalizar las interacciones de ventas y marketing con ellos.'], ['marketing-cookies', 'Cookies de marketing'], ['off', 'Desactivadas'], ['on', 'Activadas'], ['performance-functionality-cookies-description', 'Estas cookies se utilizan para mejorar el rendimiento y la funcionalidad de nuestros sitios web, pero no son imprescindibles para su uso. Sin embargo, sin estas cookies, ciertas funciones, como los vídeos, pueden dejar de estar disponibles.'], ['performance-functionality-cookies', 'Cookies de rendimiento/funcionalidad'], ['save-preferences', 'Guardar preferencias'], ['see-list-advertising-cookies', 'Consulta la lista de las cookies publicitarias que utilizamos aquí.'], ['see-list-analytics-cookies', 'Consulta la lista de las cookies analíticas que utilizamos aquí.'], ['see-list-marketing-cookies', 'Consulta la lista de las cookies de marketing que utilizamos aquí.'], ['see-list-performance-functionality-cookies', 'Consulta la lista de las cookies de rendimiento/funcionalidad que utilizamos aquí.']]);

    var fr = new Map([['accept-all-cookies', 'Tout accepter'], ['advertising-cookies', 'Cookies publicitaires'], ['advertising-cookies-description', "Ces cookies fournissent aux sociétés de publicité des informations sur votre activité en ligne afin de vous proposer des publicités en ligne plus pertinentes ou pour limiter le nombre de fois où vous voyez une publicité. Ces informations peuvent être partagées avec d'autres sociétés de publicité."], ['always-on', 'Toujours activés'], ['analytics-cookies', 'Cookies Analytics'], ['analytics-cookies-description', "Ces cookies collectent des informations nous permettant de comprendre comment nos sites Web sont utilisés, de déterminer l'efficacité de nos campagnes marketing, ou de personnaliser nos sites Web pour vous."], ['close-dialog', 'Fermer la fenêtre'], ['cookie', 'Cookie'], ['cookie-modal-description', 'Les cookies essentiels sont toujours activés. Vous pouvez désactiver les autres types de cookies.'], ['disclaimer-text', "Nous utilisons des cookies pour garantir le fonctionnement de notre site, ainsi qu'\u00E0 des fins d'analyse et de publicit\u00E9. Vous pouvez activer ou d\u00E9sactiver les cookies facultatifs selon vos pr\u00E9f\u00E9rences. Pour en savoir plus consultez notre <a href=\"https://www.intercom.com/cookie-policy\" target=\"_blank\" rel=\"noopener noreferrer\">Politique en mati\u00E8re de cookies</a>."], ['error-select-a-choice-for-each-option', 'Veuillez faire un choix pour chaque option'], ['essential-cookies', 'Cookies essentiels'], ['essential-cookies-description', 'Sans ces cookies, notre site ne peut pas fonctionner. Vous ne pouvez pas les désactiver. Ils sont définis en réponse aux requêtes que vous effectuez : configuration de vos préférences en matière de confidentialité, connexion ou remplissage de formulaires.'], ['fresh-cookie-update', 'Informations sur les cookies'], ['manage-your-cookies', 'Gérer mes préférences'], ['marketing-cookies', 'Cookies marketing'], ['marketing-cookies-description', "Ces cookies marketing basés sur le compte nous permettent d'identifier de futurs prospects et de personnaliser les interactions commerciales et marketing avec eux."], ['off', 'Désactivés'], ['on', 'Activés'], ['performance-functionality-cookies', 'Cookies de performance/fonctionnels'], ['performance-functionality-cookies-description', 'Ces cookies sont utilisés pour améliorer les performances et la fonctionnalité de nos sites Web, mais ne sont pas essentiels à leur utilisation. Toutefois, sans ces cookies, certaines fonctionnalités comme les vidéos peuvent être indisponibles.'], ['save-preferences', 'Enregistrer mes préférences'], ['see-list-advertising-cookies', 'Consultez la liste des cookies publicitaires que nous utilisons.'], ['see-list-analytics-cookies', 'Consultez la liste des cookies Analytics que nous utilisons.'], ['see-list-marketing-cookies', 'Consultez la liste des cookies marketing que nous utilisons.'], ['see-list-performance-functionality-cookies', 'Consultez la liste des cookies de performance/fonctionnels que nous utilisons.']]);

    var ptBR = new Map([['accept-all-cookies', 'Aceitar todos os cookies'], ['advertising-cookies-description', 'Estes cookies fornecem às empresas de publicidade informações sobre sua atividade online para ajudá-las a entregar-lhe publicidade online mais relevante ou para limitar o número de vezes que você vê um anúncio. Estas informações podem ser compartilhadas com outras empresas de publicidade.'], ['advertising-cookies', 'Cookies de publicidade'], ['always-on', 'Sempre ligado'], ['analytics-cookies-description', 'Esses cookies coletam informações para nos ajudar a entender como nossos sites estão sendo usados ou quão eficazes são nossas campanhas de marketing, ou para nos ajudar a personalizar nossos sites para você.'], ['analytics-cookies', 'Cookies analíticos'], ['close-dialog', 'Fechar caixa de diálogo'], ['cookie-modal-description', 'Os cookies essenciais estão sempre ativados. Você tem a opção de desativar outros tipos de cookies.'], ['cookie', 'Cookie'], ['disclaimer-text', 'Utilizamos cookies para fazer nosso site funcionar e também para fins analíticos e publicitários. Você pode ativar ou desativar os cookies opcionais, conforme desejado. Veja nossa <a href="https://www.intercom.com/cookie-policy" target="_blank" rel="noopener noreferrer">Política de Cookie</a> para mais detalhes.'], ['error-select-a-choice-for-each-option', 'Selecione uma escolha para cada opção'], ['essential-cookies-description', 'Estes cookies são essenciais para que você possa usar o site e suas funções. Eles não podem ser desativados. Eles são definidos em resposta a solicitações feitas por você, tais como definir suas preferências de privacidade, fazer login ou preencher formulários.'], ['essential-cookies', 'Cookies essenciais'], ['fresh-cookie-update', 'Atualização de cookies recente'], ['manage-your-cookies', 'Gerencie seus cookies'], ['marketing-cookies-description', 'Estes cookies de marketing baseados em contas nos permitem identificar futuros clientes e personalizar as interações de vendas e marketing com eles.'], ['marketing-cookies', 'Cookies de marketing'], ['off', 'Desativado'], ['on', 'Ativado'], ['performance-functionality-cookies-description', 'Estes cookies são usados para melhorar o desempenho e a funcionalidade de nossos sites, mas não são essenciais para seu uso. Entretanto, sem esses cookies, certas funcionalidades, como vídeos, podem ficar indisponíveis.'], ['performance-functionality-cookies', 'Cookies de desempenho/funcionalidade'], ['save-preferences', 'Salvar preferências'], ['see-list-advertising-cookies', 'Veja uma lista dos cookies de publicidade que usamos aqui.'], ['see-list-analytics-cookies', 'Veja uma lista dos cookies analíticos que usamos aqui.'], ['see-list-marketing-cookies', 'Veja uma lista dos cookies de marketing que usamos aqui.'], ['see-list-performance-functionality-cookies', 'Veja uma lista dos cookies de desempenho/funcionalidade que usamos aqui.']]);

    var translationMap = new Map([['en-US', enUS], ['de', de], ['es', es], ['fr', fr], ['pt-BR', ptBR]]);

    function useLocalizedCopy() {
      var localeCode = w$2(LocaleCodeContext);

      var localizedCopy = function (key) {
        var localizedCopyMap = translationMap.get(localeCode);
        var localizedCopy = localizedCopyMap === null || localizedCopyMap === void 0 ? void 0 : localizedCopyMap.get(key);
        var defaultCopyMap = translationMap.get(DEFAULT_LOCALE_CODE);
        var stringInDefaultLanguage = defaultCopyMap === null || defaultCopyMap === void 0 ? void 0 : defaultCopyMap.get(key);
        return localizedCopy || stringInDefaultLanguage || key;
      };

      return {
        localizedCopy: localizedCopy
      };
    }

    function Caret() {
      return h$4("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "8",
        height: "5",
        viewBox: "0 0 8 5",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, h$4("path", {
        d: "M7 4L4 1L1 4",
        stroke: "black",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }));
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the first element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */

    function arrayReduce$1(array, iteratee, accumulator, initAccum) {
      var index = -1,
          length = array == null ? 0 : array.length;

      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    var _arrayReduce = arrayReduce$1;

    /**
     * The base implementation of `_.propertyOf` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     */

    function basePropertyOf$1(object) {
      return function(key) {
        return object == null ? undefined : object[key];
      };
    }

    var _basePropertyOf = basePropertyOf$1;

    var basePropertyOf = _basePropertyOf;

    /** Used to map Latin Unicode letters to basic Latin letters. */
    var deburredLetters = {
      // Latin-1 Supplement block.
      '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
      '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
      '\xc7': 'C',  '\xe7': 'c',
      '\xd0': 'D',  '\xf0': 'd',
      '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
      '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
      '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
      '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
      '\xd1': 'N',  '\xf1': 'n',
      '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
      '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
      '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
      '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
      '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
      '\xc6': 'Ae', '\xe6': 'ae',
      '\xde': 'Th', '\xfe': 'th',
      '\xdf': 'ss',
      // Latin Extended-A block.
      '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
      '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
      '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
      '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
      '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
      '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
      '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
      '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
      '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
      '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
      '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
      '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
      '\u0134': 'J',  '\u0135': 'j',
      '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
      '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
      '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
      '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
      '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
      '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
      '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
      '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
      '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
      '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
      '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
      '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
      '\u0163': 't',  '\u0165': 't', '\u0167': 't',
      '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
      '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
      '\u0174': 'W',  '\u0175': 'w',
      '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
      '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
      '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
      '\u0132': 'IJ', '\u0133': 'ij',
      '\u0152': 'Oe', '\u0153': 'oe',
      '\u0149': "'n", '\u017f': 's'
    };

    /**
     * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
     * letters to basic Latin letters.
     *
     * @private
     * @param {string} letter The matched letter to deburr.
     * @returns {string} Returns the deburred letter.
     */
    var deburrLetter$1 = basePropertyOf(deburredLetters);

    var _deburrLetter = deburrLetter$1;

    /** Detect free variable `global` from Node.js. */

    var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

    var _freeGlobal = freeGlobal$1;

    var freeGlobal = _freeGlobal;

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root$1 = freeGlobal || freeSelf || Function('return this')();

    var _root = root$1;

    var root = _root;

    /** Built-in value references. */
    var Symbol$5 = root.Symbol;

    var _Symbol = Symbol$5;

    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */

    function arrayMap$1(array, iteratee) {
      var index = -1,
          length = array == null ? 0 : array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    var _arrayMap = arrayMap$1;

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */

    var isArray$1 = Array.isArray;

    var isArray_1 = isArray$1;

    var Symbol$4 = _Symbol;

    /** Used for built-in method references. */
    var objectProto$1 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString$1 = objectProto$1.toString;

    /** Built-in value references. */
    var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag$1(value) {
      var isOwn = hasOwnProperty$1.call(value, symToStringTag$1),
          tag = value[symToStringTag$1];

      try {
        value[symToStringTag$1] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString$1.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag$1] = tag;
        } else {
          delete value[symToStringTag$1];
        }
      }
      return result;
    }

    var _getRawTag = getRawTag$1;

    /** Used for built-in method references. */

    var objectProto = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString$1(value) {
      return nativeObjectToString.call(value);
    }

    var _objectToString = objectToString$1;

    var Symbol$3 = _Symbol,
        getRawTag = _getRawTag,
        objectToString = _objectToString;

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
        undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag$1(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    var _baseGetTag = baseGetTag$1;

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */

    function isObjectLike$1(value) {
      return value != null && typeof value == 'object';
    }

    var isObjectLike_1 = isObjectLike$1;

    var baseGetTag = _baseGetTag,
        isObjectLike = isObjectLike_1;

    /** `Object#toString` result references. */
    var symbolTag = '[object Symbol]';

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol$4(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    var isSymbol_1 = isSymbol$4;

    var Symbol$2 = _Symbol,
        arrayMap = _arrayMap,
        isArray = isArray_1,
        isSymbol$3 = isSymbol_1;

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0;

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString$1(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString$1) + '';
      }
      if (isSymbol$3(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    var _baseToString = baseToString$1;

    var baseToString = _baseToString;

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString$4(value) {
      return value == null ? '' : baseToString(value);
    }

    var toString_1 = toString$4;

    var deburrLetter = _deburrLetter,
        toString$3 = toString_1;

    /** Used to match Latin Unicode letters (excluding mathematical operators). */
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

    /** Used to compose unicode character classes. */
    var rsComboMarksRange$1 = '\\u0300-\\u036f',
        reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
        rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;

    /** Used to compose unicode capture groups. */
    var rsCombo$1 = '[' + rsComboRange$1 + ']';

    /**
     * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
     * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
     */
    var reComboMark = RegExp(rsCombo$1, 'g');

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr$1(string) {
      string = toString$3(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    var deburr_1 = deburr$1;

    /** Used to match words composed of alphanumeric characters. */

    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

    /**
     * Splits an ASCII `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function asciiWords$1(string) {
      return string.match(reAsciiWord) || [];
    }

    var _asciiWords = asciiWords$1;

    /** Used to detect strings that need a more robust regexp to match words. */

    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

    /**
     * Checks if `string` contains a word composed of Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a word is found, else `false`.
     */
    function hasUnicodeWord$1(string) {
      return reHasUnicodeWord.test(string);
    }

    var _hasUnicodeWord = hasUnicodeWord$1;

    /** Used to compose unicode character classes. */

    var rsAstralRange = '\\ud800-\\udfff',
        rsComboMarksRange = '\\u0300-\\u036f',
        reComboHalfMarksRange = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange = '\\u20d0-\\u20ff',
        rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
        rsDingbatRange = '\\u2700-\\u27bf',
        rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
        rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
        rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
        rsPunctuationRange = '\\u2000-\\u206f',
        rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
        rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
        rsVarRange = '\\ufe0e\\ufe0f',
        rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

    /** Used to compose unicode capture groups. */
    var rsApos$1 = "['\u2019]",
        rsBreak = '[' + rsBreakRange + ']',
        rsCombo = '[' + rsComboRange + ']',
        rsDigits = '\\d+',
        rsDingbat = '[' + rsDingbatRange + ']',
        rsLower = '[' + rsLowerRange + ']',
        rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
        rsFitz = '\\ud83c[\\udffb-\\udfff]',
        rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
        rsNonAstral = '[^' + rsAstralRange + ']',
        rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
        rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
        rsUpper = '[' + rsUpperRange + ']',
        rsZWJ = '\\u200d';

    /** Used to compose unicode regexes. */
    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
        rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
        rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
        rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
        reOptMod = rsModifier + '?',
        rsOptVar = '[' + rsVarRange + ']?',
        rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
        rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
        rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
        rsSeq = rsOptVar + reOptMod + rsOptJoin,
        rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

    /** Used to match complex or compound words. */
    var reUnicodeWord = RegExp([
      rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
      rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
      rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
      rsUpper + '+' + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join('|'), 'g');

    /**
     * Splits a Unicode `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function unicodeWords$1(string) {
      return string.match(reUnicodeWord) || [];
    }

    var _unicodeWords = unicodeWords$1;

    var asciiWords = _asciiWords,
        hasUnicodeWord = _hasUnicodeWord,
        toString$2 = toString_1,
        unicodeWords = _unicodeWords;

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words$1(string, pattern, guard) {
      string = toString$2(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    var words_1 = words$1;

    var arrayReduce = _arrayReduce,
        deburr = deburr_1,
        words = words_1;

    /** Used to compose unicode capture groups. */
    var rsApos = "['\u2019]";

    /** Used to match apostrophes. */
    var reApos = RegExp(rsApos, 'g');

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder$1(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    var _createCompounder = createCompounder$1;

    var createCompounder = _createCompounder;

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    var kebabCase_1 = kebabCase;

    var css$7 = picostyle(h$4);
    var Fieldset = css$7('fieldset')({
      border: '0',
      padding: '0',
      margin: '0',
      'min-width': '0'
    });
    var Header = css$7('div')({
      display: 'flex',
      marginTop: '20px'
    });
    var Label = css$7('button')(function (props) {
      return {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        border: 'none',
        ':focus': {
          outline: 'none'
        },
        '> svg': __assign({
          transition: 'transform .2s',
          marginRight: '7px',
          transform: 'rotate(90deg)'
        }, props['aria-expanded'] && {
          transform: 'rotate(180deg)'
        })
      };
    });
    var LabelText = css$7('span')({
      borderBottom: '1px dotted',
      ':hover': {
        borderBottom: '1px solid'
      }
    });
    var Action = css$7('div')({
      marginLeft: 'auto',
      paddingLeft: '10px',
      fontSize: '14px',
      color: '#989797'
    });
    var Description = css$7('div')({
      fontSize: '14px',
      marginTop: '20px',
      paddingLeft: '15px'
    });
    function Accordion(_a) {
      var label = _a.label,
          description = _a.description,
          children = _a.children,
          expanded = _a.expanded,
          onClick = _a.onClick;
      var pairId = kebabCase_1(label);
      return h$4("div", null, h$4(Fieldset, null, h$4("legend", {
        class: "vh"
      }, label), h$4(Header, null, h$4(Label, {
        id: pairId + "-label",
        class: "cookie-consent-focusable",
        onClick: onClick,
        "aria-expanded": expanded,
        "aria-controls": pairId
      }, h$4(Caret, null), h$4(LabelText, null, label)), h$4(Action, null, children))), expanded && h$4(Description, {
        role: "region",
        id: pairId,
        "aria-labelledby": pairId + "-label"
      }, description));
    }

    function AccordionManager(_a) {
      var children = _a.children;

      var _b = m$3(null),
          active = _b[0],
          setActive = _b[1];

      return children.map(function (child, index) {
        return L(child, {
          onClick: function () {
            return setActive(active === index ? null : index);
          },
          expanded: active === index
        });
      });
    }

    function _extends() {
      _extends = Object.assign ? Object.assign.bind() : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      return _extends.apply(this, arguments);
    }

    var css$6 = picostyle(h$4);

    function primaryStyles(props) {
      return {
        backgroundColor: '#181818 !important',
        border: '2px solid #181818',
        color: '#fff',
        ':hover': __assign({
          backgroundColor: '#ffffff !important',
          borderColor: '#181818',
          color: '#181818'
        }, props.size === 'small' && {
          backgroundColor: '#181818',
          borderColor: '#181818',
          color: '#fff'
        })
      };
    }

    function secondaryStyles() {
      return {
        backgroundColor: 'transparent',
        border: '2px solid #181818',
        color: '#181818',
        ':hover': {
          backgroundColor: '#181818',
          borderColor: '#181818',
          color: '#fff'
        }
      };
    }

    function smallStyles() {
      return {
        padding: '6px 20px 2px',
        fontSize: '14px',
        fontWeight: 'normal',
        '@media (max-width: 410px)': {
          padding: '6px 10px 2px'
        }
      };
    }

    var ButtonStyles = function (props) {
      return __assign(__assign(__assign(__assign(__assign(__assign({
        margin: '0',
        fontFamily: 'GDPRGraphik, Graphik, Helvetica, Arial, sans-serif',
        lineHeight: '1.4',
        '-webkit-font-smoothing': 'inherit',
        '-moz-osx-font-smoothing': 'inherit',
        '-webkit-appearance': 'none',
        display: 'inline-block',
        borderRadius: '6px',
        padding: '12px 21px',
        '-webkit-text-decoration': 'none',
        textDecoration: 'none',
        textAlign: 'center',
        transition: 'all 200ms',
        cursor: 'pointer',
        flexShrink: '0',
        fontSize: '16px',
        fontWeight: 'bold',
        position: 'relative'
      }, props.width && {
        width: "" + props.width
      }), props.variant === 'primary' && primaryStyles(props)), props.variant === 'secondary' && secondaryStyles()), props.size === 'small' && smallStyles()), props.disabled && {
        pointerEvents: 'none',
        opacity: '0.4'
      }), props.error && {
        borderColor: '#ec7965'
      });
    };
    var ButtonElement = css$6('button')(ButtonStyles);
    function Button(_a) {
      var children = _a.children,
          onClick = _a.onClick,
          _b = _a.variant,
          variant = _b === void 0 ? 'primary' : _b,
          size = _a.size,
          rest = __rest(_a, ["children", "onClick", "variant", "size"]);

      return h$4(ButtonElement, _extends({
        class: "bold-focus " + (size ? "cookie-consent-button__" + size : ''),
        onClick: onClick,
        type: "button",
        variant: variant,
        size: size
      }, rest), children);
    }

    var ConsentModeContext = M('consent-required');

    var fails$a = function (exec) {
      try {
        return !!exec();
      } catch (error) {
        return true;
      }
    };

    var fails$9 = fails$a;

    var functionBindNative = !fails$9(function () {
      // eslint-disable-next-line es/no-function-prototype-bind -- safe
      var test = (function () { /* empty */ }).bind();
      // eslint-disable-next-line no-prototype-builtins -- safe
      return typeof test != 'function' || test.hasOwnProperty('prototype');
    });

    var NATIVE_BIND$2 = functionBindNative;

    var FunctionPrototype$1 = Function.prototype;
    var call$8 = FunctionPrototype$1.call;
    var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$1.bind.bind(call$8, call$8);

    var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
      return function () {
        return call$8.apply(fn, arguments);
      };
    };

    var uncurryThis$b = functionUncurryThis;

    var toString$1 = uncurryThis$b({}.toString);
    var stringSlice$1 = uncurryThis$b(''.slice);

    var classofRaw$2 = function (it) {
      return stringSlice$1(toString$1(it), 8, -1);
    };

    var uncurryThis$a = functionUncurryThis;
    var fails$8 = fails$a;
    var classof$2 = classofRaw$2;

    var $Object$4 = Object;
    var split = uncurryThis$a(''.split);

    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var indexedObject = fails$8(function () {
      // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
      // eslint-disable-next-line no-prototype-builtins -- safe
      return !$Object$4('z').propertyIsEnumerable(0);
    }) ? function (it) {
      return classof$2(it) == 'String' ? split(it, '') : $Object$4(it);
    } : $Object$4;

    // we can't use just `it == null` since of `document.all` special case
    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
    var isNullOrUndefined$3 = function (it) {
      return it === null || it === undefined;
    };

    var isNullOrUndefined$2 = isNullOrUndefined$3;

    var $TypeError$8 = TypeError;

    // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible$2 = function (it) {
      if (isNullOrUndefined$2(it)) throw $TypeError$8("Can't call method on " + it);
      return it;
    };

    // toObject with fallback for non-array-like ES3 strings
    var IndexedObject = indexedObject;
    var requireObjectCoercible$1 = requireObjectCoercible$2;

    var toIndexedObject$5 = function (it) {
      return IndexedObject(requireObjectCoercible$1(it));
    };

    var check = function (it) {
      return it && it.Math == Math && it;
    };

    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global$c =
      // eslint-disable-next-line es/no-global-this -- safe
      check(typeof globalThis == 'object' && globalThis) ||
      check(typeof window == 'object' && window) ||
      // eslint-disable-next-line no-restricted-globals -- safe
      check(typeof self == 'object' && self) ||
      check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
      // eslint-disable-next-line no-new-func -- fallback
      (function () { return this; })() || Function('return this')();

    var shared$3 = {exports: {}};

    var global$b = global$c;

    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty$4 = Object.defineProperty;

    var defineGlobalProperty$3 = function (key, value) {
      try {
        defineProperty$4(global$b, key, { value: value, configurable: true, writable: true });
      } catch (error) {
        global$b[key] = value;
      } return value;
    };

    var global$a = global$c;
    var defineGlobalProperty$2 = defineGlobalProperty$3;

    var SHARED = '__core-js_shared__';
    var store$3 = global$a[SHARED] || defineGlobalProperty$2(SHARED, {});

    var sharedStore = store$3;

    var store$2 = sharedStore;

    (shared$3.exports = function (key, value) {
      return store$2[key] || (store$2[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: '3.27.2',
      mode: 'global',
      copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
      license: 'https://github.com/zloirock/core-js/blob/v3.27.2/LICENSE',
      source: 'https://github.com/zloirock/core-js'
    });

    var requireObjectCoercible = requireObjectCoercible$2;

    var $Object$3 = Object;

    // `ToObject` abstract operation
    // https://tc39.es/ecma262/#sec-toobject
    var toObject$2 = function (argument) {
      return $Object$3(requireObjectCoercible(argument));
    };

    var uncurryThis$9 = functionUncurryThis;
    var toObject$1 = toObject$2;

    var hasOwnProperty = uncurryThis$9({}.hasOwnProperty);

    // `HasOwnProperty` abstract operation
    // https://tc39.es/ecma262/#sec-hasownproperty
    // eslint-disable-next-line es/no-object-hasown -- safe
    var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
      return hasOwnProperty(toObject$1(it), key);
    };

    var uncurryThis$8 = functionUncurryThis;

    var id = 0;
    var postfix = Math.random();
    var toString = uncurryThis$8(1.0.toString);

    var uid$2 = function (key) {
      return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
    };

    var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

    var global$9 = global$c;
    var userAgent = engineUserAgent;

    var process = global$9.process;
    var Deno = global$9.Deno;
    var versions = process && process.versions || Deno && Deno.version;
    var v8 = versions && versions.v8;
    var match, version;

    if (v8) {
      match = v8.split('.');
      // in old Chrome, versions of V8 isn't V8 = Chrome / 10
      // but their correct versions are not interesting for us
      version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
    }

    // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
    // so check `userAgent` even if `.v8` exists, but 0
    if (!version && userAgent) {
      match = userAgent.match(/Edge\/(\d+)/);
      if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
      }
    }

    var engineV8Version = version;

    /* eslint-disable es/no-symbol -- required for testing */

    var V8_VERSION = engineV8Version;
    var fails$7 = fails$a;

    // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
    var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$7(function () {
      var symbol = Symbol();
      // Chrome 38 Symbol has incorrect toString conversion
      // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
      return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
        // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
        !Symbol.sham && V8_VERSION && V8_VERSION < 41;
    });

    /* eslint-disable es/no-symbol -- required for testing */

    var NATIVE_SYMBOL$1 = symbolConstructorDetection;

    var useSymbolAsUid = NATIVE_SYMBOL$1
      && !Symbol.sham
      && typeof Symbol.iterator == 'symbol';

    var global$8 = global$c;
    var shared$2 = shared$3.exports;
    var hasOwn$8 = hasOwnProperty_1;
    var uid$1 = uid$2;
    var NATIVE_SYMBOL = symbolConstructorDetection;
    var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

    var Symbol$1 = global$8.Symbol;
    var WellKnownSymbolsStore = shared$2('wks');
    var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

    var wellKnownSymbol$a = function (name) {
      if (!hasOwn$8(WellKnownSymbolsStore, name)) {
        WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$8(Symbol$1, name)
          ? Symbol$1[name]
          : createWellKnownSymbol('Symbol.' + name);
      } return WellKnownSymbolsStore[name];
    };

    var documentAll$2 = typeof document == 'object' && document.all;

    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
    // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
    var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

    var documentAll_1 = {
      all: documentAll$2,
      IS_HTMLDDA: IS_HTMLDDA
    };

    var $documentAll$1 = documentAll_1;

    var documentAll$1 = $documentAll$1.all;

    // `IsCallable` abstract operation
    // https://tc39.es/ecma262/#sec-iscallable
    var isCallable$f = $documentAll$1.IS_HTMLDDA ? function (argument) {
      return typeof argument == 'function' || argument === documentAll$1;
    } : function (argument) {
      return typeof argument == 'function';
    };

    var isCallable$e = isCallable$f;
    var $documentAll = documentAll_1;

    var documentAll = $documentAll.all;

    var isObject$6 = $documentAll.IS_HTMLDDA ? function (it) {
      return typeof it == 'object' ? it !== null : isCallable$e(it) || it === documentAll;
    } : function (it) {
      return typeof it == 'object' ? it !== null : isCallable$e(it);
    };

    var isObject$5 = isObject$6;

    var $String$3 = String;
    var $TypeError$7 = TypeError;

    // `Assert: Type(argument) is Object`
    var anObject$8 = function (argument) {
      if (isObject$5(argument)) return argument;
      throw $TypeError$7($String$3(argument) + ' is not an object');
    };

    var objectDefineProperties = {};

    var fails$6 = fails$a;

    // Detect IE8's incomplete defineProperty implementation
    var descriptors = !fails$6(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
    });

    var DESCRIPTORS$8 = descriptors;
    var fails$5 = fails$a;

    // V8 ~ Chrome 36-
    // https://bugs.chromium.org/p/v8/issues/detail?id=3334
    var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$5(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty(function () { /* empty */ }, 'prototype', {
        value: 42,
        writable: false
      }).prototype != 42;
    });

    var objectDefineProperty = {};

    var global$7 = global$c;
    var isObject$4 = isObject$6;

    var document$1 = global$7.document;
    // typeof document.createElement is 'object' in old IE
    var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

    var documentCreateElement$2 = function (it) {
      return EXISTS$1 ? document$1.createElement(it) : {};
    };

    var DESCRIPTORS$7 = descriptors;
    var fails$4 = fails$a;
    var createElement$1 = documentCreateElement$2;

    // Thanks to IE8 for its funny defineProperty
    var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty(createElement$1('div'), 'a', {
        get: function () { return 7; }
      }).a != 7;
    });

    var NATIVE_BIND$1 = functionBindNative;

    var call$7 = Function.prototype.call;

    var functionCall = NATIVE_BIND$1 ? call$7.bind(call$7) : function () {
      return call$7.apply(call$7, arguments);
    };

    var global$6 = global$c;
    var isCallable$d = isCallable$f;

    var aFunction = function (argument) {
      return isCallable$d(argument) ? argument : undefined;
    };

    var getBuiltIn$3 = function (namespace, method) {
      return arguments.length < 2 ? aFunction(global$6[namespace]) : global$6[namespace] && global$6[namespace][method];
    };

    var uncurryThis$7 = functionUncurryThis;

    var objectIsPrototypeOf = uncurryThis$7({}.isPrototypeOf);

    var getBuiltIn$2 = getBuiltIn$3;
    var isCallable$c = isCallable$f;
    var isPrototypeOf$1 = objectIsPrototypeOf;
    var USE_SYMBOL_AS_UID = useSymbolAsUid;

    var $Object$2 = Object;

    var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
      return typeof it == 'symbol';
    } : function (it) {
      var $Symbol = getBuiltIn$2('Symbol');
      return isCallable$c($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$2(it));
    };

    var $String$2 = String;

    var tryToString$3 = function (argument) {
      try {
        return $String$2(argument);
      } catch (error) {
        return 'Object';
      }
    };

    var isCallable$b = isCallable$f;
    var tryToString$2 = tryToString$3;

    var $TypeError$6 = TypeError;

    // `Assert: IsCallable(argument) is true`
    var aCallable$3 = function (argument) {
      if (isCallable$b(argument)) return argument;
      throw $TypeError$6(tryToString$2(argument) + ' is not a function');
    };

    var aCallable$2 = aCallable$3;
    var isNullOrUndefined$1 = isNullOrUndefined$3;

    // `GetMethod` abstract operation
    // https://tc39.es/ecma262/#sec-getmethod
    var getMethod$3 = function (V, P) {
      var func = V[P];
      return isNullOrUndefined$1(func) ? undefined : aCallable$2(func);
    };

    var call$6 = functionCall;
    var isCallable$a = isCallable$f;
    var isObject$3 = isObject$6;

    var $TypeError$5 = TypeError;

    // `OrdinaryToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-ordinarytoprimitive
    var ordinaryToPrimitive$1 = function (input, pref) {
      var fn, val;
      if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$3(val = call$6(fn, input))) return val;
      if (isCallable$a(fn = input.valueOf) && !isObject$3(val = call$6(fn, input))) return val;
      if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$3(val = call$6(fn, input))) return val;
      throw $TypeError$5("Can't convert object to primitive value");
    };

    var call$5 = functionCall;
    var isObject$2 = isObject$6;
    var isSymbol$1 = isSymbol$2;
    var getMethod$2 = getMethod$3;
    var ordinaryToPrimitive = ordinaryToPrimitive$1;
    var wellKnownSymbol$9 = wellKnownSymbol$a;

    var $TypeError$4 = TypeError;
    var TO_PRIMITIVE = wellKnownSymbol$9('toPrimitive');

    // `ToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-toprimitive
    var toPrimitive$1 = function (input, pref) {
      if (!isObject$2(input) || isSymbol$1(input)) return input;
      var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
      var result;
      if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = call$5(exoticToPrim, input, pref);
        if (!isObject$2(result) || isSymbol$1(result)) return result;
        throw $TypeError$4("Can't convert object to primitive value");
      }
      if (pref === undefined) pref = 'number';
      return ordinaryToPrimitive(input, pref);
    };

    var toPrimitive = toPrimitive$1;
    var isSymbol = isSymbol$2;

    // `ToPropertyKey` abstract operation
    // https://tc39.es/ecma262/#sec-topropertykey
    var toPropertyKey$3 = function (argument) {
      var key = toPrimitive(argument, 'string');
      return isSymbol(key) ? key : key + '';
    };

    var DESCRIPTORS$6 = descriptors;
    var IE8_DOM_DEFINE$1 = ie8DomDefine;
    var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
    var anObject$7 = anObject$8;
    var toPropertyKey$2 = toPropertyKey$3;

    var $TypeError$3 = TypeError;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var $defineProperty = Object.defineProperty;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
    var ENUMERABLE = 'enumerable';
    var CONFIGURABLE$1 = 'configurable';
    var WRITABLE = 'writable';

    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    objectDefineProperty.f = DESCRIPTORS$6 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
      anObject$7(O);
      P = toPropertyKey$2(P);
      anObject$7(Attributes);
      if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor$1(O, P);
        if (current && current[WRITABLE]) {
          O[P] = Attributes.value;
          Attributes = {
            configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
            enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
            writable: false
          };
        }
      } return $defineProperty(O, P, Attributes);
    } : $defineProperty : function defineProperty(O, P, Attributes) {
      anObject$7(O);
      P = toPropertyKey$2(P);
      anObject$7(Attributes);
      if (IE8_DOM_DEFINE$1) try {
        return $defineProperty(O, P, Attributes);
      } catch (error) { /* empty */ }
      if ('get' in Attributes || 'set' in Attributes) throw $TypeError$3('Accessors not supported');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

    var ceil = Math.ceil;
    var floor = Math.floor;

    // `Math.trunc` method
    // https://tc39.es/ecma262/#sec-math.trunc
    // eslint-disable-next-line es/no-math-trunc -- safe
    var mathTrunc = Math.trunc || function trunc(x) {
      var n = +x;
      return (n > 0 ? floor : ceil)(n);
    };

    var trunc = mathTrunc;

    // `ToIntegerOrInfinity` abstract operation
    // https://tc39.es/ecma262/#sec-tointegerorinfinity
    var toIntegerOrInfinity$2 = function (argument) {
      var number = +argument;
      // eslint-disable-next-line no-self-compare -- NaN check
      return number !== number || number === 0 ? 0 : trunc(number);
    };

    var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

    var max = Math.max;
    var min$1 = Math.min;

    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
    var toAbsoluteIndex$1 = function (index, length) {
      var integer = toIntegerOrInfinity$1(index);
      return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
    };

    var toIntegerOrInfinity = toIntegerOrInfinity$2;

    var min = Math.min;

    // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength
    var toLength$1 = function (argument) {
      return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    var toLength = toLength$1;

    // `LengthOfArrayLike` abstract operation
    // https://tc39.es/ecma262/#sec-lengthofarraylike
    var lengthOfArrayLike$2 = function (obj) {
      return toLength(obj.length);
    };

    var toIndexedObject$4 = toIndexedObject$5;
    var toAbsoluteIndex = toAbsoluteIndex$1;
    var lengthOfArrayLike$1 = lengthOfArrayLike$2;

    // `Array.prototype.{ indexOf, includes }` methods implementation
    var createMethod = function (IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIndexedObject$4($this);
        var length = lengthOfArrayLike$1(O);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare -- NaN check
          if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        } else for (;length > index; index++) {
          if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        } return !IS_INCLUDES && -1;
      };
    };

    var arrayIncludes = {
      // `Array.prototype.includes` method
      // https://tc39.es/ecma262/#sec-array.prototype.includes
      includes: createMethod(true),
      // `Array.prototype.indexOf` method
      // https://tc39.es/ecma262/#sec-array.prototype.indexof
      indexOf: createMethod(false)
    };

    var hiddenKeys$4 = {};

    var uncurryThis$6 = functionUncurryThis;
    var hasOwn$7 = hasOwnProperty_1;
    var toIndexedObject$3 = toIndexedObject$5;
    var indexOf = arrayIncludes.indexOf;
    var hiddenKeys$3 = hiddenKeys$4;

    var push = uncurryThis$6([].push);

    var objectKeysInternal = function (object, names) {
      var O = toIndexedObject$3(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) !hasOwn$7(hiddenKeys$3, key) && hasOwn$7(O, key) && push(result, key);
      // Don't enum bug & hidden keys
      while (names.length > i) if (hasOwn$7(O, key = names[i++])) {
        ~indexOf(result, key) || push(result, key);
      }
      return result;
    };

    // IE8- don't enum bug keys
    var enumBugKeys$3 = [
      'constructor',
      'hasOwnProperty',
      'isPrototypeOf',
      'propertyIsEnumerable',
      'toLocaleString',
      'toString',
      'valueOf'
    ];

    var internalObjectKeys$1 = objectKeysInternal;
    var enumBugKeys$2 = enumBugKeys$3;

    // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    // eslint-disable-next-line es/no-object-keys -- safe
    var objectKeys$1 = Object.keys || function keys(O) {
      return internalObjectKeys$1(O, enumBugKeys$2);
    };

    var DESCRIPTORS$5 = descriptors;
    var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
    var definePropertyModule$4 = objectDefineProperty;
    var anObject$6 = anObject$8;
    var toIndexedObject$2 = toIndexedObject$5;
    var objectKeys = objectKeys$1;

    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    // eslint-disable-next-line es/no-object-defineproperties -- safe
    objectDefineProperties.f = DESCRIPTORS$5 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject$6(O);
      var props = toIndexedObject$2(Properties);
      var keys = objectKeys(Properties);
      var length = keys.length;
      var index = 0;
      var key;
      while (length > index) definePropertyModule$4.f(O, key = keys[index++], props[key]);
      return O;
    };

    var getBuiltIn$1 = getBuiltIn$3;

    var html$1 = getBuiltIn$1('document', 'documentElement');

    var shared$1 = shared$3.exports;
    var uid = uid$2;

    var keys = shared$1('keys');

    var sharedKey$3 = function (key) {
      return keys[key] || (keys[key] = uid(key));
    };

    /* global ActiveXObject -- old IE, WSH */

    var anObject$5 = anObject$8;
    var definePropertiesModule = objectDefineProperties;
    var enumBugKeys$1 = enumBugKeys$3;
    var hiddenKeys$2 = hiddenKeys$4;
    var html = html$1;
    var documentCreateElement$1 = documentCreateElement$2;
    var sharedKey$2 = sharedKey$3;

    var GT = '>';
    var LT = '<';
    var PROTOTYPE = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO$1 = sharedKey$2('IE_PROTO');

    var EmptyConstructor = function () { /* empty */ };

    var scriptTag = function (content) {
      return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    };

    // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
    var NullProtoObjectViaActiveX = function (activeXDocument) {
      activeXDocument.write(scriptTag(''));
      activeXDocument.close();
      var temp = activeXDocument.parentWindow.Object;
      activeXDocument = null; // avoid memory leak
      return temp;
    };

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var NullProtoObjectViaIFrame = function () {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = documentCreateElement$1('iframe');
      var JS = 'java' + SCRIPT + ':';
      var iframeDocument;
      iframe.style.display = 'none';
      html.appendChild(iframe);
      // https://github.com/zloirock/core-js/issues/475
      iframe.src = String(JS);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(scriptTag('document.F=Object'));
      iframeDocument.close();
      return iframeDocument.F;
    };

    // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug
    var activeXDocument;
    var NullProtoObject = function () {
      try {
        activeXDocument = new ActiveXObject('htmlfile');
      } catch (error) { /* ignore */ }
      NullProtoObject = typeof document != 'undefined'
        ? document.domain && activeXDocument
          ? NullProtoObjectViaActiveX(activeXDocument) // old IE
          : NullProtoObjectViaIFrame()
        : NullProtoObjectViaActiveX(activeXDocument); // WSH
      var length = enumBugKeys$1.length;
      while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
      return NullProtoObject();
    };

    hiddenKeys$2[IE_PROTO$1] = true;

    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    // eslint-disable-next-line es/no-object-create -- safe
    var objectCreate = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject$5(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO$1] = O;
      } else result = NullProtoObject();
      return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
    };

    var wellKnownSymbol$8 = wellKnownSymbol$a;
    var create$1 = objectCreate;
    var defineProperty$3 = objectDefineProperty.f;

    var UNSCOPABLES = wellKnownSymbol$8('unscopables');
    var ArrayPrototype$1 = Array.prototype;

    // Array.prototype[@@unscopables]
    // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
    if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
      defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
        configurable: true,
        value: create$1(null)
      });
    }

    // add a key to Array.prototype[@@unscopables]
    var addToUnscopables$1 = function (key) {
      ArrayPrototype$1[UNSCOPABLES][key] = true;
    };

    var iterators = {};

    var global$5 = global$c;
    var isCallable$9 = isCallable$f;

    var WeakMap$1 = global$5.WeakMap;

    var weakMapBasicDetection = isCallable$9(WeakMap$1) && /native code/.test(String(WeakMap$1));

    var createPropertyDescriptor$4 = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };

    var DESCRIPTORS$4 = descriptors;
    var definePropertyModule$3 = objectDefineProperty;
    var createPropertyDescriptor$3 = createPropertyDescriptor$4;

    var createNonEnumerableProperty$4 = DESCRIPTORS$4 ? function (object, key, value) {
      return definePropertyModule$3.f(object, key, createPropertyDescriptor$3(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };

    var NATIVE_WEAK_MAP = weakMapBasicDetection;
    var global$4 = global$c;
    var isObject$1 = isObject$6;
    var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
    var hasOwn$6 = hasOwnProperty_1;
    var shared = sharedStore;
    var sharedKey$1 = sharedKey$3;
    var hiddenKeys$1 = hiddenKeys$4;

    var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
    var TypeError$1 = global$4.TypeError;
    var WeakMap = global$4.WeakMap;
    var set, get, has;

    var enforce = function (it) {
      return has(it) ? get(it) : set(it, {});
    };

    var getterFor = function (TYPE) {
      return function (it) {
        var state;
        if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
          throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
        } return state;
      };
    };

    if (NATIVE_WEAK_MAP || shared.state) {
      var store$1 = shared.state || (shared.state = new WeakMap());
      /* eslint-disable no-self-assign -- prototype methods protection */
      store$1.get = store$1.get;
      store$1.has = store$1.has;
      store$1.set = store$1.set;
      /* eslint-enable no-self-assign -- prototype methods protection */
      set = function (it, metadata) {
        if (store$1.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store$1.set(it, metadata);
        return metadata;
      };
      get = function (it) {
        return store$1.get(it) || {};
      };
      has = function (it) {
        return store$1.has(it);
      };
    } else {
      var STATE = sharedKey$1('state');
      hiddenKeys$1[STATE] = true;
      set = function (it, metadata) {
        if (hasOwn$6(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty$3(it, STATE, metadata);
        return metadata;
      };
      get = function (it) {
        return hasOwn$6(it, STATE) ? it[STATE] : {};
      };
      has = function (it) {
        return hasOwn$6(it, STATE);
      };
    }

    var internalState = {
      set: set,
      get: get,
      has: has,
      enforce: enforce,
      getterFor: getterFor
    };

    var objectGetOwnPropertyDescriptor = {};

    var objectPropertyIsEnumerable = {};

    var $propertyIsEnumerable = {}.propertyIsEnumerable;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

    // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
    objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
      var descriptor = getOwnPropertyDescriptor$1(this, V);
      return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable;

    var DESCRIPTORS$3 = descriptors;
    var call$4 = functionCall;
    var propertyIsEnumerableModule = objectPropertyIsEnumerable;
    var createPropertyDescriptor$2 = createPropertyDescriptor$4;
    var toIndexedObject$1 = toIndexedObject$5;
    var toPropertyKey$1 = toPropertyKey$3;
    var hasOwn$5 = hasOwnProperty_1;
    var IE8_DOM_DEFINE = ie8DomDefine;

    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
    objectGetOwnPropertyDescriptor.f = DESCRIPTORS$3 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
      O = toIndexedObject$1(O);
      P = toPropertyKey$1(P);
      if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
      } catch (error) { /* empty */ }
      if (hasOwn$5(O, P)) return createPropertyDescriptor$2(!call$4(propertyIsEnumerableModule.f, O, P), O[P]);
    };

    var makeBuiltIn$2 = {exports: {}};

    var DESCRIPTORS$2 = descriptors;
    var hasOwn$4 = hasOwnProperty_1;

    var FunctionPrototype = Function.prototype;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

    var EXISTS = hasOwn$4(FunctionPrototype, 'name');
    // additional protection from minified / mangled / dropped function names
    var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
    var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));

    var functionName = {
      EXISTS: EXISTS,
      PROPER: PROPER,
      CONFIGURABLE: CONFIGURABLE
    };

    var uncurryThis$5 = functionUncurryThis;
    var isCallable$8 = isCallable$f;
    var store = sharedStore;

    var functionToString = uncurryThis$5(Function.toString);

    // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
    if (!isCallable$8(store.inspectSource)) {
      store.inspectSource = function (it) {
        return functionToString(it);
      };
    }

    var inspectSource$1 = store.inspectSource;

    var uncurryThis$4 = functionUncurryThis;
    var fails$3 = fails$a;
    var isCallable$7 = isCallable$f;
    var hasOwn$3 = hasOwnProperty_1;
    var DESCRIPTORS$1 = descriptors;
    var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
    var inspectSource = inspectSource$1;
    var InternalStateModule$1 = internalState;

    var enforceInternalState = InternalStateModule$1.enforce;
    var getInternalState$1 = InternalStateModule$1.get;
    var $String$1 = String;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty$2 = Object.defineProperty;
    var stringSlice = uncurryThis$4(''.slice);
    var replace = uncurryThis$4(''.replace);
    var join = uncurryThis$4([].join);

    var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$3(function () {
      return defineProperty$2(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
    });

    var TEMPLATE = String(String).split('String');

    var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
      if (stringSlice($String$1(name), 0, 7) === 'Symbol(') {
        name = '[' + replace($String$1(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
      }
      if (options && options.getter) name = 'get ' + name;
      if (options && options.setter) name = 'set ' + name;
      if (!hasOwn$3(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
        if (DESCRIPTORS$1) defineProperty$2(value, 'name', { value: name, configurable: true });
        else value.name = name;
      }
      if (CONFIGURABLE_LENGTH && options && hasOwn$3(options, 'arity') && value.length !== options.arity) {
        defineProperty$2(value, 'length', { value: options.arity });
      }
      try {
        if (options && hasOwn$3(options, 'constructor') && options.constructor) {
          if (DESCRIPTORS$1) defineProperty$2(value, 'prototype', { writable: false });
        // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
        } else if (value.prototype) value.prototype = undefined;
      } catch (error) { /* empty */ }
      var state = enforceInternalState(value);
      if (!hasOwn$3(state, 'source')) {
        state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
      } return value;
    };

    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    // eslint-disable-next-line no-extend-native -- required
    Function.prototype.toString = makeBuiltIn$1(function toString() {
      return isCallable$7(this) && getInternalState$1(this).source || inspectSource(this);
    }, 'toString');

    var isCallable$6 = isCallable$f;
    var definePropertyModule$2 = objectDefineProperty;
    var makeBuiltIn = makeBuiltIn$2.exports;
    var defineGlobalProperty$1 = defineGlobalProperty$3;

    var defineBuiltIn$3 = function (O, key, value, options) {
      if (!options) options = {};
      var simple = options.enumerable;
      var name = options.name !== undefined ? options.name : key;
      if (isCallable$6(value)) makeBuiltIn(value, name, options);
      if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty$1(key, value);
      } else {
        try {
          if (!options.unsafe) delete O[key];
          else if (O[key]) simple = true;
        } catch (error) { /* empty */ }
        if (simple) O[key] = value;
        else definePropertyModule$2.f(O, key, {
          value: value,
          enumerable: false,
          configurable: !options.nonConfigurable,
          writable: !options.nonWritable
        });
      } return O;
    };

    var objectGetOwnPropertyNames = {};

    var internalObjectKeys = objectKeysInternal;
    var enumBugKeys = enumBugKeys$3;

    var hiddenKeys = enumBugKeys.concat('length', 'prototype');

    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    // eslint-disable-next-line es/no-object-getownpropertynames -- safe
    objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return internalObjectKeys(O, hiddenKeys);
    };

    var objectGetOwnPropertySymbols = {};

    // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
    objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

    var getBuiltIn = getBuiltIn$3;
    var uncurryThis$3 = functionUncurryThis;
    var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
    var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
    var anObject$4 = anObject$8;

    var concat = uncurryThis$3([].concat);

    // all object keys, includes non-enumerable and symbols
    var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
      var keys = getOwnPropertyNamesModule.f(anObject$4(it));
      var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
      return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
    };

    var hasOwn$2 = hasOwnProperty_1;
    var ownKeys = ownKeys$1;
    var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
    var definePropertyModule$1 = objectDefineProperty;

    var copyConstructorProperties$1 = function (target, source, exceptions) {
      var keys = ownKeys(source);
      var defineProperty = definePropertyModule$1.f;
      var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!hasOwn$2(target, key) && !(exceptions && hasOwn$2(exceptions, key))) {
          defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
      }
    };

    var fails$2 = fails$a;
    var isCallable$5 = isCallable$f;

    var replacement = /#|\.prototype\./;

    var isForced$1 = function (feature, detection) {
      var value = data[normalize(feature)];
      return value == POLYFILL ? true
        : value == NATIVE ? false
        : isCallable$5(detection) ? fails$2(detection)
        : !!detection;
    };

    var normalize = isForced$1.normalize = function (string) {
      return String(string).replace(replacement, '.').toLowerCase();
    };

    var data = isForced$1.data = {};
    var NATIVE = isForced$1.NATIVE = 'N';
    var POLYFILL = isForced$1.POLYFILL = 'P';

    var isForced_1 = isForced$1;

    var global$3 = global$c;
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
    var defineBuiltIn$2 = defineBuiltIn$3;
    var defineGlobalProperty = defineGlobalProperty$3;
    var copyConstructorProperties = copyConstructorProperties$1;
    var isForced = isForced_1;

    /*
      options.target         - name of the target object
      options.global         - target is the global object
      options.stat           - export as static methods of target
      options.proto          - export as prototype methods of target
      options.real           - real prototype method for the `pure` version
      options.forced         - export even if the native feature is available
      options.bind           - bind methods to the target, required for the `pure` version
      options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
      options.unsafe         - use the simple assignment of property instead of delete + defineProperty
      options.sham           - add a flag to not completely full polyfills
      options.enumerable     - export as enumerable property
      options.dontCallGetSet - prevent calling a getter on target
      options.name           - the .name of the function if it does not match the key
    */
    var _export = function (options, source) {
      var TARGET = options.target;
      var GLOBAL = options.global;
      var STATIC = options.stat;
      var FORCED, target, key, targetProperty, sourceProperty, descriptor;
      if (GLOBAL) {
        target = global$3;
      } else if (STATIC) {
        target = global$3[TARGET] || defineGlobalProperty(TARGET, {});
      } else {
        target = (global$3[TARGET] || {}).prototype;
      }
      if (target) for (key in source) {
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
          descriptor = getOwnPropertyDescriptor(target, key);
          targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
          if (typeof sourceProperty == typeof targetProperty) continue;
          copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || (targetProperty && targetProperty.sham)) {
          createNonEnumerableProperty$2(sourceProperty, 'sham', true);
        }
        defineBuiltIn$2(target, key, sourceProperty, options);
      }
    };

    var fails$1 = fails$a;

    var correctPrototypeGetter = !fails$1(function () {
      function F() { /* empty */ }
      F.prototype.constructor = null;
      // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
      return Object.getPrototypeOf(new F()) !== F.prototype;
    });

    var hasOwn$1 = hasOwnProperty_1;
    var isCallable$4 = isCallable$f;
    var toObject = toObject$2;
    var sharedKey = sharedKey$3;
    var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

    var IE_PROTO = sharedKey('IE_PROTO');
    var $Object$1 = Object;
    var ObjectPrototype = $Object$1.prototype;

    // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof
    // eslint-disable-next-line es/no-object-getprototypeof -- safe
    var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
      var object = toObject(O);
      if (hasOwn$1(object, IE_PROTO)) return object[IE_PROTO];
      var constructor = object.constructor;
      if (isCallable$4(constructor) && object instanceof constructor) {
        return constructor.prototype;
      } return object instanceof $Object$1 ? ObjectPrototype : null;
    };

    var fails = fails$a;
    var isCallable$3 = isCallable$f;
    var isObject = isObject$6;
    var getPrototypeOf$1 = objectGetPrototypeOf;
    var defineBuiltIn$1 = defineBuiltIn$3;
    var wellKnownSymbol$7 = wellKnownSymbol$a;

    var ITERATOR$4 = wellKnownSymbol$7('iterator');
    var BUGGY_SAFARI_ITERATORS$1 = false;

    // `%IteratorPrototype%` object
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
    var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

    /* eslint-disable es/no-array-prototype-keys -- safe */
    if ([].keys) {
      arrayIterator = [].keys();
      // Safari 8 has buggy iterators w/o `next`
      if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
      else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
      }
    }

    var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
      var test = {};
      // FF44- legacy iterators case
      return IteratorPrototype$2[ITERATOR$4].call(test) !== test;
    });

    if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

    // `%IteratorPrototype%[@@iterator]()` method
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
    if (!isCallable$3(IteratorPrototype$2[ITERATOR$4])) {
      defineBuiltIn$1(IteratorPrototype$2, ITERATOR$4, function () {
        return this;
      });
    }

    var iteratorsCore = {
      IteratorPrototype: IteratorPrototype$2,
      BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
    };

    var defineProperty$1 = objectDefineProperty.f;
    var hasOwn = hasOwnProperty_1;
    var wellKnownSymbol$6 = wellKnownSymbol$a;

    var TO_STRING_TAG$3 = wellKnownSymbol$6('toStringTag');

    var setToStringTag$2 = function (target, TAG, STATIC) {
      if (target && !STATIC) target = target.prototype;
      if (target && !hasOwn(target, TO_STRING_TAG$3)) {
        defineProperty$1(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
      }
    };

    var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
    var create = objectCreate;
    var createPropertyDescriptor$1 = createPropertyDescriptor$4;
    var setToStringTag$1 = setToStringTag$2;
    var Iterators$4 = iterators;

    var returnThis$1 = function () { return this; };

    var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
      var TO_STRING_TAG = NAME + ' Iterator';
      IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
      setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
      Iterators$4[TO_STRING_TAG] = returnThis$1;
      return IteratorConstructor;
    };

    var isCallable$2 = isCallable$f;

    var $String = String;
    var $TypeError$2 = TypeError;

    var aPossiblePrototype$1 = function (argument) {
      if (typeof argument == 'object' || isCallable$2(argument)) return argument;
      throw $TypeError$2("Can't set " + $String(argument) + ' as a prototype');
    };

    /* eslint-disable no-proto -- safe */

    var uncurryThis$2 = functionUncurryThis;
    var anObject$3 = anObject$8;
    var aPossiblePrototype = aPossiblePrototype$1;

    // `Object.setPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.setprototypeof
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    // eslint-disable-next-line es/no-object-setprototypeof -- safe
    var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
      var CORRECT_SETTER = false;
      var test = {};
      var setter;
      try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        setter = uncurryThis$2(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
      } catch (error) { /* empty */ }
      return function setPrototypeOf(O, proto) {
        anObject$3(O);
        aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
      };
    }() : undefined);

    var $$2 = _export;
    var call$3 = functionCall;
    var FunctionName = functionName;
    var isCallable$1 = isCallable$f;
    var createIteratorConstructor = iteratorCreateConstructor;
    var getPrototypeOf = objectGetPrototypeOf;
    var setPrototypeOf = objectSetPrototypeOf;
    var setToStringTag = setToStringTag$2;
    var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
    var defineBuiltIn = defineBuiltIn$3;
    var wellKnownSymbol$5 = wellKnownSymbol$a;
    var Iterators$3 = iterators;
    var IteratorsCore = iteratorsCore;

    var PROPER_FUNCTION_NAME = FunctionName.PROPER;
    var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
    var IteratorPrototype = IteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
    var ITERATOR$3 = wellKnownSymbol$5('iterator');
    var KEYS = 'keys';
    var VALUES = 'values';
    var ENTRIES = 'entries';

    var returnThis = function () { return this; };

    var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
      createIteratorConstructor(IteratorConstructor, NAME, next);

      var getIterationMethod = function (KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch (KIND) {
          case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
          case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
          case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
        } return function () { return new IteratorConstructor(this); };
      };

      var TO_STRING_TAG = NAME + ' Iterator';
      var INCORRECT_VALUES_NAME = false;
      var IterablePrototype = Iterable.prototype;
      var nativeIterator = IterablePrototype[ITERATOR$3]
        || IterablePrototype['@@iterator']
        || DEFAULT && IterablePrototype[DEFAULT];
      var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
      var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
      var CurrentIteratorPrototype, methods, KEY;

      // fix native
      if (anyNativeIterator) {
        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
          if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
            if (setPrototypeOf) {
              setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
            } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$3])) {
              defineBuiltIn(CurrentIteratorPrototype, ITERATOR$3, returnThis);
            }
          }
          // Set @@toStringTag to native iterators
          setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
      }

      // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
      if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        if (CONFIGURABLE_FUNCTION_NAME) {
          createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
        } else {
          INCORRECT_VALUES_NAME = true;
          defaultIterator = function values() { return call$3(nativeIterator, this); };
        }
      }

      // export additional methods
      if (DEFAULT) {
        methods = {
          values: getIterationMethod(VALUES),
          keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
          entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) for (KEY in methods) {
          if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
            defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
          }
        } else $$2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
      }

      // define iterator
      if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
        defineBuiltIn(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
      }
      Iterators$3[NAME] = defaultIterator;

      return methods;
    };

    // `CreateIterResultObject` abstract operation
    // https://tc39.es/ecma262/#sec-createiterresultobject
    var createIterResultObject$1 = function (value, done) {
      return { value: value, done: done };
    };

    var toIndexedObject = toIndexedObject$5;
    var addToUnscopables = addToUnscopables$1;
    var Iterators$2 = iterators;
    var InternalStateModule = internalState;
    var defineProperty = objectDefineProperty.f;
    var defineIterator = iteratorDefine;
    var createIterResultObject = createIterResultObject$1;
    var DESCRIPTORS = descriptors;

    var ARRAY_ITERATOR = 'Array Iterator';
    var setInternalState = InternalStateModule.set;
    var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

    // `Array.prototype.entries` method
    // https://tc39.es/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.es/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.es/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.es/ecma262/#sec-createarrayiterator
    var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
      setInternalState(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject(iterated), // target
        index: 0,                          // next index
        kind: kind                         // kind
      });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
    }, function () {
      var state = getInternalState(this);
      var target = state.target;
      var kind = state.kind;
      var index = state.index++;
      if (!target || index >= target.length) {
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      if (kind == 'keys') return createIterResultObject(index, false);
      if (kind == 'values') return createIterResultObject(target[index], false);
      return createIterResultObject([index, target[index]], false);
    }, 'values');

    // argumentsList[@@iterator] is %ArrayProto_values%
    // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
    // https://tc39.es/ecma262/#sec-createmappedargumentsobject
    var values = Iterators$2.Arguments = Iterators$2.Array;

    // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables('keys');
    addToUnscopables('values');
    addToUnscopables('entries');

    // V8 ~ Chrome 45- bug
    if (DESCRIPTORS && values.name !== 'values') try {
      defineProperty(values, 'name', { value: 'values' });
    } catch (error) { /* empty */ }

    var classofRaw$1 = classofRaw$2;
    var uncurryThis$1 = functionUncurryThis;

    var functionUncurryThisClause = function (fn) {
      // Nashorn bug:
      //   https://github.com/zloirock/core-js/issues/1128
      //   https://github.com/zloirock/core-js/issues/1130
      if (classofRaw$1(fn) === 'Function') return uncurryThis$1(fn);
    };

    var uncurryThis = functionUncurryThisClause;
    var aCallable$1 = aCallable$3;
    var NATIVE_BIND = functionBindNative;

    var bind$1 = uncurryThis(uncurryThis.bind);

    // optional / simple context binding
    var functionBindContext = function (fn, that) {
      aCallable$1(fn);
      return that === undefined ? fn : NATIVE_BIND ? bind$1(fn, that) : function (/* ...args */) {
        return fn.apply(that, arguments);
      };
    };

    var wellKnownSymbol$4 = wellKnownSymbol$a;
    var Iterators$1 = iterators;

    var ITERATOR$2 = wellKnownSymbol$4('iterator');
    var ArrayPrototype = Array.prototype;

    // check on default Array iterator
    var isArrayIteratorMethod$1 = function (it) {
      return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
    };

    var wellKnownSymbol$3 = wellKnownSymbol$a;

    var TO_STRING_TAG$2 = wellKnownSymbol$3('toStringTag');
    var test = {};

    test[TO_STRING_TAG$2] = 'z';

    var toStringTagSupport = String(test) === '[object z]';

    var TO_STRING_TAG_SUPPORT = toStringTagSupport;
    var isCallable = isCallable$f;
    var classofRaw = classofRaw$2;
    var wellKnownSymbol$2 = wellKnownSymbol$a;

    var TO_STRING_TAG$1 = wellKnownSymbol$2('toStringTag');
    var $Object = Object;

    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function (it, key) {
      try {
        return it[key];
      } catch (error) { /* empty */ }
    };

    // getting tag from ES6+ `Object.prototype.toString`
    var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
      var O, tag, result;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
        // @@toStringTag case
        : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
        // builtinTag case
        : CORRECT_ARGUMENTS ? classofRaw(O)
        // ES3 arguments fallback
        : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
    };

    var classof = classof$1;
    var getMethod$1 = getMethod$3;
    var isNullOrUndefined = isNullOrUndefined$3;
    var Iterators = iterators;
    var wellKnownSymbol$1 = wellKnownSymbol$a;

    var ITERATOR$1 = wellKnownSymbol$1('iterator');

    var getIteratorMethod$2 = function (it) {
      if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR$1)
        || getMethod$1(it, '@@iterator')
        || Iterators[classof(it)];
    };

    var call$2 = functionCall;
    var aCallable = aCallable$3;
    var anObject$2 = anObject$8;
    var tryToString$1 = tryToString$3;
    var getIteratorMethod$1 = getIteratorMethod$2;

    var $TypeError$1 = TypeError;

    var getIterator$1 = function (argument, usingIterator) {
      var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
      if (aCallable(iteratorMethod)) return anObject$2(call$2(iteratorMethod, argument));
      throw $TypeError$1(tryToString$1(argument) + ' is not iterable');
    };

    var call$1 = functionCall;
    var anObject$1 = anObject$8;
    var getMethod = getMethod$3;

    var iteratorClose$1 = function (iterator, kind, value) {
      var innerResult, innerError;
      anObject$1(iterator);
      try {
        innerResult = getMethod(iterator, 'return');
        if (!innerResult) {
          if (kind === 'throw') throw value;
          return value;
        }
        innerResult = call$1(innerResult, iterator);
      } catch (error) {
        innerError = true;
        innerResult = error;
      }
      if (kind === 'throw') throw value;
      if (innerError) throw innerResult;
      anObject$1(innerResult);
      return value;
    };

    var bind = functionBindContext;
    var call = functionCall;
    var anObject = anObject$8;
    var tryToString = tryToString$3;
    var isArrayIteratorMethod = isArrayIteratorMethod$1;
    var lengthOfArrayLike = lengthOfArrayLike$2;
    var isPrototypeOf = objectIsPrototypeOf;
    var getIterator = getIterator$1;
    var getIteratorMethod = getIteratorMethod$2;
    var iteratorClose = iteratorClose$1;

    var $TypeError = TypeError;

    var Result = function (stopped, result) {
      this.stopped = stopped;
      this.result = result;
    };

    var ResultPrototype = Result.prototype;

    var iterate$1 = function (iterable, unboundFunction, options) {
      var that = options && options.that;
      var AS_ENTRIES = !!(options && options.AS_ENTRIES);
      var IS_RECORD = !!(options && options.IS_RECORD);
      var IS_ITERATOR = !!(options && options.IS_ITERATOR);
      var INTERRUPTED = !!(options && options.INTERRUPTED);
      var fn = bind(unboundFunction, that);
      var iterator, iterFn, index, length, result, next, step;

      var stop = function (condition) {
        if (iterator) iteratorClose(iterator, 'normal', condition);
        return new Result(true, condition);
      };

      var callFn = function (value) {
        if (AS_ENTRIES) {
          anObject(value);
          return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        } return INTERRUPTED ? fn(value, stop) : fn(value);
      };

      if (IS_RECORD) {
        iterator = iterable.iterator;
      } else if (IS_ITERATOR) {
        iterator = iterable;
      } else {
        iterFn = getIteratorMethod(iterable);
        if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
        // optimisation for array iterators
        if (isArrayIteratorMethod(iterFn)) {
          for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
            result = callFn(iterable[index]);
            if (result && isPrototypeOf(ResultPrototype, result)) return result;
          } return new Result(false);
        }
        iterator = getIterator(iterable, iterFn);
      }

      next = IS_RECORD ? iterable.next : iterator.next;
      while (!(step = call(next, iterator)).done) {
        try {
          result = callFn(step.value);
        } catch (error) {
          iteratorClose(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    };

    var toPropertyKey = toPropertyKey$3;
    var definePropertyModule = objectDefineProperty;
    var createPropertyDescriptor = createPropertyDescriptor$4;

    var createProperty$1 = function (object, key, value) {
      var propertyKey = toPropertyKey(key);
      if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
      else object[propertyKey] = value;
    };

    var $$1 = _export;
    var iterate = iterate$1;
    var createProperty = createProperty$1;

    // `Object.fromEntries` method
    // https://github.com/tc39/proposal-object-from-entries
    $$1({ target: 'Object', stat: true }, {
      fromEntries: function fromEntries(iterable) {
        var obj = {};
        iterate(iterable, function (k, v) {
          createProperty(obj, k, v);
        }, { AS_ENTRIES: true });
        return obj;
      }
    });

    var global$2 = global$c;

    var path$1 = global$2;

    var path = path$1;

    path.Object.fromEntries;

    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    var domIterables = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };

    // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
    var documentCreateElement = documentCreateElement$2;

    var classList = documentCreateElement('span').classList;
    var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

    var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

    var global$1 = global$c;
    var DOMIterables = domIterables;
    var DOMTokenListPrototype = domTokenListPrototype;
    var ArrayIteratorMethods = es_array_iterator;
    var createNonEnumerableProperty = createNonEnumerableProperty$4;
    var wellKnownSymbol = wellKnownSymbol$a;

    var ITERATOR = wellKnownSymbol('iterator');
    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var ArrayValues = ArrayIteratorMethods.values;

    var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
      if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
          createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
        } catch (error) {
          CollectionPrototype[ITERATOR] = ArrayValues;
        }
        if (!CollectionPrototype[TO_STRING_TAG]) {
          createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
        }
        if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
          // some Chrome versions have non-configurable methods on DOMTokenList
          if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
            createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
          } catch (error) {
            CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
          }
        }
      }
    };

    for (var COLLECTION_NAME in DOMIterables) {
      handlePrototype(global$1[COLLECTION_NAME] && global$1[COLLECTION_NAME].prototype, COLLECTION_NAME);
    }

    handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

    function getCookieDomain(hostname) {
      if (hostname === void 0) {
        hostname = window.location.hostname;
      }

      var parts = hostname.split('.');
      var tldParts = parts.splice(parts.length - 2, parts.length);
      var tld = tldParts.join('.');
      if (tld === 'localhost') return 'localhost';
      return "." + tld;
    }

    function localStorageCache(key, callback) {
      var _a, _b, _c;

      return __awaiter(this, void 0, void 0, function () {
        var cachedValue;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              cachedValue = ((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || ((_b = window.sessionStorage) === null || _b === void 0 ? void 0 : _b.getItem(key));
              if (!!cachedValue) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , callback()];

            case 1:
              cachedValue = _d.sent();
              (_c = window.localStorage) === null || _c === void 0 ? void 0 : _c.setItem(key, cachedValue);
              _d.label = 2;

            case 2:
              return [2
              /*return*/
              , cachedValue];
          }
        });
      });
    }

    var CONSENT_COOKIE = 'gtm_cookie_consent';
    function fetchCookieConsentMode() {
      return __awaiter(this, void 0, void 0, function () {
        var consentMode;

        var _this = this;

        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , localStorageCache('cookie-consent-mode', function () {
                return __awaiter(_this, void 0, void 0, function () {
                  var response;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        return [4
                        /*yield*/
                        , intercom.get('/cookie_consent_mode')];

                      case 1:
                        response = _a.sent();
                        return [2
                        /*return*/
                        , response.error ? 'consent-required' : response.data.cookie_consent_mode];
                    }
                  });
                });
              })];

            case 1:
              consentMode = _a.sent();

              if (consentMode === 'consent-assumed') {
                window.dataLayer.push({
                  'gtm-js.restricted-data-processing': true
                });
              }

              return [2
              /*return*/
              , consentMode];
          }
        });
      });
    }
    function getCookieConsentPreference(mode) {
      var enableAll = {
        advertising: true,
        marketing: true,
        analytics: true,
        performance: true
      };

      if (mode === 'no-consent') {
        setCookieConsentPreference(enableAll);
        return enableAll;
      }

      var cookie = Cookies.get(CONSENT_COOKIE);

      if (cookie === undefined) {
        if (mode === 'consent-assumed') {
          setCookieConsentPreference(enableAll);
          return enableAll;
        }

        return null;
      }

      return deserializeConsentCookie(cookie);
    }
    function setCookieConsentPreference(value) {
      var secure = apiEndpoint().startsWith('https:');
      Cookies.set(CONSENT_COOKIE, serializeConsentCookie(value), {
        expires: 180,
        domain: getCookieDomain(),
        samesite: secure ? 'none' : 'lax',
        secure: secure,
        path: '/'
      });
    }
    function getConsentTimeStamp() {
      var cookie = Cookies.get(CONSENT_COOKIE);
      if (!cookie) return null;
      var consentTimeStamp = Number(cookie.split('+').slice(-1)[0]);
      if (isNaN(consentTimeStamp)) return null;
      return consentTimeStamp;
    }
    function getCookieConsentPropertiesForMetric() {
      var _a;

      var cookie = Cookies.get(CONSENT_COOKIE);
      var cookieConsent = cookie ? deserializeConsentCookie(cookie) : {};
      var cookieConsentMode = ((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('cookie-consent-mode')) || 'consent-required';
      return __assign({
        cookieConsentMode: cookieConsentMode
      }, cookieConsent);
    }

    function serializeConsentCookie(value) {
      return __spreadArrays(['essential'], Object.entries(value).map(function (_a) {
        var cookieType = _a[0],
            enabled = _a[1];
        return enabled && cookieType;
      }).filter(Boolean), [new Date().getTime()]).join('+');
    }

    function deserializeConsentCookie(cookieValue) {
      var _a = Object.fromEntries(cookieValue.split('+').map(function (bucket) {
        return [bucket, true];
      })),
          advertising = _a.advertising,
          marketing = _a.marketing,
          analytics = _a.analytics,
          performance = _a.performance;

      return {
        advertising: !!advertising,
        analytics: !!analytics,
        marketing: !!marketing,
        performance: !!performance
      };
    }

    var css$5 = picostyle(h$4);
    var Wrap$4 = css$5('span')({
      display: 'inline-block',
      backgroundColor: '#ec7965',
      borderRadius: '3px',
      padding: '8px 20px 6px',
      marginBottom: '20px',
      textAlign: 'center',
      fontSize: '14px'
    });
    function Error$1(_a) {
      var children = _a.children;
      return h$4(Wrap$4, null, children);
    }

    var css$4 = picostyle(h$4);
    var Wrap$3 = css$4('div')({
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridColumnGap: '15px',
      '@media (max-width: 600px)': {
        gridColumnGap: '5px'
      }
    });
    var LabelDisguisedAsButton = css$4('label')(ButtonStyles);
    function Switch(_a) {
      var id = _a.id,
          value = _a.value,
          changeValue = _a.changeValue,
          enableErrorState = _a.enableErrorState,
          onRef = _a.onRef,
          offRef = _a.offRef;
      var localizedCopy = useLocalizedCopy().localizedCopy;

      function onChange(event) {
        changeValue(event.target.value === 'on');
      }

      return h$4(Wrap$3, null, h$4(LabelDisguisedAsButton, {
        variant: value === true ? 'primary' : 'secondary',
        class: "focus-within",
        error: enableErrorState && value == null,
        ref: onRef,
        size: "small"
      }, h$4("input", {
        type: "radio",
        checked: value === true,
        onChange: onChange,
        name: id,
        value: 'on',
        class: "vh",
        "data-testid": "switch-" + id + "-on"
      }), localizedCopy('on')), h$4(LabelDisguisedAsButton, {
        variant: value === false ? 'primary' : 'secondary',
        class: "focus-within",
        error: enableErrorState && value == null,
        ref: offRef,
        size: "small"
      }, h$4("input", {
        type: "radio",
        checked: value === false,
        onChange: onChange,
        name: id,
        value: 'off',
        class: "vh",
        "data-testid": "switch-" + id + "-off"
      }), localizedCopy('off')));
    }

    var css$3 = picostyle(h$4);
    var Wrap$2 = css$3('div')({});
    var Heading$1 = css$3('h1')({
      fontSize: '26px',
      margin: '0 0 10px',
      textAlign: 'center'
    });
    var SubHeading = css$3('h3')({
      fontSize: '16px',
      fontWeight: 'normal',
      margin: '0 auto 40px',
      textAlign: 'center',
      maxWidth: '330px'
    });
    var Cta = css$3('div')({
      textAlign: 'center',
      marginTop: '50px',
      '> button': {
        paddingLeft: '50px',
        paddingRight: '50px'
      }
    });
    function Settings(_a) {
      var onSave = _a.onSave,
          defaultFocusRef = _a.defaultFocusRef;

      var _b, _c, _d, _e;

      var mode = w$2(ConsentModeContext);

      var _f = m$3((_b = getCookieConsentPreference(mode)) === null || _b === void 0 ? void 0 : _b.advertising),
          advertising = _f[0],
          setAdvertising = _f[1];

      var _g = m$3((_c = getCookieConsentPreference(mode)) === null || _c === void 0 ? void 0 : _c.marketing),
          marketing = _g[0],
          setMarketing = _g[1];

      var _h = m$3((_d = getCookieConsentPreference(mode)) === null || _d === void 0 ? void 0 : _d.analytics),
          analytics = _h[0],
          setAnalytics = _h[1];

      var _j = m$3((_e = getCookieConsentPreference(mode)) === null || _e === void 0 ? void 0 : _e.performance),
          performance = _j[0],
          setPerformance = _j[1];

      var _k = m$3(false),
          error = _k[0],
          setError = _k[1];

      var localizedCopy = useLocalizedCopy().localizedCopy;
      l$3(function () {
        if (advertising != null && analytics != null && marketing != null && performance !== null && error === true) {
          setError(false);
        }
      }, [advertising, analytics, marketing, performance, error]);

      function savePreferences() {
        if (advertising != null && analytics != null && marketing != null && performance != null) {
          setError(false);
          setCookieConsentPreference({
            advertising: advertising,
            analytics: analytics,
            marketing: marketing,
            performance: performance
          });
          onSave && onSave({
            advertising: advertising,
            analytics: analytics,
            marketing: marketing,
            performance: performance
          });
        } else {
          setError(true);
        }
      }

      return h$4(Wrap$2, null, h$4(Heading$1, {
        id: "manage-cookies-heading"
      }, localizedCopy('manage-your-cookies')), h$4(SubHeading, null, localizedCopy('cookie-modal-description')), h$4(AccordionManager, null, h$4(Accordion, {
        label: localizedCopy('essential-cookies'),
        description: localizedCopy('essential-cookies-description')
      }, localizedCopy('always-on')), h$4(Accordion, {
        label: localizedCopy('advertising-cookies'),
        description: h$4("span", null, localizedCopy('advertising-cookies-description'), ' ', h$4("a", {
          href: "https://www.intercom.com/legal/cookie-policy#why-do-we-use-cookies",
          target: "_blank",
          rel: "noopener noreferrer"
        }, localizedCopy('see-list-advertising-cookies')))
      }, h$4(Switch, {
        id: "advertising",
        value: advertising,
        changeValue: setAdvertising,
        onRef: defaultFocusRef,
        enableErrorState: error
      })), h$4(Accordion, {
        label: localizedCopy('marketing-cookies'),
        description: h$4("span", null, localizedCopy('marketing-cookies-description'), ' ', h$4("a", {
          href: "https://www.intercom.com/legal/cookie-policy#why-do-we-use-cookies",
          target: "_blank",
          rel: "noopener noreferrer"
        }, localizedCopy('see-list-marketing-cookies')))
      }, h$4(Switch, {
        id: "marketing",
        value: marketing,
        changeValue: setMarketing,
        enableErrorState: error
      })), h$4(Accordion, {
        label: localizedCopy('performance-functionality-cookies'),
        description: h$4("span", null, localizedCopy('performance-functionality-cookies-description'), ' ', h$4("a", {
          href: "https://www.intercom.com/legal/cookie-policy#why-do-we-use-cookies",
          target: "_blank",
          rel: "noopener noreferrer"
        }, localizedCopy('see-list-performance-functionality-cookies')))
      }, h$4(Switch, {
        id: "performance",
        value: performance,
        changeValue: setPerformance,
        enableErrorState: error
      })), h$4(Accordion, {
        label: localizedCopy('analytics-cookies'),
        description: h$4("span", null, localizedCopy('analytics-cookies-description'), ' ', h$4("a", {
          href: "https://www.intercom.com/legal/cookie-policy#why-do-we-use-cookies",
          target: "_blank",
          rel: "noopener noreferrer"
        }, localizedCopy('see-list-analytics-cookies')))
      }, h$4(Switch, {
        id: "analytics",
        value: analytics,
        changeValue: setAnalytics,
        enableErrorState: error
      }))), h$4(Cta, null, error && h$4("div", null, h$4(Error$1, null, localizedCopy('error-select-a-choice-for-each-option'))), h$4(Button, {
        variant: "primary",
        onClick: savePreferences,
        "data-testid": "save-button"
      }, localizedCopy('save-preferences'))));
    }

    var css$2 = picostyle(h$4);
    var Wrap$1 = css$2('div')(function (props) {
      return {
        display: 'grid',
        gridTemplateColumns: '[left-gutter] 1fr [content] 12fr [right-gutter] 1fr',
        padding: '30px 0',
        background: 'rgba(0, 0, 0, 0.24);',
        position: 'fixed',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        color: 'black',
        zIndex: '100000',
        transition: 'opacity .2s',
        opacity: "" + props.opacity
      };
    });
    var Overlay = css$2('div')({
      position: 'absolute',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      zIndex: '-1',
      ':focus': {
        outline: '0'
      }
    });
    var Inner$1 = css$2('div')(function (props) {
      return {
        gridColumn: 'content',
        width: '100%',
        maxWidth: props.wide ? '740px' : '690px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: '40px',
        '@media (max-width: 600px), (max-height: 650px)': {
          marginTop: '0'
        }
      };
    });
    var Content = css$2('div')(function (props) {
      return {
        background: '#FFFFFF',
        boxShadow: '0px 5px 10px rgba(75, 75, 75, 0.11), 0px 5px 20px rgba(89, 89, 89, 0.12)',
        borderRadius: '8px',
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        width: '100%',
        padding: props.wide ? '60px 60px 40px' : '60px 120px 40px',
        position: 'relative',
        '@media (max-width: 600px), (max-height: 650px)': {
          maxHeight: 'calc(100vh - 60px)'
        },
        '@media (max-width: 800px)': {
          paddingLeft: '60px',
          paddingRight: '60px'
        },
        '@media (max-width: 600px)': {
          padding: '70px 20px 20px'
        }
      };
    });
    var Close = css$2('button')({
      cursor: 'pointer',
      border: 'none',
      padding: '0',
      position: 'absolute',
      top: '20px',
      right: '20px'
    });
    function Modal(_a) {
      var onSave = _a.onSave,
          onClose = _a.onClose;
      var wrap = d$3(null);
      var defaultFocusRef = d$3(null);

      var _b = m$3(0),
          opacity = _b[0],
          setOpacity = _b[1];

      var _c = m$3(false),
          wideLayout = _c[0],
          setWideLayout = _c[1];

      var localizedCopy = useLocalizedCopy().localizedCopy;
      var localeCode = w$2(LocaleCodeContext);

      function handleSave(cookies) {
        setOpacity(0);
        setTimeout(function () {
          return onSave(cookies);
        }, 200);
      }

      function handleClose() {
        setOpacity(0);
        setTimeout(onClose, 200);
      }

      l$3(function () {
        var _a, _b;

        setOpacity(1);
        new _default$2({
          node: (_a = wrap === null || wrap === void 0 ? void 0 : wrap.current) === null || _a === void 0 ? void 0 : _a.base
        });
        (_b = defaultFocusRef === null || defaultFocusRef === void 0 ? void 0 : defaultFocusRef.current) === null || _b === void 0 ? void 0 : _b.base.focus();
      }, []);
      l$3(function () {
        function closeOnEscape(event) {
          if (event.key === 'Escape') {
            setOpacity(0);
            setTimeout(onClose, 200);
          }
        }

        document.addEventListener('keydown', closeOnEscape);
        return function () {
          document.removeEventListener('keydown', closeOnEscape);
        };
      }, [onClose]);
      l$3(function () {
        var wideLayoutLocale = localeCode !== 'en-US';
        setWideLayout(wideLayoutLocale);
      }, [localeCode]);
      return h$4(Wrap$1, {
        opacity: opacity,
        ref: wrap
      }, h$4(Overlay, {
        onClick: handleClose,
        tabIndex: -1
      }), h$4(Inner$1, {
        role: "dialog",
        "aria-labelledby": "manage-cookies-heading",
        wide: wideLayout
      }, h$4(Content, {
        wide: wideLayout
      }, h$4(Close, {
        onClick: handleClose,
        "data-testid": "close-button"
      }, h$4("span", {
        class: "vh"
      }, localizedCopy('close-dialog')), h$4("img", {
        src: "https://marketing.intercomcdn.com/assets/gdpr-close-icon.svg",
        width: "26",
        alt: ""
      })), h$4(Settings, {
        onSave: handleSave,
        defaultFocusRef: defaultFocusRef
      }))));
    }

    var css$1 = picostyle(h$4);
    var P$1 = css$1('p')({
      margin: '1em 0',
      ':last-of-type': {
        marginBottom: '1.5em'
      }
    });
    var DateTimeCopy = css$1('span')(function (props) {
      return __assign({}, props.color && {
        color: props.color
      });
    });

    var arrayToText = function (arr) {
      return arr.join(', ').replace(/,(?!.*,)/gim, ' and');
    };

    var TRESHOLD_TO_SHOW_UPDATED_COPY_IN_SECONDS = 5;
    function ConsentState(_a) {
      var onSave = _a.onSave;
      var mode = w$2(ConsentModeContext);
      var consentDateTime = getConsentTimeStamp();

      var _b = m$3(consentDateTime ? (new Date().getTime() - consentDateTime) / 1000 < TRESHOLD_TO_SHOW_UPDATED_COPY_IN_SECONDS : false),
          consentUpdated = _b[0],
          setConsentUpdated = _b[1];

      var _c = m$3(false),
          modalOpen = _c[0],
          setModalOpen = _c[1];

      var cookieConsent = getCookieConsentPreference(mode);
      if (!cookieConsent) return null;

      function handleSave(cookies) {
        setConsentUpdated(true);
        setModalOpen(false);
        onSave(cookies);
      }

      var optedInCookies = Object.keys(cookieConsent).filter(function (cookie) {
        return !!cookieConsent[cookie];
      });
      var allowAllCookies = optedInCookies.length === Object.keys(cookieConsent).length;

      var capitalizedCookies = __spreadArrays(['Essential'], optedInCookies).map(function (cookie) {
        return "" + cookie.charAt(0).toUpperCase() + cookie.slice(1);
      });

      var cookieConsentCopy = allowAllCookies ? "Allow all cookies: (" + arrayToText(capitalizedCookies) + ")" : "Only " + arrayToText(capitalizedCookies) + " cookies.";
      return h$4("div", null, modalOpen && h$4(Modal, {
        onSave: handleSave,
        onClose: function () {
          return setModalOpen(false);
        }
      }), h$4(P$1, null, "Your current state: ", cookieConsentCopy), consentDateTime && h$4(P$1, null, h$4(DateTimeCopy, {
        color: consentUpdated && '#ec7965'
      }, consentUpdated ? 'Updated' : 'Consent date', ":"), ' ', new Intl.DateTimeFormat('en', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'short'
      }).format(consentDateTime)), h$4(Button, {
        variant: "primary",
        onClick: function () {
          return setModalOpen(true);
        }
      }, "Change your consent"));
    }

    function GlobalStyles() {
      return h$4("style", null, "\n      @font-face {\n        font-family: \"GDPRGraphik\";\n        font-display: swap;\n        src: url(\"https://fonts.intercomcdn.com/graphik/Graphik-Regular.woff\") format(\"woff\");\n        font-weight: normal;\n        font-style: normal;\n      }\n      @font-face {\n        font-family: \"GDPRGraphik\";\n        font-display: swap;\n        src: url(\"https://fonts.intercomcdn.com/graphik/Graphik-Bold.woff\") format(\"woff\");\n        font-weight: bold;\n        font-style: normal;\n      }\n      .intercom-cookie-consent-banner-wrap {\n        font-family: GDPRGraphik, Graphik, Helvetica, Arial, sans-serif;\n        line-height: 1.5;\n        font-size: 16px;\n        text-align: left;\n      }\n      .intercom-cookie-consent-banner-wrap *,\n      .intercom-cookie-consent-banner-wrap *:before,\n      .intercom-cookie-consent-banner-wrap *:after {\n        box-sizing: border-box;\n      }\n      .intercom-cookie-consent-banner-wrap a {\n        color: inherit;\n        -webkit-text-decoration: none;\n        text-decoration: none;\n        border-bottom: 1px dotted;\n        word-break: normal;\n      }\n      .intercom-cookie-consent-banner-wrap button {\n        background-color: transparent;\n      }\n      .intercom-cookie-consent-banner-wrap a,\n      .intercom-cookie-consent-banner-wrap button {\n        outline: none;\n      }\n      .intercom-cookie-consent-banner-wrap button::-moz-focus-inner {\n        border: 0;\n      }\n      .intercom-cookie-consent-banner-wrap.intercom-cookie-consent-banner-wrap__focus-indicators a:active ,\n      .intercom-cookie-consent-banner-wrap.intercom-cookie-consent-banner-wrap__focus-indicators a:focus {\n        border-bottom: 1px solid;\n      }\n      .intercom-cookie-consent-banner-wrap.intercom-cookie-consent-banner-wrap__focus-indicators button.bold-focus {\n        position: relative;\n      }\n      .intercom-cookie-consent-banner-wrap.intercom-cookie-consent-banner-wrap__focus-indicators button.bold-focus:focus:after,\n      .intercom-cookie-consent-banner-wrap.intercom-cookie-consent-banner-wrap__focus-indicators .focus-within:focus-within:after {\n        content: '';\n        display: block;\n        position: absolute;\n        top: -6px;\n        right: -6px;\n        bottom: -6px;\n        left: -6px;\n        border: 3px solid black;\n        border-radius: 10px;\n      }\n      .intercom-cookie-consent-banner-wrap.intercom-cookie-consent-banner-wrap__focus-indicators button.cookie-consent-button__small:focus:after {\n        border-width: 2px;\n      }\n      .intercom-cookie-consent-banner-wrap.intercom-cookie-consent-banner-wrap__focus-indicators .cookie-consent-focusable:focus {\n        outline: rgb(24, 24, 24) dotted 1px;\n      }\n      .intercom-cookie-consent-banner-wrap .vh {\n        position: absolute !important;\n        height: 1px;\n        width: 1px;\n        overflow: hidden;\n        clip: rect(1px, 1px, 1px, 1px);\n        white-space: nowrap; /* added line */\n      }\n      .intercom-cookie-consent-banner-wrap button {\n        appearance: none;\n        -webkit-appearance: none;\n        font-size: inherit;\n      }\n    ");
    }

    function CookieConsent(_a) {
      var children = _a.children,
          mode = _a.mode;

      var _b = m$3(false),
          focusStyle = _b[0],
          setFocusStyle = _b[1];

      return h$4("div", {
        id: "intercom-cookie-consent-banner-wrap",
        class: focusStyle ? 'intercom-cookie-consent-banner-wrap intercom-cookie-consent-banner-wrap__focus-indicators' : 'intercom-cookie-consent-banner-wrap',
        "aria-live": "polite",
        onKeyDown: function () {
          return setFocusStyle(true);
        },
        onClick: function (e) {
          return e.screenX && setFocusStyle(false);
        }
      }, h$4(GlobalStyles, null), h$4(ConsentModeContext.Provider, {
        value: mode
      }, children));
    }

    var dist$2 = {};

    var reactSanitizer = {};

    var propTypes = {exports: {}};

    var reactIs_production_min = {};

    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var b$1="function"===typeof Symbol&&Symbol.for,c$2=b$1?Symbol.for("react.element"):60103,d$2=b$1?Symbol.for("react.portal"):60106,e$2=b$1?Symbol.for("react.fragment"):60107,f$2=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$2=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$2=b$1?Symbol.for("react.async_mode"):60111,m$2=b$1?Symbol.for("react.concurrent_mode"):60111,n$2=b$1?Symbol.for("react.forward_ref"):60112,p$2=b$1?Symbol.for("react.suspense"):60113,q=b$1?
    Symbol.for("react.suspense_list"):60120,r$2=b$1?Symbol.for("react.memo"):60115,t$2=b$1?Symbol.for("react.lazy"):60116,v$2=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$2=b$1?Symbol.for("react.responder"):60118,y$2=b$1?Symbol.for("react.scope"):60119;
    function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$2:switch(a=a.type,a){case l$2:case m$2:case e$2:case g$1:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$2:case t$2:case r$2:case h$2:return a;default:return u}}case d$2:return u}}}function A$1(a){return z$1(a)===m$2}reactIs_production_min.AsyncMode=l$2;reactIs_production_min.ConcurrentMode=m$2;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h$2;reactIs_production_min.Element=c$2;reactIs_production_min.ForwardRef=n$2;reactIs_production_min.Fragment=e$2;reactIs_production_min.Lazy=t$2;reactIs_production_min.Memo=r$2;reactIs_production_min.Portal=d$2;
    reactIs_production_min.Profiler=g$1;reactIs_production_min.StrictMode=f$2;reactIs_production_min.Suspense=p$2;reactIs_production_min.isAsyncMode=function(a){return A$1(a)||z$1(a)===l$2};reactIs_production_min.isConcurrentMode=A$1;reactIs_production_min.isContextConsumer=function(a){return z$1(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z$1(a)===h$2};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$2};reactIs_production_min.isForwardRef=function(a){return z$1(a)===n$2};reactIs_production_min.isFragment=function(a){return z$1(a)===e$2};reactIs_production_min.isLazy=function(a){return z$1(a)===t$2};
    reactIs_production_min.isMemo=function(a){return z$1(a)===r$2};reactIs_production_min.isPortal=function(a){return z$1(a)===d$2};reactIs_production_min.isProfiler=function(a){return z$1(a)===g$1};reactIs_production_min.isStrictMode=function(a){return z$1(a)===f$2};reactIs_production_min.isSuspense=function(a){return z$1(a)===p$2};
    reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$2||a===m$2||a===g$1||a===f$2||a===p$2||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t$2||a.$$typeof===r$2||a.$$typeof===h$2||a.$$typeof===k$1||a.$$typeof===n$2||a.$$typeof===w$1||a.$$typeof===x$2||a.$$typeof===y$2||a.$$typeof===v$2)};reactIs_production_min.typeOf=z$1;

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

    var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var ReactPropTypesSecret = ReactPropTypesSecret_1;

    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;

    var factoryWithThrowingShims = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          // It is still safe when called from React.
          return;
        }
        var err = new Error(
          'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
          'Use PropTypes.checkPropTypes() to call them. ' +
          'Read more at http://fb.me/use-check-prop-types'
        );
        err.name = 'Invariant Violation';
        throw err;
      }  shim.isRequired = shim;
      function getShim() {
        return shim;
      }  // Important!
      // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,

        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,

        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };

      ReactPropTypes.PropTypes = ReactPropTypes;

      return ReactPropTypes;
    };

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      propTypes.exports = factoryWithThrowingShims();
    }

    var compat = {};

    var hooks = {};

    var preact = {};

    var n$1,l$1,u$1,t$1,i$1,r$1,o$1,f$1,e$1={},c$1=[],s$1=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;function a$1(n,l){for(var u in l)n[u]=l[u];return n}function p$1(n){var l=n.parentNode;l&&l.removeChild(n);}function v$1(n,l,u){var t,i=arguments,r={};for(t in l)"key"!==t&&"ref"!==t&&(r[t]=l[t]);if(arguments.length>3)for(u=[u],t=3;t<arguments.length;t++)u.push(i[t]);if(null!=u&&(r.children=u),"function"==typeof n&&null!=n.defaultProps)for(t in n.defaultProps)void 0===r[t]&&(r[t]=n.defaultProps[t]);return h$1(n,r,l&&l.key,l&&l.ref,null)}function h$1(l,u,t,i,r){var o={type:l,props:u,key:t,ref:i,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,constructor:void 0,__v:r};return null==r&&(o.__v=o),n$1.vnode&&n$1.vnode(o),o}function y$1(n){return n.children}function d$1(n,l){this.props=n,this.context=l;}function x$1(n,l){if(null==l)return n.__?x$1(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?x$1(n):null}function m$1(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return m$1(n)}}function w(l){(!l.__d&&(l.__d=!0)&&u$1.push(l)&&!t$1++||r$1!==n$1.debounceRendering)&&((r$1=n$1.debounceRendering)||i$1)(k);}function k(){for(var n;t$1=u$1.length;)n=u$1.sort(function(n,l){return n.__v.__b-l.__v.__b}),u$1=[],n.some(function(n){var l,u,t,i,r,o,f;n.__d&&(o=(r=(l=n).__v).__e,(f=l.__P)&&(u=[],(t=a$1({},r)).__v=t,i=z(f,r,t,l.__n,void 0!==f.ownerSVGElement,null,u,null==o?x$1(r):o),A(u,r),i!=o&&m$1(r)));});}function g(n,l,u,t,i,r,o,f,s){var a,v,h,y,d,m,w,k=u&&u.__k||c$1,g=k.length;if(f==e$1&&(f=null!=r?r[0]:g?x$1(u,0):null),a=0,l.__k=_(l.__k,function(u){if(null!=u){if(u.__=l,u.__b=l.__b+1,null===(h=k[a])||h&&u.key==h.key&&u.type===h.type)k[a]=void 0;else for(v=0;v<g;v++){if((h=k[v])&&u.key==h.key&&u.type===h.type){k[v]=void 0;break}h=null;}if(y=z(n,u,h=h||e$1,t,i,r,o,f,s),(v=u.ref)&&h.ref!=v&&(w||(w=[]),h.ref&&w.push(h.ref,null,u),w.push(v,u.__c||y,u)),null!=y){var c;if(null==m&&(m=y),void 0!==u.__d)c=u.__d,u.__d=void 0;else if(r==h||y!=f||null==y.parentNode){n:if(null==f||f.parentNode!==n)n.appendChild(y),c=null;else {for(d=f,v=0;(d=d.nextSibling)&&v<g;v+=2)if(d==y)break n;n.insertBefore(y,f),c=f;}"option"==l.type&&(n.value="");}f=void 0!==c?c:y.nextSibling,"function"==typeof l.type&&(l.__d=f);}else f&&h.__e==f&&f.parentNode!=n&&(f=x$1(h));}return a++,u}),l.__e=m,null!=r&&"function"!=typeof l.type)for(a=r.length;a--;)null!=r[a]&&p$1(r[a]);for(a=g;a--;)null!=k[a]&&j(k[a],k[a]);if(w)for(a=0;a<w.length;a++)$(w[a],w[++a],w[++a]);}function _(n,l,u){if(null==u&&(u=[]),null==n||"boolean"==typeof n)l&&u.push(l(null));else if(Array.isArray(n))for(var t=0;t<n.length;t++)_(n[t],l,u);else u.push(l?l("string"==typeof n||"number"==typeof n?h$1(null,n,null,null,n):null!=n.__e||null!=n.__c?h$1(n.type,n.props,n.key,null,n.__v):n):n);return u}function b(n,l,u,t,i){var r;for(r in u)"children"===r||"key"===r||r in l||C(n,r,null,u[r],t);for(r in l)i&&"function"!=typeof l[r]||"children"===r||"key"===r||"value"===r||"checked"===r||u[r]===l[r]||C(n,r,l[r],u[r],t);}function P(n,l,u){"-"===l[0]?n.setProperty(l,u):n[l]="number"==typeof u&&!1===s$1.test(l)?u+"px":null==u?"":u;}function C(n,l,u,t,i){var r,o,f,e,c;if(i?"className"===l&&(l="class"):"class"===l&&(l="className"),"style"===l)if(r=n.style,"string"==typeof u)r.cssText=u;else {if("string"==typeof t&&(r.cssText="",t=null),t)for(e in t)u&&e in u||P(r,e,"");if(u)for(c in u)t&&u[c]===t[c]||P(r,c,u[c]);}else "o"===l[0]&&"n"===l[1]?(o=l!==(l=l.replace(/Capture$/,"")),f=l.toLowerCase(),l=(f in n?f:l).slice(2),u?(t||n.addEventListener(l,N,o),(n.l||(n.l={}))[l]=u):n.removeEventListener(l,N,o)):"list"!==l&&"tagName"!==l&&"form"!==l&&"type"!==l&&"size"!==l&&!i&&l in n?n[l]=null==u?"":u:"function"!=typeof u&&"dangerouslySetInnerHTML"!==l&&(l!==(l=l.replace(/^xlink:?/,""))?null==u||!1===u?n.removeAttributeNS("http://www.w3.org/1999/xlink",l.toLowerCase()):n.setAttributeNS("http://www.w3.org/1999/xlink",l.toLowerCase(),u):null==u||!1===u&&!/^ar/.test(l)?n.removeAttribute(l):n.setAttribute(l,u));}function N(l){this.l[l.type](n$1.event?n$1.event(l):l);}function z(l,u,t,i,r,o,f,e,c){var s,p,v,h,x,m,w,k,_,b,P=u.type;if(void 0!==u.constructor)return null;(s=n$1.__b)&&s(u);try{n:if("function"==typeof P){if(k=u.props,_=(s=P.contextType)&&i[s.__c],b=s?_?_.props.value:s.__:i,t.__c?w=(p=u.__c=t.__c).__=p.__E:("prototype"in P&&P.prototype.render?u.__c=p=new P(k,b):(u.__c=p=new d$1(k,b),p.constructor=P,p.render=D),_&&_.sub(p),p.props=k,p.state||(p.state={}),p.context=b,p.__n=i,v=p.__d=!0,p.__h=[]),null==p.__s&&(p.__s=p.state),null!=P.getDerivedStateFromProps&&(p.__s==p.state&&(p.__s=a$1({},p.__s)),a$1(p.__s,P.getDerivedStateFromProps(k,p.__s))),h=p.props,x=p.state,v)null==P.getDerivedStateFromProps&&null!=p.componentWillMount&&p.componentWillMount(),null!=p.componentDidMount&&p.__h.push(p.componentDidMount);else {if(null==P.getDerivedStateFromProps&&k!==h&&null!=p.componentWillReceiveProps&&p.componentWillReceiveProps(k,b),!p.__e&&null!=p.shouldComponentUpdate&&!1===p.shouldComponentUpdate(k,p.__s,b)||u.__v===t.__v&&!p.__){for(p.props=k,p.state=p.__s,u.__v!==t.__v&&(p.__d=!1),p.__v=u,u.__e=t.__e,u.__k=t.__k,p.__h.length&&f.push(p),s=0;s<u.__k.length;s++)u.__k[s]&&(u.__k[s].__=u);break n}null!=p.componentWillUpdate&&p.componentWillUpdate(k,p.__s,b),null!=p.componentDidUpdate&&p.__h.push(function(){p.componentDidUpdate(h,x,m);});}p.context=b,p.props=k,p.state=p.__s,(s=n$1.__r)&&s(u),p.__d=!1,p.__v=u,p.__P=l,s=p.render(p.props,p.state,p.context),u.__k=null!=s&&s.type==y$1&&null==s.key?s.props.children:Array.isArray(s)?s:[s],null!=p.getChildContext&&(i=a$1(a$1({},i),p.getChildContext())),v||null==p.getSnapshotBeforeUpdate||(m=p.getSnapshotBeforeUpdate(h,x)),g(l,u,t,i,r,o,f,e,c),p.base=u.__e,p.__h.length&&f.push(p),w&&(p.__E=p.__=null),p.__e=!1;}else null==o&&u.__v===t.__v?(u.__k=t.__k,u.__e=t.__e):u.__e=T$1(t.__e,u,t,i,r,o,f,c);(s=n$1.diffed)&&s(u);}catch(l){u.__v=null,n$1.__e(l,u,t);}return u.__e}function A(l,u){n$1.__c&&n$1.__c(u,l),l.some(function(u){try{l=u.__h,u.__h=[],l.some(function(n){n.call(u);});}catch(l){n$1.__e(l,u.__v);}});}function T$1(n,l,u,t,i,r,o,f){var s,a,p,v,h,y=u.props,d=l.props;if(i="svg"===l.type||i,null!=r)for(s=0;s<r.length;s++)if(null!=(a=r[s])&&((null===l.type?3===a.nodeType:a.localName===l.type)||n==a)){n=a,r[s]=null;break}if(null==n){if(null===l.type)return document.createTextNode(d);n=i?document.createElementNS("http://www.w3.org/2000/svg",l.type):document.createElement(l.type,d.is&&{is:d.is}),r=null,f=!1;}if(null===l.type)y!==d&&n.data!=d&&(n.data=d);else {if(null!=r&&(r=c$1.slice.call(n.childNodes)),p=(y=u.props||e$1).dangerouslySetInnerHTML,v=d.dangerouslySetInnerHTML,!f){if(y===e$1)for(y={},h=0;h<n.attributes.length;h++)y[n.attributes[h].name]=n.attributes[h].value;(v||p)&&(v&&p&&v.__html==p.__html||(n.innerHTML=v&&v.__html||""));}b(n,d,y,i,f),v?l.__k=[]:(l.__k=l.props.children,g(n,l,u,t,"foreignObject"!==l.type&&i,r,o,e$1,f)),f||("value"in d&&void 0!==(s=d.value)&&s!==n.value&&C(n,"value",s,y.value,!1),"checked"in d&&void 0!==(s=d.checked)&&s!==n.checked&&C(n,"checked",s,y.checked,!1));}return n}function $(l,u,t){try{"function"==typeof l?l(u):l.current=u;}catch(l){n$1.__e(l,t);}}function j(l,u,t){var i,r,o;if(n$1.unmount&&n$1.unmount(l),(i=l.ref)&&(i.current&&i.current!==l.__e||$(i,null,u)),t||"function"==typeof l.type||(t=null!=(r=l.__e)),l.__e=l.__d=void 0,null!=(i=l.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount();}catch(l){n$1.__e(l,u);}i.base=i.__P=null;}if(i=l.__k)for(o=0;o<i.length;o++)i[o]&&j(i[o],u,t);null!=r&&p$1(r);}function D(n,l,u){return this.constructor(n,u)}function E(l,u,t){var i,r,f;n$1.__&&n$1.__(l,u),r=(i=t===o$1)?null:t&&t.__k||u.__k,l=v$1(y$1,null,[l]),f=[],z(u,(i?u:t||u).__k=l,r||e$1,e$1,void 0!==u.ownerSVGElement,t&&!i?[t]:r?null:c$1.slice.call(u.childNodes),f,t||e$1,i),A(f,l);}n$1={__e:function(n,l){for(var u,t;l=l.__;)if((u=l.__c)&&!u.__)try{if(u.constructor&&null!=u.constructor.getDerivedStateFromError&&(t=!0,u.setState(u.constructor.getDerivedStateFromError(n))),null!=u.componentDidCatch&&(t=!0,u.componentDidCatch(n)),t)return w(u.__E=u)}catch(l){n=l;}throw n}},l$1=function(n){return null!=n&&void 0===n.constructor},d$1.prototype.setState=function(n,l){var u;u=this.__s!==this.state?this.__s:this.__s=a$1({},this.state),"function"==typeof n&&(n=n(u,this.props)),n&&a$1(u,n),null!=n&&this.__v&&(l&&this.__h.push(l),w(this));},d$1.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),w(this));},d$1.prototype.render=y$1,u$1=[],t$1=0,i$1="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,o$1=e$1,f$1=0,preact.render=E,preact.hydrate=function(n,l){E(n,l,o$1);},preact.createElement=v$1,preact.h=v$1,preact.Fragment=y$1,preact.createRef=function(){return {}},preact.isValidElement=l$1,preact.Component=d$1,preact.cloneElement=function(n,l){var u,t;for(t in l=a$1(a$1({},n.props),l),arguments.length>2&&(l.children=c$1.slice.call(arguments,2)),u={},l)"key"!==t&&"ref"!==t&&(u[t]=l[t]);return h$1(n.type,u,l.key||n.key,l.ref||n.ref,null)},preact.createContext=function(n){var l={},u={__c:"__cC"+f$1++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var t,i=this;return this.getChildContext||(t=[],this.getChildContext=function(){return l[u.__c]=i,l},this.shouldComponentUpdate=function(n){i.props.value!==n.value&&t.some(function(l){l.context=n.value,w(l);});},this.sub=function(n){t.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){t.splice(t.indexOf(n),1),l&&l.call(n);};}),n.children}};return u.Consumer.contextType=u,u.Provider.__=u,u},preact.toChildArray=_,preact._e=j,preact.options=n$1;

    var n,t,r,u=preact,o=0,i=[],c=u.options.__r,e=u.options.diffed,f=u.options.__c,a=u.options.unmount;function p(n,r){u.options.__h&&u.options.__h(t,n,o||r),o=0;var i=t.__H||(t.__H={__:[],__h:[]});return n>=i.__.length&&i.__.push({}),i.__[n]}function v(n){return o=1,s(T,n)}function s(r,u,o){var i=p(n++,2);return i.__c||(i.__c=t,i.__=[o?o(u):T(void 0,u),function(n){var t=r(i.__[0],n);i.__[0]!==t&&(i.__[0]=t,i.__c.setState({}));}]),i.__}function x(r,o){var i=p(n++,4);!u.options.__s&&h(i.__H,o)&&(i.__=r,i.__H=o,t.__h.push(i));}function l(t,r){var u=p(n++,7);return h(u.__H,r)?(u.__H=r,u.__h=t,u.__=t()):u.__}function m(){i.some(function(n){if(n.__P)try{n.__H.__h.forEach(y),n.__H.__h.forEach(d),n.__H.__h=[];}catch(t){return n.__H.__h=[],u.options.__e(t,n.__v),!0}}),i=[];}function y(n){n.t&&n.t();}function d(n){var t=n.__();"function"==typeof t&&(n.t=t);}function h(n,t){return !n||t.some(function(t,r){return t!==n[r]})}function T(n,t){return "function"==typeof t?t(n):t}u.options.__r=function(r){c&&c(r),n=0,(t=r.__c).__H&&(t.__H.__h.forEach(y),t.__H.__h.forEach(d),t.__H.__h=[]);},u.options.diffed=function(n){e&&e(n);var t=n.__c;if(t){var o=t.__H;o&&o.__h.length&&(1!==i.push(t)&&r===u.options.requestAnimationFrame||((r=u.options.requestAnimationFrame)||function(n){var t,r=function(){clearTimeout(u),cancelAnimationFrame(t),setTimeout(n);},u=setTimeout(r,100);"undefined"!=typeof window&&(t=requestAnimationFrame(r));})(m));}},u.options.__c=function(n,t){t.some(function(n){try{n.__h.forEach(y),n.__h=n.__h.filter(function(n){return !n.__||d(n)});}catch(r){t.some(function(n){n.__h&&(n.__h=[]);}),t=[],u.options.__e(r,n.__v);}}),f&&f(n,t);},u.options.unmount=function(n){a&&a(n);var t=n.__c;if(t){var r=t.__H;if(r)try{r.__.forEach(function(n){return n.t&&n.t()});}catch(n){u.options.__e(n,t.__v);}}},hooks.useState=v,hooks.useReducer=s,hooks.useEffect=function(r,o){var i=p(n++,3);!u.options.__s&&h(i.__H,o)&&(i.__=r,i.__H=o,t.__H.__h.push(i));},hooks.useLayoutEffect=x,hooks.useRef=function(n){return o=5,l(function(){return {current:n}},[])},hooks.useImperativeHandle=function(n,t,r){o=6,x(function(){"function"==typeof n?n(t()):n&&(n.current=t());},null==r?r:r.concat(n));},hooks.useMemo=l,hooks.useCallback=function(n,t){return o=8,l(function(){return n},t)},hooks.useContext=function(r){var u=t.context[r.__c],o=p(n++,9);return o.__c=r,u?(null==o.__&&(o.__=!0,u.sub(t)),u.props.value):r.__},hooks.useDebugValue=function(n,t){u.options.useDebugValue&&u.options.useDebugValue(t?t(n):n);},hooks.useErrorBoundary=function(r){var u=p(n++,10),o=v();return u.__=r,t.componentDidCatch||(t.componentDidCatch=function(n){u.__&&u.__(n),o[1](n);}),[o[0],function(){o[1](void 0);}]};

    (function (exports) {
    var n=hooks,t=preact;function e(n,t){for(var e in t)n[e]=t[e];return n}function r(n,t){for(var e in n)if("__source"!==e&&!(e in t))return !0;for(var r in t)if("__source"!==r&&n[r]!==t[r])return !0;return !1}var o=function(n){var t,e;function o(t){var e;return (e=n.call(this,t)||this).isPureReactComponent=!0,e}return e=n,(t=o).prototype=Object.create(e.prototype),t.prototype.constructor=t,t.__proto__=e,o.prototype.shouldComponentUpdate=function(n,t){return r(this.props,n)||r(this.state,t)},o}(t.Component);function u(n,o){function u(n){var t=this.props.ref,e=t==n.ref;return !e&&t&&(t.call?t(null):t.current=null),o?!o(this.props,n)||!e:r(this.props,n)}function i(r){return this.shouldComponentUpdate=u,t.createElement(n,e({},r))}return i.prototype.isReactComponent=!0,i.displayName="Memo("+(n.displayName||n.name)+")",i.t=!0,i}var i=t.options.__b;function f(n){function t(t){var r=e({},t);return delete r.ref,n(r,t.ref)}return t.prototype.isReactComponent=t.t=!0,t.displayName="ForwardRef("+(n.displayName||n.name)+")",t}t.options.__b=function(n){n.type&&n.type.t&&n.ref&&(n.props.ref=n.ref,n.ref=null),i&&i(n);};var c=function(n,e){return n?t.toChildArray(n).reduce(function(n,t,r){return n.concat(e(t,r))},[]):null},l={map:c,forEach:c,count:function(n){return n?t.toChildArray(n).length:0},only:function(n){if(1!==(n=t.toChildArray(n)).length)throw new Error("Children.only() expects only one child.");return n[0]},toArray:t.toChildArray},a=t.options.__e;function s(n){return n&&((n=e({},n)).__c=null,n.__k=n.__k&&n.__k.map(s)),n}function p(){this.__u=0,this.o=null,this.__b=null;}function v(n){var t=n.__.__c;return t&&t.u&&t.u(n)}function h(n){var e,r,o;function u(u){if(e||(e=n()).then(function(n){r=n.default||n;},function(n){o=n;}),o)throw o;if(!r)throw e;return t.createElement(r,u)}return u.displayName="Lazy",u.t=!0,u}function d(){this.i=null,this.l=null;}t.options.__e=function(n,t,e){if(n.then)for(var r,o=t;o=o.__;)if((r=o.__c)&&r.__c)return r.__c(n,t.__c);a(n,t,e);},(p.prototype=new t.Component).__c=function(n,t){var e=this;null==e.o&&(e.o=[]),e.o.push(t);var r=v(e.__v),o=!1,u=function(){o||(o=!0,r?r(i):i());};t.__c=t.componentWillUnmount,t.componentWillUnmount=function(){u(),t.__c&&t.__c();};var i=function(){var n;if(!--e.__u)for(e.__v.__k[0]=e.state.u,e.setState({u:e.__b=null});n=e.o.pop();)n.forceUpdate();};e.__u++||e.setState({u:e.__b=e.__v.__k[0]}),n.then(u,u);},p.prototype.render=function(n,e){return this.__b&&(this.__v.__k[0]=s(this.__b),this.__b=null),[t.createElement(t.Component,null,e.u?null:n.children),e.u&&n.fallback]};var x=function(n,t,e){if(++e[1]===e[0]&&n.l.delete(t),n.props.revealOrder&&("t"!==n.props.revealOrder[0]||!n.l.size))for(e=n.i;e;){for(;e.length>3;)e.pop()();if(e[1]<e[0])break;n.i=e=e[2];}};(d.prototype=new t.Component).u=function(n){var t=this,e=v(t.__v),r=t.l.get(n);return r[0]++,function(o){var u=function(){t.props.revealOrder?(r.push(o),x(t,n,r)):o();};e?e(u):u();}},d.prototype.render=function(n){this.i=null,this.l=new Map;var e=t.toChildArray(n.children);n.revealOrder&&"b"===n.revealOrder[0]&&e.reverse();for(var r=e.length;r--;)this.l.set(e[r],this.i=[1,0,this.i]);return n.children},d.prototype.componentDidUpdate=d.prototype.componentDidMount=function(){var n=this;n.l.forEach(function(t,e){x(n,e,t);});};var m=function(){function n(){}var t=n.prototype;return t.getChildContext=function(){return this.props.context},t.render=function(n){return n.children},n}();function y(n){var e=this,r=n.container,o=t.createElement(m,{context:e.context},n.vnode);return e.s&&e.s!==r&&(e.p.parentNode&&e.s.removeChild(e.p),t._e(e.v),e.h=!1),n.vnode?e.h?(r.__k=e.__k,t.render(o,r),e.__k=r.__k):(e.p=document.createTextNode(""),t.hydrate("",r),r.appendChild(e.p),e.h=!0,e.s=r,t.render(o,r,e.p),e.__k=e.p.__k):e.h&&(e.p.parentNode&&e.s.removeChild(e.p),t._e(e.v)),e.v=o,e.componentWillUnmount=function(){e.p.parentNode&&e.s.removeChild(e.p),t._e(e.v);},null}function b(n,e){return t.createElement(y,{vnode:n,container:e})}var g=/^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/;t.Component.prototype.isReactComponent={};var w="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;function E(n,e,r){if(null==e.__k)for(;e.firstChild;)e.removeChild(e.firstChild);return t.render(n,e),"function"==typeof r&&r(),n?n.__c:null}var _=t.options.event;function A(n,t){n["UNSAFE_"+t]&&!n[t]&&Object.defineProperty(n,t,{configurable:!1,get:function(){return this["UNSAFE_"+t]},set:function(n){this["UNSAFE_"+t]=n;}});}t.options.event=function(n){_&&(n=_(n)),n.persist=function(){};var t=!1,e=!1,r=n.stopPropagation;n.stopPropagation=function(){r.call(n),t=!0;};var o=n.preventDefault;return n.preventDefault=function(){o.call(n),e=!0;},n.isPropagationStopped=function(){return t},n.isDefaultPrevented=function(){return e},n.nativeEvent=n};var C={configurable:!0,get:function(){return this.class}},S=t.options.vnode;function k(n){return t.createElement.bind(null,n)}function N(n){return !!n&&n.$$typeof===w}function R(n){return N(n)?t.cloneElement.apply(null,arguments):n}function U(n){return !!n.__k&&(t.render(null,n),!0)}function F(n){return n&&(n.base||1===n.nodeType&&n)||null}t.options.vnode=function(n){n.$$typeof=w;var e=n.type,r=n.props;if(e){if(r.class!=r.className&&(C.enumerable="className"in r,null!=r.className&&(r.class=r.className),Object.defineProperty(r,"className",C)),"function"!=typeof e){var o,u,i;for(i in r.defaultValue&&void 0!==r.value&&(r.value||0===r.value||(r.value=r.defaultValue),delete r.defaultValue),Array.isArray(r.value)&&r.multiple&&"select"===e&&(t.toChildArray(r.children).forEach(function(n){-1!=r.value.indexOf(n.props.value)&&(n.props.selected=!0);}),delete r.value),r)if(o=g.test(i))break;if(o)for(i in u=n.props={},r)u[g.test(i)?i.replace(/[A-Z0-9]/,"-$&").toLowerCase():i]=r[i];}!function(t){var e=n.type,r=n.props;if(r&&"string"==typeof e){var o={};for(var u in r)/^on(Ani|Tra|Tou)/.test(u)&&(r[u.toLowerCase()]=r[u],delete r[u]),o[u.toLowerCase()]=u;if(o.ondoubleclick&&(r.ondblclick=r[o.ondoubleclick],delete r[o.ondoubleclick]),o.onbeforeinput&&(r.onbeforeinput=r[o.onbeforeinput],delete r[o.onbeforeinput]),o.onchange&&("textarea"===e||"input"===e.toLowerCase()&&!/^fil|che|ra/i.test(r.type))){var i=o.oninput||"oninput";r[i]||(r[i]=r[o.onchange],delete r[o.onchange]);}}}(),"function"==typeof e&&!e.m&&e.prototype&&(A(e.prototype,"componentWillMount"),A(e.prototype,"componentWillReceiveProps"),A(e.prototype,"componentWillUpdate"),e.m=!0);}S&&S(n);};var M=function(n,t){return n(t)},O={useState:n.useState,useReducer:n.useReducer,useEffect:n.useEffect,useLayoutEffect:n.useLayoutEffect,useRef:n.useRef,useImperativeHandle:n.useImperativeHandle,useMemo:n.useMemo,useCallback:n.useCallback,useContext:n.useContext,useDebugValue:n.useDebugValue,version:"16.8.0",Children:l,render:E,hydrate:E,unmountComponentAtNode:U,createPortal:b,createElement:t.createElement,createContext:t.createContext,createFactory:k,cloneElement:R,createRef:t.createRef,Fragment:t.Fragment,isValidElement:N,findDOMNode:F,Component:t.Component,PureComponent:o,memo:u,forwardRef:f,unstable_batchedUpdates:M,Suspense:p,SuspenseList:d,lazy:h};Object.keys(n).forEach(function(t){exports[t]=n[t];}),exports.createElement=t.createElement,exports.createContext=t.createContext,exports.createRef=t.createRef,exports.Fragment=t.Fragment,exports.Component=t.Component,exports.version="16.8.0",exports.Children=l,exports.render=E,exports.hydrate=function(n,e,r){return t.hydrate(n,e),"function"==typeof r&&r(),n?n.__c:null},exports.unmountComponentAtNode=U,exports.createPortal=b,exports.createFactory=k,exports.cloneElement=R,exports.isValidElement=N,exports.findDOMNode=F,exports.PureComponent=o,exports.memo=u,exports.forwardRef=f,exports.unstable_batchedUpdates=M,exports.Suspense=p,exports.SuspenseList=d,exports.lazy=h,exports.default=O;

    }(compat));

    var dist$1 = {};

    var sanitizer$1 = {};

    var purify = {exports: {}};

    /*! @license DOMPurify 3.0.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.3/LICENSE */

    (function (module, exports) {
    (function (global, factory) {
      module.exports = factory() ;
    })(commonjsGlobal, (function () {
      const {
        entries,
        setPrototypeOf,
        isFrozen,
        getPrototypeOf,
        getOwnPropertyDescriptor
      } = Object;
      let {
        freeze,
        seal,
        create
      } = Object; // eslint-disable-line import/no-mutable-exports

      let {
        apply,
        construct
      } = typeof Reflect !== 'undefined' && Reflect;

      if (!apply) {
        apply = function apply(fun, thisValue, args) {
          return fun.apply(thisValue, args);
        };
      }

      if (!freeze) {
        freeze = function freeze(x) {
          return x;
        };
      }

      if (!seal) {
        seal = function seal(x) {
          return x;
        };
      }

      if (!construct) {
        construct = function construct(Func, args) {
          return new Func(...args);
        };
      }

      const arrayForEach = unapply(Array.prototype.forEach);
      const arrayPop = unapply(Array.prototype.pop);
      const arrayPush = unapply(Array.prototype.push);
      const stringToLowerCase = unapply(String.prototype.toLowerCase);
      const stringToString = unapply(String.prototype.toString);
      const stringMatch = unapply(String.prototype.match);
      const stringReplace = unapply(String.prototype.replace);
      const stringIndexOf = unapply(String.prototype.indexOf);
      const stringTrim = unapply(String.prototype.trim);
      const regExpTest = unapply(RegExp.prototype.test);
      const typeErrorCreate = unconstruct(TypeError);
      function unapply(func) {
        return function (thisArg) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          return apply(func, thisArg, args);
        };
      }
      function unconstruct(func) {
        return function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return construct(func, args);
        };
      }
      /* Add properties to a lookup table */

      function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;

        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;

        if (setPrototypeOf) {
          // Make 'in' and truthy checks like Boolean(set.constructor)
          // independent of any properties defined on Object.prototype.
          // Prevent prototype setters from intercepting set as a this value.
          setPrototypeOf(set, null);
        }

        let l = array.length;

        while (l--) {
          let element = array[l];

          if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);

            if (lcElement !== element) {
              // Config presets (e.g. tags.js, attrs.js) are immutable.
              if (!isFrozen(array)) {
                array[l] = lcElement;
              }

              element = lcElement;
            }
          }

          set[element] = true;
        }

        return set;
      }
      /* Shallow clone an object */

      function clone(object) {
        const newObject = create(null);

        for (const [property, value] of entries(object)) {
          newObject[property] = value;
        }

        return newObject;
      }
      /* This method automatically checks if the prop is function
       * or getter and behaves accordingly. */

      function lookupGetter(object, prop) {
        while (object !== null) {
          const desc = getOwnPropertyDescriptor(object, prop);

          if (desc) {
            if (desc.get) {
              return unapply(desc.get);
            }

            if (typeof desc.value === 'function') {
              return unapply(desc.value);
            }
          }

          object = getPrototypeOf(object);
        }

        function fallbackValue(element) {
          console.warn('fallback value for', element);
          return null;
        }

        return fallbackValue;
      }

      const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

      const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
      const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
      // We still need to know them so that we can do namespace
      // checks properly in case one wants to add them to
      // allow-list.

      const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
      const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']); // Similarly to SVG, we want to know all MathML elements,
      // even those that we disallow by default.

      const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
      const text = freeze(['#text']);

      const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
      const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
      const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
      const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

      const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

      const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
      const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
      const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

      const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

      const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
      );
      const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
      const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
      );
      const DOCTYPE_NAME = seal(/^html$/i);

      var EXPRESSIONS = /*#__PURE__*/Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        ERB_EXPR: ERB_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR,
        DATA_ATTR: DATA_ATTR,
        ARIA_ATTR: ARIA_ATTR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        DOCTYPE_NAME: DOCTYPE_NAME
      });

      const getGlobal = () => typeof window === 'undefined' ? null : window;
      /**
       * Creates a no-op policy for internal use only.
       * Don't export this function outside this module!
       * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
       * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
       * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
       * are not supported or creating the policy failed).
       */


      const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
          return null;
        } // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.


        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';

        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
          suffix = purifyHostElement.getAttribute(ATTR_NAME);
        }

        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');

        try {
          return trustedTypes.createPolicy(policyName, {
            createHTML(html) {
              return html;
            },

            createScriptURL(scriptUrl) {
              return scriptUrl;
            }

          });
        } catch (_) {
          // Policy creation failed (most likely another DOMPurify script has
          // already run). Skip creating the policy, as this will only cause errors
          // if TT are enforced.
          console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
          return null;
        }
      };

      function createDOMPurify() {
        let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

        const DOMPurify = root => createDOMPurify(root);
        /**
         * Version label, exposed for easier checks
         * if DOMPurify is up to date or not
         */


        DOMPurify.version = '3.0.3';
        /**
         * Array of elements that DOMPurify removed during sanitation.
         * Empty if nothing was removed.
         */

        DOMPurify.removed = [];

        if (!window || !window.document || window.document.nodeType !== 9) {
          // Not running in a browser, provide a factory function
          // so that you can pass your own Window
          DOMPurify.isSupported = false;
          return DOMPurify;
        }

        const originalDocument = window.document;
        const currentScript = originalDocument.currentScript;
        let {
          document
        } = window;
        const {
          DocumentFragment,
          HTMLTemplateElement,
          Node,
          Element,
          NodeFilter,
          NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
          HTMLFormElement,
          DOMParser,
          trustedTypes
        } = window;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.

        if (typeof HTMLTemplateElement === 'function') {
          const template = document.createElement('template');

          if (template.content && template.content.ownerDocument) {
            document = template.content.ownerDocument;
          }
        }

        let trustedTypesPolicy;
        let emptyHTML = '';
        const {
          implementation,
          createNodeIterator,
          createDocumentFragment,
          getElementsByTagName
        } = document;
        const {
          importNode
        } = originalDocument;
        let hooks = {};
        /**
         * Expose whether this browser supports running the full DOMPurify.
         */

        DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const {
          MUSTACHE_EXPR,
          ERB_EXPR,
          TMPLIT_EXPR,
          DATA_ATTR,
          ARIA_ATTR,
          IS_SCRIPT_OR_DATA,
          ATTR_WHITESPACE
        } = EXPRESSIONS;
        let {
          IS_ALLOWED_URI: IS_ALLOWED_URI$1
        } = EXPRESSIONS;
        /**
         * We consider the elements and attributes below to be safe. Ideally
         * don't add any new ones but feel free to remove unwanted ones.
         */

        /* allowed element names */

        let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
        /* Allowed attribute names */

        let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
        /*
         * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
         * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
         * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
         * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
         */

        let CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
          tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
          },
          attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
          },
          allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
          }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

        let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

        let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */

        let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */

        let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */

        let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
         * Usually removed due to a mXSS issue in jQuery 3.0 */

        let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
         * This means, DOMPurify removes data attributes, mustaches and ERB
         */

        let SAFE_FOR_TEMPLATES = false;
        /* Decide if document with <html>... should be returned */

        let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */

        let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
         * document.body. By default, browsers might move them to document.head */

        let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
         * string (or a TrustedHTML object if Trusted Types are supported).
         * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
         */

        let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
         * string  (or a TrustedHTML object if Trusted Types are supported) */

        let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
         * case Trusted Types are not supported  */

        let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
         * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
         */

        let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
         * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
         *
         * HTML/DOM spec rules that enable DOM Clobbering:
         *   - Named Access on Window (§7.3.3)
         *   - DOM Tree Accessors (§3.1.5)
         *   - Form Element Parent-Child Relations (§4.10.3)
         *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
         *   - HTMLCollection (§4.2.10.2)
         *
         * Namespace isolation is implemented by prefixing `id` and `name` attributes
         * with a constant string, i.e., `user-content-`
         */

        let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */

        let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
         * of importing it into a new Document and returning a sanitized copy */

        let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */

        let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */

        let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
        /* Tags that are safe for data: URIs */

        let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
        /* Attributes safe for values like "javascript:" */

        let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */

        let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */

        let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
        /* Parsing of strict XHTML documents */

        let PARSER_MEDIA_TYPE;
        const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc;
        /* Keep a reference to config to pass to hooks */

        let CONFIG = null;
        /* Ideally, do not touch anything below this line */

        /* ______________________________________________ */

        const formElement = document.createElement('form');

        const isRegexOrFunction = function isRegexOrFunction(testValue) {
          return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
         * _parseConfig
         *
         * @param  {Object} cfg optional config literal
         */
        // eslint-disable-next-line complexity


        const _parseConfig = function _parseConfig(cfg) {
          if (CONFIG && CONFIG === cfg) {
            return;
          }
          /* Shield configuration object from tampering */


          if (!cfg || typeof cfg !== 'object') {
            cfg = {};
          }
          /* Shield configuration object from prototype pollution */


          cfg = clone(cfg);
          PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
          SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

          transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
          /* Set configuration parameters */

          ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
          ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
          ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
          URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
          cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
          transformCaseFunc // eslint-disable-line indent
          ) // eslint-disable-line indent
          : DEFAULT_URI_SAFE_ATTRIBUTES;
          DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
          cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
          transformCaseFunc // eslint-disable-line indent
          ) // eslint-disable-line indent
          : DEFAULT_DATA_URI_TAGS;
          FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
          FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
          FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
          USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
          ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

          ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

          ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

          ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

          SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

          WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

          RETURN_DOM = cfg.RETURN_DOM || false; // Default false

          RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

          RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

          FORCE_BODY = cfg.FORCE_BODY || false; // Default false

          SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

          SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

          KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

          IN_PLACE = cfg.IN_PLACE || false; // Default false

          IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
          NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
          CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

          if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
            CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
          }

          if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
            CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
          }

          if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
            CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
          }

          if (SAFE_FOR_TEMPLATES) {
            ALLOW_DATA_ATTR = false;
          }

          if (RETURN_DOM_FRAGMENT) {
            RETURN_DOM = true;
          }
          /* Parse profile info */


          if (USE_PROFILES) {
            ALLOWED_TAGS = addToSet({}, [...text]);
            ALLOWED_ATTR = [];

            if (USE_PROFILES.html === true) {
              addToSet(ALLOWED_TAGS, html$1);
              addToSet(ALLOWED_ATTR, html);
            }

            if (USE_PROFILES.svg === true) {
              addToSet(ALLOWED_TAGS, svg$1);
              addToSet(ALLOWED_ATTR, svg);
              addToSet(ALLOWED_ATTR, xml);
            }

            if (USE_PROFILES.svgFilters === true) {
              addToSet(ALLOWED_TAGS, svgFilters);
              addToSet(ALLOWED_ATTR, svg);
              addToSet(ALLOWED_ATTR, xml);
            }

            if (USE_PROFILES.mathMl === true) {
              addToSet(ALLOWED_TAGS, mathMl$1);
              addToSet(ALLOWED_ATTR, mathMl);
              addToSet(ALLOWED_ATTR, xml);
            }
          }
          /* Merge configuration parameters */


          if (cfg.ADD_TAGS) {
            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
              ALLOWED_TAGS = clone(ALLOWED_TAGS);
            }

            addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
          }

          if (cfg.ADD_ATTR) {
            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
              ALLOWED_ATTR = clone(ALLOWED_ATTR);
            }

            addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
          }

          if (cfg.ADD_URI_SAFE_ATTR) {
            addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
          }

          if (cfg.FORBID_CONTENTS) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
              FORBID_CONTENTS = clone(FORBID_CONTENTS);
            }

            addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
          }
          /* Add #text in case KEEP_CONTENT is set to true */


          if (KEEP_CONTENT) {
            ALLOWED_TAGS['#text'] = true;
          }
          /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


          if (WHOLE_DOCUMENT) {
            addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
          }
          /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


          if (ALLOWED_TAGS.table) {
            addToSet(ALLOWED_TAGS, ['tbody']);
            delete FORBID_TAGS.tbody;
          }

          if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
              throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            }

            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
              throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            } // Overwrite existing TrustedTypes policy.


            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY; // Sign local variables required by `sanitize`.

            emptyHTML = trustedTypesPolicy.createHTML('');
          } else {
            // Uninitialized policy, attempt to initialize the internal dompurify policy.
            if (trustedTypesPolicy === undefined) {
              trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
            } // If creating the internal policy succeeded sign internal variables.


            if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
              emptyHTML = trustedTypesPolicy.createHTML('');
            }
          } // Prevent further manipulation of configuration.
          // Not available in IE8, Safari 5, etc.


          if (freeze) {
            freeze(cfg);
          }

          CONFIG = cfg;
        };

        const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
        const HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.

        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
        /* Keep track of all possible SVG and MathML tags
         * so that we can perform the namespace checks
         * correctly. */

        const ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        const ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
         *
         *
         * @param  {Element} element a DOM element whose namespace is being checked
         * @returns {boolean} Return false if the element has a
         *  namespace that a spec-compliant parser would never
         *  return. Return true otherwise.
         */

        const _checkValidNamespace = function _checkValidNamespace(element) {
          let parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
          // can be null. We just simulate parent in this case.

          if (!parent || !parent.tagName) {
            parent = {
              namespaceURI: NAMESPACE,
              tagName: 'template'
            };
          }

          const tagName = stringToLowerCase(element.tagName);
          const parentTagName = stringToLowerCase(parent.tagName);

          if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
            return false;
          }

          if (element.namespaceURI === SVG_NAMESPACE) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) {
              return tagName === 'svg';
            } // The only way to switch from MathML to SVG is via`
            // svg if parent is either <annotation-xml> or MathML
            // text integration points.


            if (parent.namespaceURI === MATHML_NAMESPACE) {
              return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            } // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.


            return Boolean(ALL_SVG_TAGS[tagName]);
          }

          if (element.namespaceURI === MATHML_NAMESPACE) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) {
              return tagName === 'math';
            } // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points


            if (parent.namespaceURI === SVG_NAMESPACE) {
              return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
            } // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.


            return Boolean(ALL_MATHML_TAGS[tagName]);
          }

          if (element.namespaceURI === HTML_NAMESPACE) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
              return false;
            }

            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
              return false;
            } // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace


            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
          } // For XHTML and XML documents that support custom namespaces


          if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
            return true;
          } // The code should never reach this place (this means
          // that the element somehow got namespace that is not
          // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
          // Return false just in case.


          return false;
        };
        /**
         * _forceRemove
         *
         * @param  {Node} node a DOM node
         */


        const _forceRemove = function _forceRemove(node) {
          arrayPush(DOMPurify.removed, {
            element: node
          });

          try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            node.parentNode.removeChild(node);
          } catch (_) {
            node.remove();
          }
        };
        /**
         * _removeAttribute
         *
         * @param  {String} name an Attribute name
         * @param  {Node} node a DOM node
         */


        const _removeAttribute = function _removeAttribute(name, node) {
          try {
            arrayPush(DOMPurify.removed, {
              attribute: node.getAttributeNode(name),
              from: node
            });
          } catch (_) {
            arrayPush(DOMPurify.removed, {
              attribute: null,
              from: node
            });
          }

          node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

          if (name === 'is' && !ALLOWED_ATTR[name]) {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
              try {
                _forceRemove(node);
              } catch (_) {}
            } else {
              try {
                node.setAttribute(name, '');
              } catch (_) {}
            }
          }
        };
        /**
         * _initDocument
         *
         * @param  {String} dirty a string of dirty markup
         * @return {Document} a DOM, filled with the dirty markup
         */


        const _initDocument = function _initDocument(dirty) {
          /* Create a HTML document */
          let doc;
          let leadingWhitespace;

          if (FORCE_BODY) {
            dirty = '<remove></remove>' + dirty;
          } else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
            const matches = stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
          }

          if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
            // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
          }

          const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
          /*
           * Use the DOMParser API by default, fallback later if needs be
           * DOMParser not work for svg when has multiple root element.
           */

          if (NAMESPACE === HTML_NAMESPACE) {
            try {
              doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
          }
          /* Use createHTMLDocument in case DOMParser is not available */


          if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);

            try {
              doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {// Syntax error if dirtyPayload is invalid xml
            }
          }

          const body = doc.body || doc.documentElement;

          if (dirty && leadingWhitespace) {
            body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
          }
          /* Work on whole document or just its body */


          if (NAMESPACE === HTML_NAMESPACE) {
            return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
          }

          return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
         * _createIterator
         *
         * @param  {Document} root document/fragment to create iterator for
         * @return {Iterator} iterator instance
         */


        const _createIterator = function _createIterator(root) {
          return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
          NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
        };
        /**
         * _isClobbered
         *
         * @param  {Node} elm element to check for clobbering attacks
         * @return {Boolean} true if clobbered, false if safe
         */


        const _isClobbered = function _isClobbered(elm) {
          return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
         * _isNode
         *
         * @param  {Node} obj object to check whether it's a DOM node
         * @return {Boolean} true is object is a DOM node
         */


        const _isNode = function _isNode(object) {
          return typeof Node === 'object' ? object instanceof Node : object && typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
         * _executeHook
         * Execute user configurable hooks
         *
         * @param  {String} entryPoint  Name of the hook's entry point
         * @param  {Node} currentNode node to work on with the hook
         * @param  {Object} data additional hook parameters
         */


        const _executeHook = function _executeHook(entryPoint, currentNode, data) {
          if (!hooks[entryPoint]) {
            return;
          }

          arrayForEach(hooks[entryPoint], hook => {
            hook.call(DOMPurify, currentNode, data, CONFIG);
          });
        };
        /**
         * _sanitizeElements
         *
         * @protect nodeName
         * @protect textContent
         * @protect removeChild
         *
         * @param   {Node} currentNode to check for permission to exist
         * @return  {Boolean} true if node was killed, false if left alive
         */


        const _sanitizeElements = function _sanitizeElements(currentNode) {
          let content;
          /* Execute a hook if present */

          _executeHook('beforeSanitizeElements', currentNode, null);
          /* Check if element is clobbered or can clobber */


          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);

            return true;
          }
          /* Now let's check the element's type and name */


          const tagName = transformCaseFunc(currentNode.nodeName);
          /* Execute a hook if present */

          _executeHook('uponSanitizeElement', currentNode, {
            tagName,
            allowedTags: ALLOWED_TAGS
          });
          /* Detect mXSS attempts abusing namespace confusion */


          if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
            _forceRemove(currentNode);

            return true;
          }
          /* Remove element if anything forbids its presence */


          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            /* Check if we have a custom element to handle */
            if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
              if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
              if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
            }
            /* Keep content except for bad-listed elements */


            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
              const parentNode = getParentNode(currentNode) || currentNode.parentNode;
              const childNodes = getChildNodes(currentNode) || currentNode.childNodes;

              if (childNodes && parentNode) {
                const childCount = childNodes.length;

                for (let i = childCount - 1; i >= 0; --i) {
                  parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                }
              }
            }

            _forceRemove(currentNode);

            return true;
          }
          /* Check whether element has a valid namespace */


          if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);

            return true;
          }
          /* Make sure that older browsers don't get noscript mXSS */


          if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
            _forceRemove(currentNode);

            return true;
          }
          /* Sanitize element content to be template-safe */


          if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
            /* Get the element's text content */
            content = currentNode.textContent;
            content = stringReplace(content, MUSTACHE_EXPR, ' ');
            content = stringReplace(content, ERB_EXPR, ' ');
            content = stringReplace(content, TMPLIT_EXPR, ' ');

            if (currentNode.textContent !== content) {
              arrayPush(DOMPurify.removed, {
                element: currentNode.cloneNode()
              });
              currentNode.textContent = content;
            }
          }
          /* Execute a hook if present */


          _executeHook('afterSanitizeElements', currentNode, null);

          return false;
        };
        /**
         * _isValidAttribute
         *
         * @param  {string} lcTag Lowercase tag name of containing element.
         * @param  {string} lcName Lowercase attribute name.
         * @param  {string} value Attribute value.
         * @return {Boolean} Returns true if `value` is valid, otherwise false.
         */
        // eslint-disable-next-line complexity


        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
          /* Make sure attribute cannot clobber */
          if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
            return false;
          }
          /* Allow valid data-* attributes: At least one character after "-"
              (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
              XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
              We don't need to check the value; it's always URI safe. */


          if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
            if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
              return false;
            }
            /* Check value is safe. First, is attr inert? If so, is safe */

          } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if (value) {
            return false;
          } else ;

          return true;
        };
        /**
         * _basicCustomElementCheck
         * checks if at least one dash is included in tagName, and it's not the first char
         * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
         * @param {string} tagName name of the tag of the node to sanitize
         */


        const _basicCustomElementTest = function _basicCustomElementTest(tagName) {
          return tagName.indexOf('-') > 0;
        };
        /**
         * _sanitizeAttributes
         *
         * @protect attributes
         * @protect nodeName
         * @protect removeAttribute
         * @protect setAttribute
         *
         * @param  {Node} currentNode to sanitize
         */


        const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
          let attr;
          let value;
          let lcName;
          let l;
          /* Execute a hook if present */

          _executeHook('beforeSanitizeAttributes', currentNode, null);

          const {
            attributes
          } = currentNode;
          /* Check if we have attributes; if not we might have a text node */

          if (!attributes) {
            return;
          }

          const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR
          };
          l = attributes.length;
          /* Go backwards over all attributes; safely remove bad ones */

          while (l--) {
            attr = attributes[l];
            const {
              name,
              namespaceURI
            } = attr;
            value = name === 'value' ? attr.value : stringTrim(attr.value);
            lcName = transformCaseFunc(name);
            /* Execute a hook if present */

            hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

            _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

            value = hookEvent.attrValue;
            /* Did the hooks approve of the attribute? */

            if (hookEvent.forceKeepAttr) {
              continue;
            }
            /* Remove attribute */


            _removeAttribute(name, currentNode);
            /* Did the hooks approve of the attribute? */


            if (!hookEvent.keepAttr) {
              continue;
            }
            /* Work around a security issue in jQuery 3.0 */


            if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
              _removeAttribute(name, currentNode);

              continue;
            }
            /* Sanitize attribute content to be template-safe */


            if (SAFE_FOR_TEMPLATES) {
              value = stringReplace(value, MUSTACHE_EXPR, ' ');
              value = stringReplace(value, ERB_EXPR, ' ');
              value = stringReplace(value, TMPLIT_EXPR, ' ');
            }
            /* Is `value` valid for this attribute? */


            const lcTag = transformCaseFunc(currentNode.nodeName);

            if (!_isValidAttribute(lcTag, lcName, value)) {
              continue;
            }
            /* Full DOM Clobbering protection via namespace isolation,
             * Prefix id and name attributes with `user-content-`
             */


            if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
              // Remove the attribute with this value
              _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


              value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            /* Handle attributes that require Trusted Types */


            if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
              if (namespaceURI) ; else {
                switch (trustedTypes.getAttributeType(lcTag, lcName)) {
                  case 'TrustedHTML':
                    {
                      value = trustedTypesPolicy.createHTML(value);
                      break;
                    }

                  case 'TrustedScriptURL':
                    {
                      value = trustedTypesPolicy.createScriptURL(value);
                      break;
                    }
                }
              }
            }
            /* Handle invalid data-* attribute set by try-catching it */


            try {
              if (namespaceURI) {
                currentNode.setAttributeNS(namespaceURI, name, value);
              } else {
                /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
                currentNode.setAttribute(name, value);
              }

              arrayPop(DOMPurify.removed);
            } catch (_) {}
          }
          /* Execute a hook if present */


          _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
         * _sanitizeShadowDOM
         *
         * @param  {DocumentFragment} fragment to iterate over recursively
         */


        const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
          let shadowNode;

          const shadowIterator = _createIterator(fragment);
          /* Execute a hook if present */


          _executeHook('beforeSanitizeShadowDOM', fragment, null);

          while (shadowNode = shadowIterator.nextNode()) {
            /* Execute a hook if present */
            _executeHook('uponSanitizeShadowNode', shadowNode, null);
            /* Sanitize tags and elements */


            if (_sanitizeElements(shadowNode)) {
              continue;
            }
            /* Deep shadow DOM detected */


            if (shadowNode.content instanceof DocumentFragment) {
              _sanitizeShadowDOM(shadowNode.content);
            }
            /* Check attributes, sanitize if necessary */


            _sanitizeAttributes(shadowNode);
          }
          /* Execute a hook if present */


          _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
         * Sanitize
         * Public method providing core sanitation functionality
         *
         * @param {String|Node} dirty string or DOM node
         * @param {Object} configuration object
         */
        // eslint-disable-next-line complexity


        DOMPurify.sanitize = function (dirty) {
          let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          let body;
          let importedNode;
          let currentNode;
          let returnNode;
          /* Make sure we have a string to sanitize.
            DO NOT return early, as this will return the wrong type if
            the user has requested a DOM object rather than a string */

          IS_EMPTY_INPUT = !dirty;

          if (IS_EMPTY_INPUT) {
            dirty = '<!-->';
          }
          /* Stringify, in case dirty is an object */


          if (typeof dirty !== 'string' && !_isNode(dirty)) {
            if (typeof dirty.toString === 'function') {
              dirty = dirty.toString();

              if (typeof dirty !== 'string') {
                throw typeErrorCreate('dirty is not a string, aborting');
              }
            } else {
              throw typeErrorCreate('toString is not a function');
            }
          }
          /* Return dirty HTML if DOMPurify cannot run */


          if (!DOMPurify.isSupported) {
            return dirty;
          }
          /* Assign config vars */


          if (!SET_CONFIG) {
            _parseConfig(cfg);
          }
          /* Clean up removed elements */


          DOMPurify.removed = [];
          /* Check if dirty is correctly typed for IN_PLACE */

          if (typeof dirty === 'string') {
            IN_PLACE = false;
          }

          if (IN_PLACE) {
            /* Do some early pre-sanitization to avoid unsafe root nodes */
            if (dirty.nodeName) {
              const tagName = transformCaseFunc(dirty.nodeName);

              if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
              }
            }
          } else if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
               elements being stripped by the parser */
            body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);

            if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
              /* Node is already a body, use as is */
              body = importedNode;
            } else if (importedNode.nodeName === 'HTML') {
              body = importedNode;
            } else {
              // eslint-disable-next-line unicorn/prefer-dom-node-append
              body.appendChild(importedNode);
            }
          } else {
            /* Exit directly if we have nothing to do */
            if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) {
              return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
            }
            /* Initialize the document to work on */


            body = _initDocument(dirty);
            /* Check we have a DOM node from the data */

            if (!body) {
              return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
          }
          /* Remove first element node (ours) if FORCE_BODY is set */


          if (body && FORCE_BODY) {
            _forceRemove(body.firstChild);
          }
          /* Get node iterator */


          const nodeIterator = _createIterator(IN_PLACE ? dirty : body);
          /* Now start iterating over the created document */


          while (currentNode = nodeIterator.nextNode()) {
            /* Sanitize tags and elements */
            if (_sanitizeElements(currentNode)) {
              continue;
            }
            /* Shadow DOM detected, sanitize it */


            if (currentNode.content instanceof DocumentFragment) {
              _sanitizeShadowDOM(currentNode.content);
            }
            /* Check attributes, sanitize if necessary */


            _sanitizeAttributes(currentNode);
          }
          /* If we sanitized `dirty` in-place, return it. */


          if (IN_PLACE) {
            return dirty;
          }
          /* Return sanitized string or DOM */


          if (RETURN_DOM) {
            if (RETURN_DOM_FRAGMENT) {
              returnNode = createDocumentFragment.call(body.ownerDocument);

              while (body.firstChild) {
                // eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
              }
            } else {
              returnNode = body;
            }

            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
              /*
                AdoptNode() is not used because internal state is not reset
                (e.g. the past names map of a HTMLFormElement), this is safe
                in theory but we would rather not risk another attack vector.
                The state that is cloned by importNode() is explicitly defined
                by the specs.
              */
              returnNode = importNode.call(originalDocument, returnNode, true);
            }

            return returnNode;
          }

          let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
          /* Serialize doctype if allowed */

          if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
            serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
          }
          /* Sanitize final string template-safe */


          if (SAFE_FOR_TEMPLATES) {
            serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR, ' ');
            serializedHTML = stringReplace(serializedHTML, ERB_EXPR, ' ');
            serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR, ' ');
          }

          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
         * Public method to set the configuration once
         * setConfig
         *
         * @param {Object} cfg configuration object
         */


        DOMPurify.setConfig = function (cfg) {
          _parseConfig(cfg);

          SET_CONFIG = true;
        };
        /**
         * Public method to remove the configuration
         * clearConfig
         *
         */


        DOMPurify.clearConfig = function () {
          CONFIG = null;
          SET_CONFIG = false;
        };
        /**
         * Public method to check if an attribute value is valid.
         * Uses last set config, if any. Otherwise, uses config defaults.
         * isValidAttribute
         *
         * @param  {string} tag Tag name of containing element.
         * @param  {string} attr Attribute name.
         * @param  {string} value Attribute value.
         * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
         */


        DOMPurify.isValidAttribute = function (tag, attr, value) {
          /* Initialize shared config vars if necessary. */
          if (!CONFIG) {
            _parseConfig({});
          }

          const lcTag = transformCaseFunc(tag);
          const lcName = transformCaseFunc(attr);
          return _isValidAttribute(lcTag, lcName, value);
        };
        /**
         * AddHook
         * Public method to add DOMPurify hooks
         *
         * @param {String} entryPoint entry point for the hook to add
         * @param {Function} hookFunction function to execute
         */


        DOMPurify.addHook = function (entryPoint, hookFunction) {
          if (typeof hookFunction !== 'function') {
            return;
          }

          hooks[entryPoint] = hooks[entryPoint] || [];
          arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
         * RemoveHook
         * Public method to remove a DOMPurify hook at a given entryPoint
         * (pops it from the stack of hooks if more are present)
         *
         * @param {String} entryPoint entry point for the hook to remove
         * @return {Function} removed(popped) hook
         */


        DOMPurify.removeHook = function (entryPoint) {
          if (hooks[entryPoint]) {
            return arrayPop(hooks[entryPoint]);
          }
        };
        /**
         * RemoveHooks
         * Public method to remove all DOMPurify hooks at a given entryPoint
         *
         * @param  {String} entryPoint entry point for the hooks to remove
         */


        DOMPurify.removeHooks = function (entryPoint) {
          if (hooks[entryPoint]) {
            hooks[entryPoint] = [];
          }
        };
        /**
         * RemoveAllHooks
         * Public method to remove all DOMPurify hooks
         *
         */


        DOMPurify.removeAllHooks = function () {
          hooks = {};
        };

        return DOMPurify;
      }

      var purify = createDOMPurify();

      return purify;

    }));

    }(purify));

    var browser = window.DOMPurify || (window.DOMPurify = purify.exports.default || purify.exports);

    var customSanitizers = {};

    (function (exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = void 0;
    var ELEMENT_ATTRIBUTE_VALIDATIONS = {
      iframe: {
        // This list should match the one in interblocks.ts https://github.com/intercom/interblocks.ts/blob/2ce1fc14f7b05b15f44bc763c675953f1c90373a/src/compile/validations.ts#L76
        src: [/^https:\/\/www\.youtube\.com\/embed\/.+/, /^https:\/\/www\.loom\.com\/embed\/.+/, /^https:\/\/play\.vidyard\.com\//, /^https:\/\/player\.vimeo\.com\/video\/.+/, /^https:\/\/fast\.wistia\.net\/embed\/iframe\/.+/]
      }
    };
    var _default = {
      IFRAME: function IFRAME(node, _data) {
        var src = node.attributes["src"];
        if (!src || !ELEMENT_ATTRIBUTE_VALIDATIONS.iframe.src.some(function (regex) {
          return regex.test(src.value);
        })) {
          node.remove();
        }
      }
    };
    exports["default"] = _default;
    }(customSanitizers));

    var config = {};

    var emailTemplate = {};

    var htmlBlock = {};

    Object.defineProperty(htmlBlock, "__esModule", {
      value: true
    });
    htmlBlock.HTML_BLOCK_CONFIG = void 0;
    // Config from https://github.com/intercom/intercom/blob/master/gems/intercom-message-content-sanitization/lib/message_content_sanitization/sanitizers/config/custom_template.rb
    var HTML_BLOCK_CONFIG = {
      ADD_TAGS: ["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"],
      ADD_ATTR: ["abbr", "align", "allowfullscreen", "alt", "axis", "background", "bgcolor", "border", "cellpadding", "cellspacing", "charset", "cite", "class", "colspan", "content", "datetime", "dir", "frameborder", "height", "href", "http-equiv", "id", "ite", "lang", "name", "pubdate", "reversed", "rowspan", "scope", "span", "src", "start", "style", "summary", "target", "target", "title", "type", "valign", "width", "xmlns"]
    };
    htmlBlock.HTML_BLOCK_CONFIG = HTML_BLOCK_CONFIG;

    Object.defineProperty(emailTemplate, "__esModule", {
      value: true
    });
    emailTemplate.EMAIL_TEMPLATE_CONFIG = void 0;
    var _htmlBlock = htmlBlock;
    // Config from https://github.com/intercom/intercom/blob/master/gems/intercom-message-content-sanitization/lib/message_content_sanitization/sanitizers/config/custom_template.rb
    var EMAIL_TEMPLATE_CONFIG = Object.assign({}, _htmlBlock.HTML_BLOCK_CONFIG, {
      WHOLE_DOCUMENT: true
    });
    emailTemplate.EMAIL_TEMPLATE_CONFIG = EMAIL_TEMPLATE_CONFIG;

    var _default$1 = {};

    Object.defineProperty(_default$1, "__esModule", {
      value: true
    });
    _default$1.DEFAULT_CONFIG = void 0;
    var COMPOSER_ALLOWED_CUSTOM_ELEMENTS = ["ic-attribute", "ic-block", "ic-marker", "ic-mention"];
    var DEFAULT_CONFIG = {
      ADD_TAGS: ["iframe"],
      ADD_ATTR: ["allowfullscreen", "frameborder", "target"],
      CUSTOM_ELEMENT_HANDLING: {
        tagNameCheck: function tagNameCheck(tagName) {
          return COMPOSER_ALLOWED_CUSTOM_ELEMENTS.includes(tagName);
        },
        attributeNameCheck: /^(data-|contenteditable)/,
        allowCustomizedBuiltInElements: false
      }
    };
    _default$1.DEFAULT_CONFIG = DEFAULT_CONFIG;

    var inboxComposer = {};

    Object.defineProperty(inboxComposer, "__esModule", {
      value: true
    });
    inboxComposer.INBOX_COMPOSER_CONFIG = void 0;
    var _default = _default$1;
    var INBOX_COMPOSER_CONFIG = Object.assign({}, _default.DEFAULT_CONFIG, {
      ALLOW_UNKNOWN_PROTOCOLS: true
    });
    inboxComposer.INBOX_COMPOSER_CONFIG = INBOX_COMPOSER_CONFIG;

    (function (exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = getHtmlConfig;
    var _emailTemplate = emailTemplate;
    var _default = _default$1;
    var _inboxComposer = inboxComposer;
    var _htmlBlock = htmlBlock;
    var CONFIGS = {
      "default": _default.DEFAULT_CONFIG,
      email: _emailTemplate.EMAIL_TEMPLATE_CONFIG,
      inboxComposer: _inboxComposer.INBOX_COMPOSER_CONFIG,
      htmlBlock: _htmlBlock.HTML_BLOCK_CONFIG
    };
    function getHtmlConfig() {
      var configName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
      if (!CONFIGS[configName]) {
        throw new Error("@intercom/intercom-sanitizer: You passed an invalid configuration, `".concat(configName, "`,  to `sanitizeHtml`. The only valid configurations are: `").concat(Object.keys(CONFIGS).join(", "), "`"));
      }
      return CONFIGS[configName];
    }
    }(config));

    Object.defineProperty(sanitizer$1, "__esModule", {
      value: true
    });
    sanitizer$1.sanitizeHtml = sanitizeHtml;
    var _isomorphicDompurify = _interopRequireDefault(browser);
    var _customSanitizers = _interopRequireDefault(customSanitizers);
    var _index = _interopRequireDefault(config);
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
    // Add the hook only once outside of the function
    _isomorphicDompurify["default"].addHook("uponSanitizeElement", function (node, data) {
      if (_customSanitizers["default"][node.tagName]) {
        _customSanitizers["default"][node.tagName](node, data);
      }
    });
    function sanitizeHtml(html) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _isomorphicDompurify["default"].sanitize(html, (0, _index["default"])(options.config));
    }

    var sanitizer = {};

    var dist = {};

    Object.defineProperty(dist, "__esModule", { value: true });
    dist.sanitizeUrl = void 0;
    var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
    var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
    var htmlCtrlEntityRegex = /&(newline|tab);/gi;
    var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
    var urlSchemeRegex = /^.+(:|&colon;)/gim;
    var relativeFirstCharacters = [".", "/"];
    function isRelativeUrlWithoutProtocol(url) {
        return relativeFirstCharacters.indexOf(url[0]) > -1;
    }
    // adapted from https://stackoverflow.com/a/29824550/2601552
    function decodeHtmlCharacters(str) {
        return str.replace(htmlEntitiesRegex, function (match, dec) {
            return String.fromCharCode(dec);
        });
    }
    function sanitizeUrl$1(url) {
        var sanitizedUrl = decodeHtmlCharacters(url || "")
            .replace(htmlCtrlEntityRegex, "")
            .replace(ctrlCharactersRegex, "")
            .trim();
        if (!sanitizedUrl) {
            return "about:blank";
        }
        if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
            return sanitizedUrl;
        }
        var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
        if (!urlSchemeParseResults) {
            return sanitizedUrl;
        }
        var urlScheme = urlSchemeParseResults[0];
        if (invalidProtocolRegex.test(urlScheme)) {
            return "about:blank";
        }
        return sanitizedUrl;
    }
    dist.sanitizeUrl = sanitizeUrl$1;

    Object.defineProperty(sanitizer, "__esModule", {
      value: true
    });
    sanitizer.sanitizeUrl = sanitizeUrl;
    var _sanitizeUrl = dist;
    function sanitizeUrl(url) {
      if (!url) {
        return url;
      }
      return (0, _sanitizeUrl.sanitizeUrl)(url);
    }

    (function (exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "sanitizeHtml", {
      enumerable: true,
      get: function get() {
        return _sanitizer.sanitizeHtml;
      }
    });
    Object.defineProperty(exports, "sanitizeUrl", {
      enumerable: true,
      get: function get() {
        return _sanitizer2.sanitizeUrl;
      }
    });
    var _sanitizer = sanitizer$1;
    var _sanitizer2 = sanitizer;
    }(dist$1));

    (function (exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = exports.Sanitized = void 0;
    var _propTypes = _interopRequireDefault(propTypes.exports);
    var _react = _interopRequireDefault(compat);
    var _intercomSanitizer = dist$1;
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
    var Sanitized = function Sanitized(props) {
      var cleanString = (0, _intercomSanitizer.sanitizeHtml)(props.html);
      return /*#__PURE__*/_react["default"].createElement(props.element, {
        className: props.className,
        dangerouslySetInnerHTML: {
          __html: cleanString
        },
        id: props.id,
        style: props.style,
        "data-testid": props["data-testid"]
      });
    };
    exports.Sanitized = Sanitized;
    Sanitized.defaultProps = {
      html: ""
    };
    Sanitized.propTypes = {
      html: _propTypes["default"].string.isRequired,
      element: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].elementType]).isRequired,
      className: _propTypes["default"].string,
      id: _propTypes["default"].string,
      style: _propTypes["default"].any,
      "data-testid": _propTypes["default"].string
    };
    Sanitized.defaultProps = {
      element: "span"
    };
    var _default = Sanitized;
    exports["default"] = _default;
    }(reactSanitizer));

    (function (exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "Sanitized", {
      enumerable: true,
      get: function get() {
        return _reactSanitizer.Sanitized;
      }
    });
    var _reactSanitizer = reactSanitizer;
    }(dist$2));

    var css = picostyle(h$4);
    var Wrap = css('div')(function (props) {
      return {
        display: 'grid',
        gridTemplateColumns: '[left-gutter] 1fr [content] 12fr [right-gutter] 1fr',
        padding: '78px 0 70px',
        background: '#F4F0EB',
        boxShadow: '0px 1px 48px rgba(48, 48, 48, 0.25)',
        position: 'fixed',
        bottom: '0',
        left: '0',
        right: '0',
        color: 'black',
        zIndex: '100000',
        transition: 'opacity .2s',
        opacity: "" + props.opacity,
        '@media (max-width: 1000px)': {
          paddingTop: '70px'
        },
        '@media (max-width: 600px)': {
          padding: '40px 0 60px'
        }
      };
    });
    var Inner = css('div')({
      gridColumn: 'content',
      maxWidth: '960px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'repeat(12,1fr)',
      gridColumnGap: '20px'
    });
    var Heading = css('h2')({
      fontSize: '26px',
      fontWeight: 'bold',
      margin: '0',
      gridColumn: '1 / span 5',
      '@media (max-width: 1000px)': {
        gridColumn: '1 / span 12'
      }
    });
    var HeadingContent = css('span')({
      display: 'flex',
      alignItems: 'center',
      '@media (max-width: 600px)': {
        flexFlow: 'column',
        alignItems: 'flex-start'
      }
    });
    var CookieImage = css('img')({
      margin: '-8px 15px 0 0',
      maxHeight: '47px',
      '@media (max-width: 600px)': {
        margin: '0 0 5px 0'
      }
    });
    var Paragraph = css('p')({
      marginTop: '-14px',
      maxWidth: '530px',
      gridColumn: '6 / span 7',
      fontSize: '16px',
      '@media (max-width: 1000px)': {
        margin: '10px 0 20px',
        gridColumn: '1 / span 12',
        maxWidth: 'none'
      }
    });
    var Buttons = css('div')({
      marginTop: '20px',
      display: 'grid',
      gridColumn: '6 / span 7',
      gridTemplateColumns: 'repeat(12, minmax(220px, 1fr))',
      gridRowGap: '20px',
      gridColumnGap: '30px',
      '@media (max-width: 1000px)': {
        gridColumn: '1 / span 12',
        marginTop: '0'
      },
      '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gridColumn: '1 / span 12',
        marginTop: '0'
      }
    });
    function Banner(_a) {
      var onSave = _a.onSave,
          setRoute = _a.setRoute;
      var wrap = d$3(null);
      var acceptCookies = d$3(null);

      var _b = m$3(0),
          opacity = _b[0],
          setOpacity = _b[1];

      var localizedCopy = useLocalizedCopy().localizedCopy;
      l$3(function () {
        var _a, _b;

        setOpacity(1);
        new _default$2({
          node: (_a = wrap === null || wrap === void 0 ? void 0 : wrap.current) === null || _a === void 0 ? void 0 : _a.base
        });
        (_b = acceptCookies === null || acceptCookies === void 0 ? void 0 : acceptCookies.current) === null || _b === void 0 ? void 0 : _b.base.focus();
      }, []);

      function acceptAllCookies() {
        setOpacity(0);
        var cookiePreference = {
          advertising: true,
          analytics: true,
          marketing: true,
          performance: true
        };
        setCookieConsentPreference(cookiePreference);
        setTimeout(function () {
          return onSave(cookiePreference);
        }, 200);
      }

      function manageCookies() {
        setOpacity(0);
        setTimeout(function () {
          return setRoute('modal');
        }, 200);
      }

      return h$4(Wrap, {
        opacity: opacity,
        ref: wrap
      }, h$4(Inner, null, h$4(Heading, null, h$4(HeadingContent, null, h$4(CookieImage, {
        src: "https://marketing.intercomcdn.com/assets/cookie.png",
        width: "47",
        alt: localizedCopy('cookie')
      }), h$4("span", null, localizedCopy('fresh-cookie-update')))), h$4(Paragraph, null, h$4(dist$2.Sanitized, {
        html: localizedCopy('disclaimer-text'),
        element: 'div'
      })), h$4(Buttons, null, h$4("span", null, h$4(Button, {
        variant: "secondary",
        onClick: manageCookies,
        width: "100%",
        "data-testid": "manage-your-cookies-button"
      }, localizedCopy('manage-your-cookies'))), h$4("span", null, h$4(Button, {
        onClick: acceptAllCookies,
        width: "100%",
        ref: acceptCookies,
        "data-accept-all": true,
        "data-testid": "accept-all-cookies-button"
      }, localizedCopy('accept-all-cookies'))))));
    }

    function Router(_a) {
      var onSave = _a.onSave,
          _b = _a.initialRoute,
          initialRoute = _b === void 0 ? 'banner' : _b;

      var _c = m$3(initialRoute),
          route = _c[0],
          setRoute = _c[1];

      if (route === 'banner') return h$4(Banner, {
        onSave: onSave,
        setRoute: setRoute
      });
      if (route === 'modal') return h$4(Modal, {
        onSave: onSave,
        onClose: function () {
          return setRoute('banner');
        }
      });
      return null;
    }

    function createElement(id) {
      var element = document.createElement('div');
      element.id = id;
      document.body.appendChild(element);
      return element;
    }

    function renderCookieConsentBanner(mode, localeCode) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , new Promise(function (resolve) {
            var popUpWrap = document.querySelector('#intercom-cookie-consent-banner') || createElement('intercom-cookie-consent-banner');

            function onSave(cookiePreferences) {
              intercom.post('/cookie_consent_mode', cookiePreferences);
              H(null, popUpWrap);
              resolve(cookiePreferences);
            }

            return H(h$4(LocaleCodeContext.Provider, {
              value: localeCode !== null && localeCode !== void 0 ? localeCode : DEFAULT_LOCALE_CODE
            }, h$4(CookieConsent, {
              mode: mode
            }, h$4(Router, {
              onSave: onSave
            }))), popUpWrap);
          })];
        });
      });
    }
    function renderCookieConsent(element, onSave, mode) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (!element) {
            throw new Error('Element argument is required');
          }

          if (mode === 'no-consent') {
            // Don't render anything when the user has no ability to change their preferences
            return [2
            /*return*/
            ];
          }

          H(h$4(CookieConsent, {
            mode: mode
          }, h$4(ConsentState, {
            onSave: onSave
          })), element);
          return [2
          /*return*/
          ];
        });
      });
    }

    var detectUa_umd = {exports: {}};

    (function (module, exports) {
    !function(e,t){t(exports);}(commonjsGlobal,function(e){var t="undefined"==typeof window,i=(s.prototype.match=function(e,t){t=this.userAgent.match(t);return t&&1<t.length&&t[e]||""},Object.defineProperty(s.prototype,"isMobile",{get:function(){return !this.isTablet&&(/[^-]mobi/i.test(this.userAgent)||"iphone"===this.iOSDevice||"ipod"===this.iOSDevice||this.isAndroidDevice||/nexus\s*[0-6]\s*/i.test(this.userAgent))},enumerable:!1,configurable:!0}),Object.defineProperty(s.prototype,"isTablet",{get:function(){return /tablet/i.test(this.userAgent)&&!/tablet pc/i.test(this.userAgent)||"ipad"===this.iOSDevice||this.isAndroidDevice&&!/[^-]mobi/i.test(this.userAgent)||!/nexus\s*[0-6]\s*/i.test(this.userAgent)&&/nexus\s*[0-9]+/i.test(this.userAgent)},enumerable:!1,configurable:!0}),Object.defineProperty(s.prototype,"isDesktop",{get:function(){return !this.isMobile&&!this.isTablet},enumerable:!1,configurable:!0}),Object.defineProperty(s.prototype,"isMacOS",{get:function(){return /macintosh/i.test(this.userAgent)&&{version:this.match(1,/mac os x (\d+(\.?_?\d+)+)/i).replace(/[_\s]/g,".").split(".").map(function(e){return e})[1]}},enumerable:!1,configurable:!0}),Object.defineProperty(s.prototype,"isWindows",{get:function(){return /windows /i.test(this.userAgent)&&{version:this.match(1,/Windows ((NT|XP)( \d\d?.\d)?)/i)}},enumerable:!1,configurable:!0}),Object.defineProperty(s.prototype,"isiOS",{get:function(){return !!this.iOSDevice&&{version:this.match(1,/os (\d+([_\s]\d+)*) like mac os x/i).replace(/[_\s]/g,".")||this.match(1,/version\/(\d+(\.\d+)?)/i)}},enumerable:!1,configurable:!0}),Object.defineProperty(s.prototype,"isAndroid",{get:function(){return this.isAndroidDevice&&{version:this.match(1,/android[ \/-](\d+(\.\d+)*)/i)}},enumerable:!1,configurable:!0}),Object.defineProperty(s.prototype,"browser",{get:function(){var e=this.match(1,/version\/(\d+(\.\d+)?)/i);return /opera/i.test(this.userAgent)?{name:"Opera",version:e||this.match(1,/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)}:/opr\/|opios/i.test(this.userAgent)?{name:"Opera",version:this.match(1,/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i)||e}:/SamsungBrowser/i.test(this.userAgent)?{name:"Samsung Internet for Android",version:e||this.match(1,/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)}:/yabrowser/i.test(this.userAgent)?{name:"Yandex Browser",version:e||this.match(1,/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)}:/ucbrowser/i.test(this.userAgent)?{name:"UC Browser",version:this.match(1,/(?:ucbrowser)[\s\/](\d+(\.\d+)?)/i)}:/msie|trident/i.test(this.userAgent)?{name:"Internet Explorer",version:this.match(1,/(?:msie |rv:)(\d+(\.\d+)?)/i)}:/(edge|edgios|edga|edg)/i.test(this.userAgent)?{name:"Microsoft Edge",version:this.match(2,/(edge|edgios|edga|edg)\/(\d+(\.\d+)?)/i)}:/firefox|iceweasel|fxios/i.test(this.userAgent)?{name:"Firefox",version:this.match(1,/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)}:/chromium/i.test(this.userAgent)?{name:"Chromium",version:this.match(1,/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i)||e}:/chrome|crios|crmo/i.test(this.userAgent)?{name:"Chrome",version:this.match(1,/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)}:/safari|applewebkit/i.test(this.userAgent)?{name:"Safari",version:e}:{name:this.match(1,/^(.*)\/(.*) /),version:this.match(2,/^(.*)\/(.*) /)}},enumerable:!1,configurable:!0}),s);function s(e){this.userAgent=e||(!t&&window.navigator?window.navigator.userAgent:""),this.isAndroidDevice=!/like android/i.test(this.userAgent)&&/android/i.test(this.userAgent),this.iOSDevice=this.match(1,/(iphone|ipod|ipad)/i).toLowerCase(),!t&&"MacIntel"===navigator.platform&&2<navigator.maxTouchPoints&&!window.MSStream&&(this.iOSDevice="ipad");}e.DetectUA=i,Object.defineProperty(e,"__esModule",{value:!0});});
    }(detectUa_umd, detectUa_umd.exports));

    function device () {
      var device = new detectUa_umd.exports.DetectUA();

      if (device.isMobile) {
        return 'mobile';
      } else if (device.isTablet) {
        return 'tablet';
      }

      return 'desktop';
    }

    // @ts-nocheck
    function addGoogleRemarketing (customAttributes) {
      try {
        google_trackConversion({
          google_conversion_id: 967943485,
          google_custom_params: customAttributes,
          google_remarketing_only: true
        });
      } catch (e) {
        console.error(e);
      }
    }

    // @ts-nocheck
    // Example remarketing pixel link with conversion label and custom attribute
    // Ex: googleads.g.doubleclick.net/pagead/viewthroughconversion/<account-id>/?label=<conversion-label-id>&data.custom_param=value
    function addGoogleRemarketingImage (customAttributes) {
      try {
        var img = new Image(1, 1);
        img.id = 'googlePixelIntercom';
        var params = '';
        var entity_params = ['label', 'currency_code', 'value'];

        for (var key in customAttributes) {
          if (customAttributes[key]) {
            if (entity_params.indexOf(key) > -1) {
              params += "&" + key + "=" + customAttributes[key];
            } else {
              params += "&data." + key + "=" + customAttributes[key];
            }
          }
        }

        img.src = "//www.googleadservices.com/pagead/conversion/967943485/?guid=ON&script=0" + params;
        document.body && document.body.appendChild(img);
      } catch (e) {
        console.error(e);
      }
    }

    function fireThirdPartyEventsOnEmailSubmission () {
      if (getEnvironment() !== 'production') {
        return;
      }
      /*
       * FACEBOOK PIXEL
       */


      if (window.fbq) {
        window.fbq('trackCustom', 'ms_email_signed_up', {});
        window.fbq('track', 'Lead', {});
      }
      /*
       * QUORA
       */


      if (window.qp) {
        window.qp('track', 'Generic');
      }
      /*
       * GOOGLE ADWORDS
       */


      addGoogleRemarketing({
        send_to: 'AW-967943485/UutXCOvj9WQQvcrGzQM'
      });
      addGoogleRemarketingImage({
        ms_email_signed_up: 'true',
        label: 'e0V8CJ2JkGwQvcrGzQM',
        value: '1.00',
        currency_code: 'USD'
      });
      /*
       * STATIC CONVERSION PIXEL
       */

      var staticConversionPixel = new Image(1, 1);
      staticConversionPixel.src = '//insight.adsrvr.org/track/conv/?adv=bzwixbq&ct=0:sxgxp5i&fmt=3';
      /*
       * LINKEDIN PIXEL
       */

      var linkedinPixel = new Image(1, 1);
      linkedinPixel.src = 'https://dc.ads.linkedin.com/collect/?pid=38643&conversionId=139071&fmt=gif';
      /*
       * BING
       */

      window.uetq = window.uetq || [];
      window.uetq.push({
        ec: 'email_submission',
        ea: 'email_submission',
        el: 'email_submission',
        ev: 0,
        gv: 0
      });
    }

    function getUrlParam (window, name) {
      return (window.location.search.split(name + "=")[1] || '').split('&')[0];
    }

    var Metrics = {
      increment: increment,
      incrementWithOutput: incrementWithOutput,
      recordTiming: recordTiming
    };

    function increment(name, tags) {
      var _a;

      return __awaiter(this, void 0, void 0, function () {
        var metricTags, result;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              metricTags = __assign(__assign({}, getDefaultTags()), tags);
              return [4
              /*yield*/
              , intercom.post('/metrics', {
                metric_name: name,
                tags: metricTags
              })];

            case 1:
              result = _b.sent();

              if (result.error && result.exception) {
                (_a = window.Raven) === null || _a === void 0 ? void 0 : _a.captureException(result.exception);
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    }

    function incrementWithOutput(name, tags) {
      var _a;

      return __awaiter(this, void 0, void 0, function () {
        var metricTags, result;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              metricTags = __assign(__assign({}, getDefaultTags()), tags);
              return [4
              /*yield*/
              , intercom.post('/metrics', {
                metric_name: name,
                tags: metricTags
              })];

            case 1:
              result = _b.sent();

              if (result.error && result.exception) {
                (_a = window.Raven) === null || _a === void 0 ? void 0 : _a.captureException(result.exception);
              }

              return [2
              /*return*/
              , result];
          }
        });
      });
    }

    function recordTiming(name, duration, tags) {
      var _a;

      return __awaiter(this, void 0, void 0, function () {
        var metricTags, result;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              metricTags = __assign(__assign({}, getDefaultTags()), tags);
              return [4
              /*yield*/
              , intercom.post('/timing_metrics', {
                metric_name: name,
                duration: duration,
                tags: metricTags
              })];

            case 1:
              result = _b.sent();

              if (result.error && result.exception) {
                (_a = window.Raven) === null || _a === void 0 ? void 0 : _a.captureException(result.exception);
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    }

    function getDefaultTags() {
      var environment = getEnvironment();
      var device$1 = device();
      return {
        environment: environment,
        device: device$1
      };
    }

    var sanitize = function (values) {
      var employee_count = values.employee_count,
          restValues = __rest(values, ["employee_count"]);

      var sanitizedValues = restValues;

      if (parseInt(employee_count, 10)) {
        sanitizedValues.employee_count = parseInt(employee_count, 10);
      }

      return sanitizedValues;
    };
    function recordData(sixthSenseData) {
      return __awaiter(this, void 0, void 0, function () {
        var sanitizedData;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              sanitizedData = sanitize(sixthSenseData);
              return [4
              /*yield*/
              , intercom.post('/6sense_data', sanitizedData)];

            case 1:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    }

    /*
    Documentation:
    addMarketoFormToDom Adds the skeleton HTML form element
    loadMarketoFormsJs  Loads the Marketo forms2.js by adding a script element
    loadMarketoForm     Uses the marketo forms2.js to load the marketo form into the form element
    */
    var MARKETO_RAVEN_OPTIONS = {
      tags: {
        responsible_team: 'team-automation-enablement',
        error_type: 'marketo'
      }
    };

    var MarketoFormError =
    /** @class */
    function (_super) {
      __extends(MarketoFormError, _super);

      function MarketoFormError(err) {
        var _this = _super.call(this, err) || this;

        _this.intercomErrorType = '';
        return _this;
      }

      return MarketoFormError;
    }(Error);

    function addMarketoFormToDOM(formId) {
      // The HTML form's id should be distinct from formId. If you have an HTML element with id `foo`, then window.foo points to that element.
      var formHtmlId = "marketoForm_" + formId + "_html_id";

      if (window[formHtmlId]) {
        return;
      }

      var form = document.createElement('form');
      form.id = formHtmlId;
      form.style.display = 'none';
      document.getElementsByTagName('body')[0].appendChild(form);
    }
    var FORM_JS_REQUEST_KEY = 'mktoForm_js_request';
    function loadMarketoFormsJs() {
      if (window[FORM_JS_REQUEST_KEY]) {
        return window[FORM_JS_REQUEST_KEY];
      }

      window[FORM_JS_REQUEST_KEY] = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        script.src = 'https://app-sjqe.marketo.com/js/forms2/js/forms2.min.js';
        document.getElementsByTagName('head')[0].appendChild(script);
      }).catch(function () {
        Metrics.increment('GtmJS.Marketo.formJsBlocked');
      });
      return window[FORM_JS_REQUEST_KEY];
    }
    function loadMarketoForm(hostName, accountId, formId) {
      var formRequestKey = "mktoForm_" + formId + "_request";

      if (window[formRequestKey]) {
        return window[formRequestKey];
      }

      window[formRequestKey] = new Promise(function (resolve, reject) {
        window.MktoForms2.loadForm(hostName, accountId, formId, function (marketoForm) {
          if (marketoForm) {
            // Store the marketo form object so we can call val() on it later.
            window["mktoForm_" + formId] = marketoForm;

            if (window.Raven) {
              var addBreadcrumb = window.Raven.captureBreadcrumb || window.Raven.addBreadcrumb;
              addBreadcrumb({
                category: 'marketo',
                message: "Attached form " + JSON.stringify(window["mktoForm_" + formId]) + " to window " + window
              });
            } // Tell the Marketo form not to redirect anywhere. We just want to submit the form and then do our own thing.
            // Do not go wherever Marketo's form takes us.


            marketoForm.onSuccess(function () {
              return false;
            });
            resolve(marketoForm);
          } else {
            var error = new MarketoFormError("marketo form not loaded hostName: " + hostName + " accountId: " + accountId + " formId: " + formId);
            error.intercomErrorType = 'GtmJS.Marketo.formLoad.error';
            reject(error);
          }
        });
      });
      return window[formRequestKey];
    }
    function reportMarketoErrorToSentry(error, extras) {
      if (extras === void 0) {
        extras = {};
      }

      try {
        if (window.Raven) {
          window.Raven.captureException(error, Object.assign({}, MARKETO_RAVEN_OPTIONS, {
            extra: extras
          }));
        }
      } catch (e) {// Do nothing
      }
    }
    function whenMarketoFormReady(formId) {
      // Adds a callback that will be called exactly once for each form on the page that becomes “ready”.
      // The callback is passed a single argument, a form object. http://developers.marketo.com/javascript-api/forms/api-reference/
      return new Promise(function (resolve, reject) {
        if (!window.MktoForms2) {
          reject(new MarketoFormError('Marketo not loaded when calling whenMarketoFormReady'));
        }

        window.MktoForms2.whenReady(function (marketoForm) {
          if (marketoForm.getId() === formId) {
            resolve();
          }
        });
      });
    }
    function submitMarketoForm(form, formFields) {
      var formId = form.getId();
      return new Promise(function (resolve, reject) {
        if (!form.validate || !form.validate()) {
          var error = new Error('marketoFormValidationFailed');
          reportMarketoErrorToSentry(error, formFields);
          Metrics.increment('GtmJS.Marketo.formValidationFailed', {
            formId: formId
          });
          reject(error);
        } else {
          // Resolve no matter what after a certain amount of time
          var fallbackResolveTimer_1 = setTimeout(function () {
            Metrics.increment('GtmJS.Marketo.formSubmissionTimeout', {
              formId: formId
            });
            resolve();
          }, 10000);
          form.onSuccess(function () {
            clearTimeout(fallbackResolveTimer_1); // This call may not succeed if redirect cancels it

            Metrics.increment('GtmJS.Marketo.success', __assign({
              formId: formId
            }, getCookieConsentPropertiesForMetric()));
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'marketo-form-submitted',
              custom_event_metadata: __assign({
                'marketo-form-id': formId
              }, formFields)
            });
            resolve(); // Tell the Marketo form not to redirect anywhere. We just want to submit the form and then do our own thing.

            return false;
          });
          form.submit();
        }
      });
    }

    // @ts-nocheck
    function addFacebookImagePixel (eventName, customAttributes) {
      try {
        // https://developers.facebook.com/docs/marketing-api/audiences-api/pixel#inpageevents
        var pixelId = '938193196235407';
        var attrs = Object.assign(customAttributes);
        var img = new Image(1, 1);
        var params = '';
        attrs['ev'] = eventName;
        attrs['id'] = pixelId;
        attrs['noscript'] = 1;

        for (var key in attrs) {
          if (attrs[key]) {
            params += "&" + key + "=" + attrs[key];
          }
        }

        img.id = 'fbPixelIntercom';
        img.src = "https://www.facebook.com/tr?" + params;
        document.body && document.body.appendChild(img);
      } catch (e) {
        console.error(e);
      }
    }

    // @ts-nocheck
    function addFacebookPixel (eventName, customAttributes) {
      try {
        fbq('trackCustom', eventName, customAttributes);
      } catch (e) {
        console.error(e);
      }
    }

    // @ts-nocheck
    function initFacebookPixel () {
      try {
        if (typeof fbq === 'undefined') {
          !function (f, b, e, v, n, t, s) {
            if (f.fbq) return;

            n = f.fbq = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };

            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '938193196235407');
        }
      } catch (e) {
        console.error(e);
      }
    }

    // @ts-nocheck
    function initGooglePixel () {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://www.googleadservices.com/pagead/conversion_async.js';
        script.async = true;
        script.addEventListener('load', function () {
          resolve(script);
        }, false);
        script.addEventListener('error', function (e) {
          console.error(e);
          reject(script);
        }, false);
        document.body && document.body.appendChild(script);
      });
    }

    // @ts-nocheck
    function loadClearbitScript() {
      ga('require', 'Clearbit', {
        mapping: {
          companyName: 'dimension11',
          companyEmployeesRange: 'dimension12',
          companyTags: 'dimension13',
          companyTech: 'dimension14',
          companySubIndustry: 'dimension15',
          companyIndustry: 'dimension16',
          companyIndustryGroup: 'dimension17',
          companySector: 'dimension18',
          companyType: 'dimension19',
          companyDomain: 'dimension20'
        }
      });

      (function () {
        var s = document.getElementsByTagName('script')[0];
        var b = document.createElement('script');
        b.type = 'text/javascript';
        b.async = true;
        b.src = 'https://ga.clearbit.com/v1/ga.js?authorization=pk_281710c391d62b4da12e1a9adc3f3a72';
        s.parentNode.insertBefore(b, s);
      })();
    }

    // @ts-nocheck
    function loadGoogleAnalyticsScript(propertyId) {
      try {
        ;

        (function (i, s, o, g, r, a, m) {
          i['GoogleAnalyticsObject'] = r;
          i[r] = i[r] || function () {
            ;
            (i[r].q = i[r].q || []).push(arguments);
          }, i[r].l = 1 * new Date();
          a = s.createElement(o), m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

        ga('create', propertyId, 'auto');
      } catch (e) {
        if (window.Raven) {
          window.Raven.captureException(e, {
            tags: {
              responsible_team: 'team-app-ecosystem'
            }
          });
        } else if (window.location.host.endsWith('.test')) {
          console.error(e);
        }
      }
    }
    function trackPageViewInGoogleAnalytics() {
      if (typeof ga === 'function') {
        ga('set', 'page', window.location.pathname + window.location.search);
        ga('send', 'pageview');
      }
    }

    // @ts-nocheck
    function loadMarketoMunchkinScript() {

      (function () {
        var didInit = false;

        function initMunchkin() {
          if (didInit === false) {
            didInit = true;
            Munchkin.init('258-CLW-344');
          }
        }

        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//munchkin.marketo.net/munchkin.js';

        s.onreadystatechange = function () {
          if (this.readyState == 'complete' || this.readyState == 'loaded') {
            initMunchkin();
          }
        };

        s.onload = initMunchkin;
        document.getElementsByTagName('head')[0].appendChild(s);
      })();
    }
    function trackPageViewInMarketoMunchkin() {
      if (typeof Munchkin === 'object') {
        Munchkin.munchkinFunction('clickLink', {
          href: window.location.pathname + window.location.search
        });
      }
    }

    var defaultMarketoFormId = 1042;
    var gtmCookie = 'gtm_id';
    var datadogCookie = 'datadog';

    var GTMClass =
    /** @class */
    function () {
      function GTMClass(localeCode) {
        this.version = '1.38.7';
        /** @deprecated */

        this.blocked = false;
        this.blockedByClient = {
          GtmTracking: false,
          Marketo: false
        };
        this.pageviewId = null;
        this.emailSubmissionId = null;
        this.emailSubmissionResponse = null;
        this.meta = {};
        this.pageViewPromise = null;
        this.device = device();

        this.recordSixthSenseData = function (sixthsenseData) {
          try {
            recordData(sixthsenseData);
          } catch (e) {
            Metrics.increment('GtmJS.6Sense.RecordSixthSenseData.failure');
          }
        };

        if (!window.dataLayer) {
          window.dataLayer = [];
        }

        var gtmCookieId = Cookies.get(gtmCookie);

        if (!gtmCookieId) {
          var cookieIdentifier = v4();
          Cookies.set(gtmCookie, cookieIdentifier, {
            expires: 365,
            domain: getCookieDomain(),
            samesite: 'none',
            secure: apiEndpoint().startsWith('https:')
          });
        }

        this.localeCode = localeCode;

        if (!window.IntercomGTM) {
          window.IntercomGTM = this;
        }
      }
      /**
       * Records a pageview
       * @example <caption>Record a pageview</caption>
       * recordPageView().then((response) => console.log(response.pageviewId))
       */


      GTMClass.prototype.recordPageView = function (params) {
        var _this = this; // Using the page URL instead of a flag to support single-page applications.


        if (window.GTM_PAGEVIEW_URL === window.location.href) {
          console.warn('Attempted to record duplicate pageview');
          Metrics.increment('GtmJS.recordPageView.duplicatePageView');
          return window.pageViewPromise;
        }

        window.GTM_PAGEVIEW_URL = window.location.href;
        var queryParams = new URLSearchParams(window.location.search);
        var isTestPageview = queryParams.get('is_test') == 'true';

        var record = function () {
          return __awaiter(_this, void 0, void 0, function () {
            var response, newPageviewId, event_1;

            var _a;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  return [4
                  /*yield*/
                  , intercom.post('/pageviews', __assign(__assign({}, params), {
                    page_url: window.location.href.replace(window.location.hash, ''),
                    referrer: document.referrer || getUrlParam(window, 'utm_referrer'),
                    metadata: Object.assign({}, (params || {})['metadata'], {
                      gtm_client_version: '1.38.7',
                      is_test: isTestPageview
                    })
                  }), {
                    headers: {
                      'X-Date': new Date().toISOString()
                    }
                  })];

                case 1:
                  response = _b.sent();

                  if (response.error) {
                    if (response.exception) {
                      (_a = window.Raven) === null || _a === void 0 ? void 0 : _a.captureException(response.exception);
                    } else {
                      this.blockedByClient.GtmTracking = true;
                      Metrics.increment('GtmJS.serviceBlockedByClient', {
                        service: 'GtmTracking'
                      });
                    }

                    this.pageviewId = null;
                    return [2
                    /*return*/
                    , {
                      pageviewId: null
                    }];
                  }

                  newPageviewId = response.data.pageview_id;

                  if (newPageviewId && this.pageviewId !== newPageviewId) {
                    event_1 = new Event('gtm-js:record-pageview');
                    window.dispatchEvent(event_1);
                  }

                  this.pageviewId = newPageviewId;
                  return [2
                  /*return*/
                  , {
                    pageviewId: newPageviewId
                  }];
              }
            });
          });
        };

        window.pageViewPromise = record();
        return window.pageViewPromise;
      };
      /**
       * @deprecated Pass experiment impressions to recordPageView instead.
       */


      GTMClass.prototype.recordAbTestImpression = function (pageviewId, experimentName, variation) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , intercom.post("/ab_test_impressions", {
                  experiment_name: experimentName,
                  variation: variation,
                  pageview_id: pageviewId
                })];

              case 1:
                return [2
                /*return*/
                , _a.sent().resultOrThrow()];
            }
          });
        });
      };
      /**
       * Record experiment impression
       * @example <caption>Record experiment impression</caption>
       * recordExperimentImpression({ pageview_id: 1, experiment: 'my-experiment', variation: 'a', experiment_source:'optimizely'})
       *     .then((response) => console.log(response.id))
       */


      GTMClass.prototype.recordExperimentImpression = function (experimentImpression) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , intercom.post('/experiment_impressions', {
                  pageview_id: experimentImpression.pageviewId,
                  experiment: experimentImpression.experiment,
                  variation: experimentImpression.variation,
                  experiment_source: experimentImpression.experimentSource
                })];

              case 1:
                return [2
                /*return*/
                , _a.sent().resultOrThrow()];
            }
          });
        });
      };

      GTMClass.prototype.recordEmailSubmissionWithOptions = function (esOptions) {
        return this.recordEmailSubmission(esOptions.email, esOptions.createQualifiedProspect, esOptions.pageViewId, esOptions.opts, esOptions.callback, esOptions.marketoFormId, esOptions.marketoFields && esOptions.marketoFields(), esOptions.disableMarketoIntegration, esOptions.extraMetricsTags, esOptions.visitorAttributes);
      };
      /**
       * Records a user email submission
       * @example <caption>Record an email submission</caption>
       * recordEmailSubmission('bob@qatest.app', false, 3).then((id) => console.log(id))
       */


      GTMClass.prototype.recordEmailSubmission = function (email, createQualifiedProspect, pageviewId, opts, cb, marketoFormId, extraMarketoFields, disableMarketoIntegration, extraMetricsTags, visitorAttributes) {
        var _this = this;

        var pageview_id = pageviewId !== null && pageviewId !== void 0 ? pageviewId : this.pageviewId;
        var metricsTags = Object.assign({
          formId: marketoFormId
        }, extraMetricsTags);

        if (window._DATADOG_SYNTHETICS_BROWSER && !Cookies.get(datadogCookie)) {
          var cookieIdentifier = v4();
          Cookies.set('datadog', cookieIdentifier, {
            expires: 365,
            domain: getCookieDomain(),
            samesite: 'none',
            secure: apiEndpoint().startsWith('https:')
          });
        }

        if (typeof pageview_id !== 'number') {
          Metrics.increment('GtmJS.submitFailed.noPageView', metricsTags);
          return Promise.reject(new Error('No pageview ID provided'));
        }

        var marketoFields = Object.assign({
          Email: email,
          gtm_emailsubmission_id_last__c: ''
        }, extraMarketoFields || {});
        Metrics.increment('GtmJS.recordEmailSubmission', metricsTags);
        return intercom.post('/email_submissions', __assign({
          email: email,
          pageview_id: pageview_id,
          qualified_prospect: createQualifiedProspect,
          visitor_attributes: visitorAttributes
        }, opts)).then(function (result) {
          var emailSubmission = result.resultOrThrow();
          _this.emailSubmissionResponse = emailSubmission;
          _this.emailSubmissionId = emailSubmission.id;

          if (_this.emailSubmissionId) {
            marketoFields['gtm_emailsubmission_id_last__c'] = _this.emailSubmissionId.toString();
          }

          if (disableMarketoIntegration) {
            Metrics.increment('GtmJS.Marketo.marketoIntegrationDisabled', metricsTags);

            if (cb) {
              cb(_this.emailSubmissionId);
            }

            return _this.emailSubmissionResponse;
          }

          return _this.recordMarketoEvent(marketoFormId || defaultMarketoFormId, marketoFields).then(function () {
            Metrics.increment('GtmJS.Marketo.emailSubmissionSucceeded', metricsTags);

            if (cb) {
              cb(_this.emailSubmissionId);
            }

            return _this.emailSubmissionResponse;
          }).catch(function (error) {
            if (console) {
              console.log(error);
            }

            Metrics.increment('GtmJS.Marketo.formSubmissionFailed', metricsTags);

            if (error.message === 'GtmJS.Marketo.formMissing') {
              Metrics.increment('GtmJS.Marketo.uncapturedEmailSubmission.becauseFormMissing', metricsTags);
            } else {
              reportMarketoErrorToSentry(error);
            }

            Metrics.increment('GtmJS.Marketo.uncapturedEmailSubmission', metricsTags);

            if (cb) {
              cb(_this.emailSubmissionId);
            }

            return _this.emailSubmissionResponse;
          });
        });
      };
      /**
       * Submit event data to marketo
       * @param formId
       * @param marketoFields
       * @param paramWindow
       */


      GTMClass.prototype.recordMarketoEvent = function (formId, marketoFields, injectedWindow) {
        var form;
        var paramWindow = injectedWindow || window;

        try {
          form = window["mktoForm_" + formId];

          if (window.Raven) {
            var addBreadcrumb = window.Raven.captureBreadcrumb || window.Raven.addBreadcrumb;
            addBreadcrumb({
              category: 'marketo',
              message: "Retrieved form " + JSON.stringify(window["mktoForm_" + formId]) + " (mktoForm_" + formId + ") from window " + window
            });
          }

          Metrics.increment('GtmJS.Marketo.formRequested', {
            formId: formId
          });

          if (!form) {
            Metrics.increment('GtmJS.Marketo.formMissing', {
              formId: formId
            });
            var exception = new Error('GtmJS.Marketo.formMissing');

            if (window.Raven) {
              window.Raven.captureException(exception);
            }

            throw exception;
          }

          var formFields = Object.assign({
            URL_last__c: "" + paramWindow.location.origin + paramWindow.location.pathname,
            Google_Client_ID__c: Cookies.get('_ga'),
            Google_Click_ID__c: getUrlParam(paramWindow, 'gclid'),
            utm_content_last__c: getUrlParam(paramWindow, 'utm_content'),
            utm_medium_last__c: getUrlParam(paramWindow, 'utm_medium'),
            utm_source_last__c: getUrlParam(paramWindow, 'utm_source'),
            utm_term_last__c: getUrlParam(paramWindow, 'utm_term'),
            utm_ad_last__c: getUrlParam(paramWindow, 'utm_ad'),
            utm_ad_collection_last__c: getUrlParam(paramWindow, 'utm_ad_collection'),
            utm_campaign_last__c: getUrlParam(paramWindow, 'utm_campaign'),
            utm_kw_last__c: getUrlParam(paramWindow, 'utm_kw_last')
          }, marketoFields);
          form.vals(formFields);
          appStatus(formFields.Email);
          return submitMarketoForm(form, formFields);
        } catch (error) {
          if (console) {
            console.log(error);
          }

          Metrics.increment('GtmJS.Marketo.formBuildFailed', {
            formId: formId
          });
          reportMarketoErrorToSentry(error, {
            form_id: formId
          });
          return Promise.reject(error);
        }
      };
      /**
       * Records a GTM Event
       * @example <caption>Record an event</caption>
       * recordEvent('clicked the button', 2, { location: 'purchase' }).then((response) => console.log(response.event_id))
       */


      GTMClass.prototype.recordEvent = function (identifier, pageviewId, metadata) {
        return __awaiter(this, void 0, void 0, function () {
          var pageview_id;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                pageview_id = pageviewId || this.pageviewId;

                if (typeof pageview_id !== 'number') {
                  throw new Error('No pageview ID provided');
                }

                return [4
                /*yield*/
                , intercom.post("/events", {
                  identifier: identifier,
                  pageview_id: pageview_id,
                  metadata: metadata
                })];

              case 1:
                return [2
                /*return*/
                , _a.sent().resultOrThrow()];
            }
          });
        });
      };
      /**
       * Loads the Facebook pixel
       */


      GTMClass.prototype.loadFacebookPixel = function () {
        initFacebookPixel();
        this.meta.fbq_init = true;
      };
      /**
       * Records Facebook and Google ad tracking pixels
       * @example <caption>Record ad tracking pixels</caption>
       * recordPixel('clicked the button', {key: 'value'})
       */


      GTMClass.prototype.recordPixel = function (eventName, customAttributes) {
        this.recordFacebookPixel(eventName, customAttributes);
        this.recordGooglePixel(customAttributes);
      };
      /**
       * Records only a Facebook pixel
       * @example <caption>Record a Facebook pixel</caption>
       * recordFacebookPixel('clicked the button', {key: 'value'})
       */


      GTMClass.prototype.recordFacebookPixel = function (eventName, customAttributes) {
        if (this.meta.fbq_init) {
          addFacebookPixel(eventName, customAttributes);
        } else {
          initFacebookPixel();
          addFacebookPixel(eventName, customAttributes);
          this.meta.fbq_init = true;
        }
      };
      /**
       * Records only a Facebook image pixel
       * @example <caption>Record a Facebook image pixel</caption>
       * recordFacebookImagePixel('clicked_button', {key: 'value'})
       */


      GTMClass.prototype.recordFacebookImagePixel = function (eventName, customAttributes) {
        addFacebookImagePixel(eventName, customAttributes);
        return true;
      };
      /**
       * Loads the Google adwords pixel
       */


      GTMClass.prototype.loadGooglePixel = function () {
        initGooglePixel();
        this.meta.google_init = true;
      };
      /**
       * Records only a Google pixel
       * @example <caption>Record a Google pixel</caption>
       * recordGooglePixel({key: 'value'})
       */


      GTMClass.prototype.recordGooglePixel = function (customAttributes) {
        var _this = this;

        if (this.meta.google_init) {
          return addGoogleRemarketing(customAttributes);
        }

        return initGooglePixel().then(function () {
          addGoogleRemarketing(customAttributes);
          _this.meta.google_init = true;
          return _this.meta.google_init;
        });
      };
      /**
       * Records only a Google Image pixel
       * @example <caption>Record a Google image pixel</caption>
       * recordGoogleImgPixel({key: 'value'})
       */


      GTMClass.prototype.recordGoogleImgPixel = function (customAttributes) {
        addGoogleRemarketingImage(customAttributes);
        this.meta.google_img_init = true;
        return this.meta.google_img_init;
      };
      /**
       * Remove Google Image pixel
       * @example <caption>Remove Google Image pixel</caption>
       * recordFacebookPixel({key: 'value'})
       */


      GTMClass.prototype.removeGoogleImgPixel = function () {
        var pixel = document.getElementById('googlePixelIntercom');

        if (pixel && pixel.parentNode) {
          pixel.parentNode.removeChild(pixel);
          return true;
        }

        return false;
      };
      /**
       * Initialize Marketo Forms2.0 forms
       *
       */


      GTMClass.prototype.initMarketoForms = function (hostName, accountId, formId) {
        var _this = this;

        return new Promise(function (resolve, reject) {
          addMarketoFormToDOM(formId);
          loadMarketoFormsJs().catch(function () {
            // Errors specific to loading the forms2 JS script
            Metrics.increment('GtmJS.serviceBlockedByClient', {
              service: 'Marketo'
            });
            _this.blockedByClient.Marketo = true;
          }).then(function () {
            return loadMarketoForm(hostName, accountId, formId);
          }).then(function () {
            return whenMarketoFormReady(formId);
          }).then(function () {
            return resolve();
          }).catch(function (error) {
            Metrics.increment(error.intercomErrorType || 'GtmJS.Marketo.formLoad.scriptError', {
              formId: formId
            });
            reject(error);
          });
        });
      };

      GTMClass.prototype.personalEmailDomain = function (email) {
        return __awaiter(this, void 0, void 0, function () {
          var domain, result, return_value;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                domain = email.substring(email.lastIndexOf('@') + 1).toLowerCase();
                return [4
                /*yield*/
                , intercom.get('/personal_email_domain', {
                  query: {
                    domain: domain
                  }
                })];

              case 1:
                result = _a.sent();
                return_value = result.error ? false : result.data.personal_email_domain;

                if (return_value && this.pageviewId) {
                  this.recordEvent('personal-email-detected', undefined, {
                    email: email
                  });
                }

                return [2
                /*return*/
                , return_value];
            }
          });
        });
      };
      /**
       * Load Google Analytics with the supplied property ID
       */


      GTMClass.prototype.loadGoogleAnalytics = function (propertyId) {
        loadGoogleAnalyticsScript(propertyId);
      };
      /**
       * Load Marketo Munchkin script
       */


      GTMClass.prototype.loadMarketoMunchkin = function () {
        loadMarketoMunchkinScript();
      };
      /**
       * Load Clearbit script
       */


      GTMClass.prototype.loadClearbit = function () {
        loadClearbitScript();
      };
      /**
       * Record page view in third party tools
       */


      GTMClass.prototype.recordPageViewInThirdPartyTools = function () {
        trackPageViewInGoogleAnalytics();
        trackPageViewInMarketoMunchkin();
      };
      /**
       * Fire third party events on email submission
       */


      GTMClass.prototype.recordThirdPartyEventsOnEmailSubmission = function () {
        fireThirdPartyEventsOnEmailSubmission();
      };
      /**
       * Determine the user's cookie consent preferences under particular laws. The behaviors required
       * by the laws are abstracted into "consent modes". See {CookieConsentMode} for details.
       *
       * `auto` can be passed as the mode, in which case the user's geolocation will be used to
       * determine what to do.
       *
       * @param consentMode How to determine consent.
       */


      GTMClass.prototype.CookieConsentPreference = function (mode, force) {
        if (force === void 0) {
          force = false;
        }

        return __awaiter(this, void 0, void 0, function () {
          var cookiePreferences;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!(mode === 'auto')) return [3
                /*break*/
                , 2];
                return [4
                /*yield*/
                , fetchCookieConsentMode()];

              case 1:
                mode = _a.sent();
                _a.label = 2;

              case 2:
                cookiePreferences = getCookieConsentPreference(mode);
                if (!(force || !cookiePreferences && mode === 'consent-required')) return [3
                /*break*/
                , 4];
                return [4
                /*yield*/
                , renderCookieConsentBanner(mode, this.localeCode)];

              case 3:
                cookiePreferences = _a.sent();
                _a.label = 4;

              case 4:
                window.dataLayer.push({
                  event: 'gtm-js.cookie-consent.consentChanged'
                });
                return [2
                /*return*/
                , cookiePreferences];
            }
          });
        });
      };

      GTMClass.prototype.renderCookieConsent = function (_a) {
        var node = _a.node,
            onSave = _a.onSave,
            mode = _a.mode;
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                if (!(mode === 'auto')) return [3
                /*break*/
                , 2];
                return [4
                /*yield*/
                , fetchCookieConsentMode()];

              case 1:
                mode = _b.sent();
                _b.label = 2;

              case 2:
                return [2
                /*return*/
                , renderCookieConsent(node, onSave, mode)];
            }
          });
        });
      };

      GTMClass.prototype.incrementMetric = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return Metrics.increment.apply(Metrics, args);
      };

      GTMClass.prototype.incrementMetricWithOutput = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return Metrics.incrementWithOutput.apply(Metrics, args);
      };

      GTMClass.prototype.recordTimingMetric = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return Metrics.recordTiming.apply(Metrics, args);
      };
      /**
       * Record events specified in the query string. This is used when we need to
       * record an event as we are navigating away from a previous page. To
       * ensure the request is not cancelled, we record it on the subsequent page
       * load.
       */


      GTMClass.prototype.recordOnPageviewEvent = function (window) {
        var urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('on_pageview_event')) {
          return this.recordEvent(urlParams.get('on_pageview_event') || '');
        }
      };

      GTMClass.prototype.getCookieConsentMode = function () {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , fetchCookieConsentMode()];

              case 1:
                return [2
                /*return*/
                , _a.sent()];
            }
          });
        });
      };

      GTMClass.prototype.getGeoLocation = function () {
        return __awaiter(this, void 0, void 0, function () {
          var geoLocation;

          var _this = this;

          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , localStorageCache('geo_location', function () {
                  return __awaiter(_this, void 0, void 0, function () {
                    var response, geoLocationData;
                    return __generator(this, function (_a) {
                      switch (_a.label) {
                        case 0:
                          return [4
                          /*yield*/
                          , intercom.get('/geo_location')];

                        case 1:
                          response = _a.sent();
                          geoLocationData = response.error ? {} : response.data;
                          return [2
                          /*return*/
                          , JSON.stringify(geoLocationData)];
                      }
                    });
                  });
                })];

              case 1:
                geoLocation = _a.sent();

                try {
                  return [2
                  /*return*/
                  , JSON.parse(geoLocation)];
                } catch (error) {
                  return [2
                  /*return*/
                  , {}];
                }

                return [2
                /*return*/
                ];
            }
          });
        });
      };

      return GTMClass;
    }();

    return GTMClass;

}));
